export const QUESTIONS_ALL = [
    {
        "notes": [
            "'lề đường' -> không dành cho phương tiện giao thông đi lại",
            "'Phần đường xe cơ giới' -> phương tiện giao thông bao gồm cả xe thô sơ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 1",
        "no": 1,
        "content": "Phần của đường bộ được sử dụng cho phương tiện giao thông đường bộ đi lại là gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phần mặt đường và lề đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phần đường xe chạy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phần đường xe cơ giới."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'có đủ chiều rộng cho xe chạy an toàn'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 2",
        "no": 2,
        "content": "Làn đường là gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là một phần của phần đường xe chạy được chia theo chiều dọc của đường, sử dụng cho xe chạy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là một phần của phần đường xe chạy được chia theo chiều dọc của đường, có đủ chiều rộng cho xe chạy an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là đường cho xe ô tô chạy, dừng, đỗ an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'chiều rộng, chiều cao' -> giới hạn phải tính cả 2 chiều",
            "'cả hàng hoá xếp trên xe'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 3",
        "no": 3,
        "content": "Khổ giới hạn của đường bộ được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Khổ giới hạn của đường bộ là khoảng trống có kích thước giới hạn về chiều rộng, chiều cao của đường bộ để các xe, bao gồm cả hàng hoá xếp trên xe đi qua được an toàn và được xác định theo quy chuẩn, tiêu chuẩn kỹ thuật của đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là khoảng trống có kích thước giới hạn về chiều rộng của đường, cầu, bến phà, hầm trên đường bộ để các xe kể cả hàng hóa xếp trên xe đi qua được an toàn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là khoảng trống có kích thước giới hạn về chiều cao của cầu, bến phà, hầm trên đường bộ để các xe đi qua được an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Dải phân cách dùng phân cách 2 chiều hoặc phân thành các làn độc lập của 1 chiều"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 4",
        "no": 4,
        "content": "Dải phân cách được lắp đặt để làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để phân chia các làn đường dành cho xe cơ giới và xe thô sơ trên đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để phân chia phần đường xe chạy thành hai chiều riêng biệt hoặc để phân chia phần đường dành cho xe cơ giới và xe thô sơ hoặc của nhiều loại xe khác nhau trên cùng một chiều đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để phân tách phần đường xe chạy và hành lang an toàn giao thông."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'cảnh báo nguy hiểm' -> cần có bảng cảnh báo",
            "'báo hiệu' -> cần có bảng báo hiệu"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 5",
        "no": 5,
        "content": "Vạch kẻ đường là gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là báo hiệu đường bộ để hỗ trợ cảnh báo nguy hiểm cho người tham gia giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là vạch chỉ sự phân chia làn đường, vị trí hoặc hướng đi, vị trí dừng lại."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là báo hiệu cho người tham gia giao thông đường bộ về các thông tin của đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Người điều khiển phương tiện tham gia giao thông' KHÁC 'Người điều khiển giao thông'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 6",
        "no": 6,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là người điều khiển xe cơ giới, người điều khiển xe thô sơ, người điều khiển xe máy chuyên dùng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là người được giao nhiệm vụ hướng dẫn giao thông trên đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 7",
        "no": 7,
        "content": "Người lái xe được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là người điều khiển xe cơ giới."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là người điều khiển xe thô sơ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là người điều khiển xe máy chuyên dùng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 8",
        "no": 8,
        "content": "Trong nhóm các phương tiện giao thông đường bộ dưới đây, nhóm phương tiện nào là xe cơ giới?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô; máy kéo; xe mô tô hai bánh; xe mô tô ba bánh; xe gắn máy; xe cơ giới dùng cho người khuyết tật và xe máy chuyên dùng; xe đạp, xe đạp máy, xe đạp điện."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô; rơ moóc được kéo bởi xe ô tô; sơ mi rơ moóc được kéo bởi ô tô đầu kéo; xe chở người bốn bánh có gắn động cơ; xe chở hàng bốn bánh có gắn động cơ; xe mô tô, xe gắn máy và các loại xe tương tự."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 9",
        "no": 9,
        "content": "Trong nhóm các phương tiện giao thông đường bộ dưới đây, nhóm phương tiện nào là xe thô sơ?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Xe đạp, xe đạp máy, xe đạp điện; xe xích lô; xe lăn dùng cho người khuyết tật; xe vật nuôi kéo và các loại xe tương tự."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe đạp (kể cả xe đạp máy, xe đạp điện), xe gắn máy, xe cơ giới dùng cho người khuyết tật và xe máy chuyên dùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô, máy kéo, rơ moóc hoặc sơ mi rơ moóc được kéo bởi xe ô tô, máy kéo."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 10",
        "no": 10,
        "content": "Phương tiện giao thông đường bộ gồm những loại nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phương tiện giao thông cơ giới đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phương tiện giao thông thô sơ đường bộ, xe máy chuyên dùng và các loại xe tương tự."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 11",
        "no": 11,
        "content": "Người tham gia giao thông đường bộ gồm những đối tượng nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người điều khiển, người được chở trên phương tiện tham gia giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người điều khiển, dẫn dắt vật nuôi trên đường bộ; người đi bộ trên đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 12",
        "no": 12,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ gồm những đối tượng nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người điều khiển xe cơ giới, người điều khiển xe thô sơ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người điều khiển xe máy chuyên dùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Người điều khiển phương tiện tham gia giao thông' KHÁC 'Người điều khiển giao thông'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 13",
        "no": 13,
        "content": "Người điều khiển giao thông đường bộ được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là người điều khiển phương tiện tham gia giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là Cảnh sát giao thông và người được giao nhiệm vụ hướng dẫn giao thông trên đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là người tham gia giao thông đường bộ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đứng yên tạm thời của xe trong một khoảng thời gian'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 14",
        "no": 14,
        "content": "Dừng xe được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là trạng thái đứng yên của xe không giới hạn thời gian để cho người lên, xuống xe, xếp dỡ hàng hóa hoặc thực hiện công việc khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là trạng thái đứng yên tạm thời của xe trong một khoảng thời gian cần thiết đủ để cho người lên xe, xuống xe, xếp dỡ hàng hóa, kiểm tra kỹ thuật xe hoặc hoạt động khác. Khi dừng xe không được tắt máy và không được rời khỏi vị trí lái, trừ trường hợp rời khỏi vị trí lái để đóng, mở cửa xe, xếp dỡ hàng hóa, kiểm tra kỹ thuật xe nhưng phải sử dụng phanh đỗ xe hoặc thực hiện biện pháp an toàn khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là trạng thái đứng yên của xe không giới hạn thời gian giữa 02 lần vận chuyển hàng hóa hoặc hành khách."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đứng yên của xe không giới hạn thời gian'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 15",
        "no": 15,
        "content": "Đỗ xe được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là trạng thái đứng yên của xe có giới hạn thời gian trong một khoảng thời gian cần thiết đủ để cho người lên, xuống xe đó, xếp dỡ hàng hóa hoặc thực hiện công việc khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là trạng thái đứng yên của xe không giới hạn thời gian. Khi đỗ xe, người điều khiển phương tiện tham gia giao thông đường bộ chỉ được rời khỏi xe khi đã sử dụng phanh đỗ xe hoặc thực hiện biện pháp an toàn khác. Xe đỗ trên đoạn đường dốc phải đánh lái về phía lề đường, chèn bánh."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Không liên quan đến thủ đô"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 16",
        "no": 16,
        "content": "Đường cao tốc được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là một cấp kỹ thuật của đường bộ, chỉ dành cho một số loại xe cơ giới, xe máy chuyên dùng tham gia giao thông theo quy định của pháp luật. Có dải phân cách phân chia hai chiều xe chạy riêng biệt, không giao nhau cùng mức với một hoặc các đường khác, chỉ cho xe ra, vào ở những điểm nhất định. Có hàng rào bảo vệ, trang thiết bị phục vụ, bảo đảm giao thông liên tục, an toàn, rút ngắn thời gian hành trình."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là đường nối liền Thủ đô Hà Nội với trung tâm hành chính cấp tỉnh; đường nối liền các trung tâm hành chính cấp tỉnh; đường có vị trí quan trọng đối với sự phát triển kinh tế- xã hội, bảo đảm quốc phòng, an ninh của vùng, khu vực."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'va chạm hoặc xe ô tô giảm tốc độ đột ngột'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 17",
        "no": 17,
        "content": "Thiết bị an toàn cho trẻ em được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là thiết bị có đủ khả năng bảo đảm an toàn cho trẻ em ở tư thế ngồi hoặc nằm trên xe ô tô, được thiết kế để giảm nguy cơ chấn thương cho người dùng trong trường hợp xảy ra va chạm hoặc xe ô tô giảm tốc độ đột ngột, bằng cách hạn chế sự di chuyển của cơ thể trẻ em."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là thiết bị có đủ khả năng bảo đảm an toàn cho trẻ em ở tư thế đứng hoặc nằm trên xe ô tô, được thiết kế để giảm nguy cơ chấn thương cho người dùng trong trường hợp xe ô tô lưu thông bình thường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đường bên' -> có",
            "'đường nội bộ' -> có"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 18",
        "no": 18,
        "content": "Theo chức năng phục vụ thì đường bộ được phân loại như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đường chính, đường nhánh, đường gom, đường bên, đường dành cho giao thông công cộng, đường nội bộ, đường dành riêng cho người đi bộ, người đi xe đạp và các đường khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đường chính, đường nhánh, đường gom, đường dành cho giao thông công cộng, đường nội bộ, đường dành riêng cho người đi bộ, người đi xe đạp và các đường khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đường chính, đường nhánh, đường gom, đường bên, đường dành cho giao thông công cộng, đường dành riêng cho người đi bộ, người đi xe đạp và các đường khác."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe đạp được đi trên quốc lộ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 19",
        "no": 19,
        "content": "Hành vi nào dưới đây bị nghiêm cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Sử dụng xe đạp đi trên các tuyến quốc lộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rải vật sắc nhọn, đổ chất gây trơn trượt trên đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 20",
        "no": 20,
        "content": "Hành vi đưa xe cơ giới, xe máy chuyên dùng tham gia giao thông đường bộ nào dưới đây bị cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Không có chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hết niên hạn sử dụng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Phải được cấp phép"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 21",
        "no": 21,
        "content": "Tổ chức đua xe được phép thực hiện khi nào?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Trên đường phố không có người qua lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được người dân ủng hộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được cơ quan có thẩm quyền cấp phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'hình sự'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 22",
        "no": 22,
        "content": "Hành vi đua xe trái phép bị xử lý như thế nào?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Chỉ bị nhắc nhở."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tùy theo mức độ của hành vi vi phạm có thể bị xử lý hành chính hoặc xử lý hình sự."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Có ma túy là phạt cả tiền và GPLX"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 23",
        "no": 23,
        "content": "Hành vi của người điều khiển xe ô tô và các loại xe tương tự khi tham gia giao thông đường bộ mà trong cơ thể có chất ma túy thì bị áp dụng hình thức xử phạt vi phạm hành chính nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Bị phạt tiền."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bị tước giấy phép lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Ở VN, có nồng độ cồn là cấm"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 24",
        "no": 24,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ mà trong máu hoặc hơi thở có nồng độ cồn có bị nghiêm cấm không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Bị nghiêm cấm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không bị nghiêm cấm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không bị nghiêm cấm, nếu nồng độ cồn trong máu ở mức nhẹ, có thể điều khiển phương tiện tham gia giao thông."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "cồn -> Phạt tiền là đương nhiên, tùy mức độ có thể tước GPLX"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 25",
        "no": 25,
        "content": "Hành vi của người điều khiển xe ô tô và các loại xe tương tự khi tham gia giao thông đường bộ mà trong máu hoặc hơi thở có nồng độ cồn thì bị áp dụng hình thức xử phạt vi phạm hành chính nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Bị phạt tiền."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có thể bị tước giấy phép lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Người ko điều khiển phương tiện có thể có nồng độ cồn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 26",
        "no": 26,
        "content": "Theo Luật Phòng chống tác hại của rượu, bia, đối tượng nào dưới đây bị cấm sử dụng rượu, bia khi tham gia giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Người điều khiển xe ô tô, xe mô tô, xe đạp, xe gắn máy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Người được chở trên xe cơ giới."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Giao xe thì Phải cho người có GPLX hợp lệ tại thời điểm đó"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 27",
        "no": 27,
        "content": "Hành vi giao xe ô tô, mô tô cho người nào sau đây tham gia giao thông đường bộ bị nghiêm cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Người chưa đủ tuổi theo quy định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người không có giấy phép lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người có giấy phép lái xe nhưng đã bị trừ hết 12 điểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 28",
        "no": 28,
        "content": "Hành vi nào sau đây bị nghiêm cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Điều khiển xe cơ giới lạng lách, đánh võng, rú ga liên tục khi tham gia giao thông trên đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xúc phạm, đe dọa, cản trở, chống đối hoặc không chấp hành hiệu lệnh, hướng dẫn, yêu cầu kiểm tra, kiểm soát của người thi hành công vụ về bảo đảm trật tự, an toàn giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 29",
        "no": 29,
        "content": "Các hành vi nào sau đây bị cấm đối với phương tiện tham gia giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cải tạo xe ô tô loại khác thành xe ô tô chở người phục vụ mục đích quốc phòng, an ninh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cải tạo trái phép; cố ý can thiệp làm sai lệch chỉ số trên đồng hồ báo quãng đường đã chạy của xe ô tô; cắt, hàn, tẩy xóa, đục sửa, đóng lại trái phép số khung, số động cơ của xe cơ giới, xe máy chuyên dùng."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 30",
        "no": 30,
        "content": "Hành vi nào sau đây bị cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Lắp đặt, sử dụng thiết bị âm thanh, ánh sáng trên xe cơ giới, xe máy chuyên dùng gây mất trật tự, an toàn giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cản trở người, phương tiện tham gia giao thông trên đường bộ; ném gạch, đất, đá, cát hoặc vật thể khác vào người, phương tiện đang tham gia giao thông trên đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'trái phép' -> Bị nghiêm cấm",
            "Chỉ có nhà nước được sản xuất, mua bán biển số"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 31",
        "no": 31,
        "content": "Việc sản xuất, sử dụng, mua, bán trái phép biển số xe có bị nghiêm cấm hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không bị nghiêm cấm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bị nghiêm cấm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bị nghiêm cấm tuỳ trường hợp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Lạng lách, đánh võng, rú ga liên tục.'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 32",
        "no": 32,
        "content": "Khi điều khiển phương tiện tham gia giao thông, những hành vi nào dưới đây bị nghiêm cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Thay đổi tốc độ của xe nhiều lần."
                ],
                "answer": false
            },
            {
                "option": [
                    "Điều khiển phương tiện sau 23 giờ trong ngày."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lạng lách, đánh võng, rú ga liên tục."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 33",
        "no": 33,
        "content": "Có bao nhiêu nhóm biển báo hiệu đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ba nhóm: Biển báo cấm, biển báo nguy hiểm và biển hiệu lệnh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bốn nhóm: Biển báo cấm, biển báo nguy hiểm, biển hiệu lệnh và biển phụ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Năm nhóm: Biển báo cấm, biển báo nguy hiểm, biển hiệu lệnh, biển chỉ dẫn, biển phụ."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'bảo đảm an toàn'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 34",
        "no": 34,
        "content": "Tại nơi có vạch kẻ đường hoặc tại nơi mà người đi bộ, xe lăn của người khuyết tật đang qua đường, người điều khiển phương tiện tham gia giao thông phải thực hiện như thế nào?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giảm tốc độ và nhường đường cho người đi bộ, xe lăn của người khuyết tật qua đường đảm bảo an toàn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát, giảm tốc độ hoặc dừng lại để bảo đảm an toàn cho người đi bộ, xe lăn của người khuyết tật qua đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát, tăng tốc độ và điều khiển phương tiện nhanh chóng đi qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Lúc nào cũng phải quan sát"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 35",
        "no": 35,
        "content": "Người điều khiển xe mô tô phải phải quan sát, giảm tốc độ hoặc dừng lại để bảo đảm an toàn trong các trường hợp nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Đường hẹp, đường vòng, đường quanh co, đường đèo, dốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi cầu, cống hẹp, đập tràn, đường ngầm, hầm chui, hầm đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trời mưa, gió, sương, khói, bụi, mặt đường trơn trượt, lầy lội, có nhiều đất đá, vật liệu rơi vãi ảnh hưởng đến an toàn giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "các hướng theo cánh tay chỉ được đi tất cả các hướng, ngược lại phải dừng lại",
            "https://www.toyota.com.vn/tin-tuc/thong-tin-bo-tro/hieu-lenh-cua-nguoi-dieu-khien-giao-thong-39153"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/036.PNG", "/resources/images/600bca/036.PNG"],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 36",
        "no": 36,
        "content": "Khi gặp hiệu lệnh điều khiển của Cảnh sát giao thông như hình dưới đây thì người tham gia giao thông đường bộ phải đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở các hướng phải dừng lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở các hướng được đi theo chiều gậy chỉ của Cảnh sát giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở phía trước và phía sau người điều khiển được đi tất cả các hướng; người tham gia giao thông đường bộ ở phía bên phải và phía bên trái người điều khiển phải dừng lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở phía trước và phía sau người điều khiển phải dừng lại; người tham gia giao thông đường bộ ở phía bên phải và phía bên trái người điều khiển được đi tất cả các hướng."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "https://www.toyota.com.vn/tin-tuc/thong-tin-bo-tro/hieu-lenh-cua-nguoi-dieu-khien-giao-thong-39153"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/037.PNG", "/resources/images/600bca/037.PNG"],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 37",
        "no": 37,
        "content": "Khi gặp hiệu lệnh điều khiển của Cảnh sát giao thông như hình dưới đây thì người tham gia giao thông đường bộ phải đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở phía sau Cảnh sát giao thông được đi, các hướng khác phải dừng lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ được rẽ phải theo chiều mũi tên màu xanh ở bục Cảnh sát giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở tất cả các hướng phải dừng lại, trừ các xe đã ở trong khu vực giao nhau."
                ],
                "answer": true
            },
            {
                "option": [
                    "Người tham gia giao thông đường bộ ở phía trước Cảnh sát giao thông phải dừng lại, các hướng khác được đi."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Hiệu lệnh của người điều khiển giao thông;",
            "- Hiệu lệnh của đèn tín hiệu;",
            "- Hiệu lệnh của biển báo hiệu;",
            "- Hiệu lệnh của vạch kẻ đường và các dấu hiệu khác trên mặt đường."
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 38",
        "no": 38,
        "content": "Khi hiệu lệnh của người điều khiển giao thông trái với tín hiệu đèn giao thông hoặc biển báo hiệu đường bộ thì người tham gia giao thông đường bộ phải chấp hành báo hiệu đường bộ nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Theo hiệu lệnh của người điều khiển giao thông."
                ],
                "answer": true
            },
            {
                "option": [
                    "Theo tín hiệu đèn giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Theo biển báo hiệu đường bộ."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 39",
        "no": 39,
        "content": "Khi ở một vị trí vừa có biển báo hiệu đặt cố định vừa có biển báo hiệu tạm thời mà hai biển có ý nghĩa khác nhau, người tham gia giao thông đường bộ phải chấp hành hiệu lệnh của biển báo hiệu nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển báo hiệu đặt cố định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển báo hiệu tạm thời."
                ],
                "answer": true
            },
            {
                "option": [
                    "Theo quyết định của người tham gia giao thông nhưng phải bảo đảm an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'tín hiệu màu vàng' -> khác với màu vàng nhấp nháy --> phải dừng lại như đèn đỏ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 40",
        "no": 40,
        "content": "Tại nơi đường giao nhau, khi đèn điều khiển giao thông có tín hiệu màu vàng, người điều khiển phương tiện tham gia giao thông phải chấp hành như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng lại trước vạch dừng; trường hợp đang đi trên vạch dừng hoặc đã đi qua vạch dừng mà tín hiệu đèn màu vàng thì được đi tiếp; trường hợp tín hiệu đèn màu vàng nhấp nháy, người điều khiển phương tiện tham gia giao thông đường bộ được đi nhưng phải quan sát, giảm tốc độ hoặc dừng lại nhường đường cho người đi bộ, xe lăn của người khuyết tật qua đường hoặc các phương tiện khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ nhanh chóng vượt qua nút giao."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát, giảm tốc độ, từ từ vượt qua nút giao."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Không vượt quá tốc độ tối đa cho phép'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 41",
        "no": 41,
        "content": "Người lái xe trên đường cần chấp hành quy định về tốc độ tối đa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ lớn hơn tốc độ tối đa cho phép khi đường vắng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ lớn hơn tốc độ tối đa cho phép khi vào ban đêm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không vượt quá tốc độ tối đa cho phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Không được cho trẻ em ngồi cùng hàng ghế với người lái xe'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 42",
        "no": 42,
        "content": "Khi chở trẻ em dưới 10 tuổi và chiều cao dưới 1,35 mét trên xe ô tô, người lái xe phải thực hiện quy tắc nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được cho trẻ em ngồi cùng hàng ghế với người lái xe, trừ loại xe ô tô chỉ có một hàng ghế; người lái xe phải sử dụng, hướng dẫn sử dụng thiết bị an toàn phù hợp cho trẻ em."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cho trẻ em ngồi cùng hàng ghế với người lái xe, người lái xe phải sử dụng, hướng dẫn sử dụng thiết bị an toàn phù hợp cho trẻ em."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đi chậm thì đi về phía bên phải"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 43",
        "no": 43,
        "content": "Phương tiện tham gia giao thông đường bộ di chuyển với tốc độ thấp hơn phải đi như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi về bên trái theo chiều đi của mình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi về bên phải theo chiều đi của mình."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi ở bất cứ bên nào nhưng phải bấm đèn cảnh báo nguy hiểm để báo hiệu cho các phương tiện khác."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'người lái xe cơ giới, xe máy chuyên dùng' -> xe đặc biệt --> đi làn trái"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 44",
        "no": 44,
        "content": "Trên một chiều đường có vạch kẻ phân làn đường, người lái xe cơ giới, xe máy chuyên dùng phải điều khiển xe đi trên làn đường nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi trên làn đường bên phải trong cùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi trên làn đường bên trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi ở bất cứ làn nào nhưng phải bảo đảm tốc độ cho phép."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Phải tạo điều kiện cho xe xin vượt đủ điền kiện an toàn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 45",
        "no": 45,
        "content": "Người lái xe phải giảm tốc độ, có tín hiệu rẽ phải và đi sát về bên phải của phần đường xe chạy trong các trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Khi xe chạy phía trước có tín hiệu vượt xe khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi phía trước có xe chạy ngược chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi xe sau xin vượt nếu đủ điều kiện an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Khi xe sau có tín hiệu vượt bên phải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'mỗi chiều đường xe chạy chỉ có một làn đường'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 46",
        "no": 46,
        "content": "Vượt xe là gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là tình huống giao thông trên đường mà mỗi chiều đường xe chạy chỉ có một làn đường dành cho xe cơ giới, xe đi phía sau di chuyển sang bên trái để di chuyển lên trước xe phía trước."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là tình huống giao thông trên đường có từ hai làn đường dành cho xe cơ giới cùng chiều trở lên được phân biệt bằng vạch kẻ đường, xe đi phía sau di chuyển lên trước xe phía trước theo quy tắc sử dụng làn đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'cầu hẹp có một làn đường, đường cong có tầm nhìn bị hạn chế '"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 47",
        "no": 47,
        "content": "Người lái xe được phép vượt xe trên cầu hẹp có một làn đường, đường cong có tầm nhìn bị hạn chế hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Được phép vượt khi đường vắng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép vượt."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được phép vượt khi có việc gấp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Bấm còi liên tục' -> ko được",
            "'Rú ga liên tục' -> ko được"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 48",
        "no": 48,
        "content": "Muốn vượt xe phía trước, người lái xe mô tô phải có tín hiệu như thế nào dưới đây để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Bấm còi liên tục để xe phía trước biết xe mình xin vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rú ga liên tục để xe phía trước biết xe mình xin vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu nhấp nháy bằng đèn chiếu sáng phía trước hoặc còi."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Cấm còi từ 22h đến 5h sáng"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 49",
        "no": 49,
        "content": "Khi lái xe trong khu đông dân cư, khu vực cơ sở khám bệnh, chữa bệnh trừ các khu vực có biển cấm sử dụng còi, người lái xe được sử dụng còi trong thời gian nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Từ 22 giờ ngày hôm trước đến 05 giờ ngày hôm sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Từ 05 giờ đến 22 giờ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Từ 23 giờ ngày hôm trước đến 05 giờ sáng hôm sau."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm còi từ 22h đến 5h sáng"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 50",
        "no": 50,
        "content": "Phương tiện tham gia giao thông đường bộ chỉ được sử dụng tín hiệu còi trong các trường hợp nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để báo hiệu cho người tham gia giao thông đường bộ khi xuất hiện tình huống có thể mất an toàn giao thông hoặc báo hiệu chuẩn bị vượt xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để báo hiệu cho người tham gia giao thông đường bộ từ 22 giờ ngày hôm trước đến 05 giờ ngày hôm sau trong khu đông dân cư, khu vực cơ sở khám bệnh, chữa bệnh, trừ xe ưu tiên."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Trong khu dân cư, ko được dùng đèn pha"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 51",
        "no": 51,
        "content": "Người lái xe sử dụng đèn như thế nào khi đi trên các đoạn đường qua khu đông dân cư có hệ thống chiếu sáng đang hoạt động?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ bật đèn chiếu xa (đèn pha)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bật đèn chiếu xa (đèn pha) khi đường vắng, bật đèn chiếu gần (đèn cốt) khi có xe đi ngược chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ bật đèn chiếu gần (đèn cốt)."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Dùng tay cầm và sử dụng'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 52",
        "no": 52,
        "content": "Khi điều khiển phương tiện tham gia giao thông, hành vi nào sau đây bị cấm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Dùng tay cầm và sử dụng điện thoại hoặc thiết bị điện tử khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ được chở người trên thùng xe ô tô chở hàng trong trường hợp chở người đi làm nhiệm vụ cứu nạn, cứu hộ, phòng, chống thiên tai, dịch bệnh hoặc thực hiện nhiệm vụ khẩn cấp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Trên cầu vẫn được vượt nếu có 2 làn xe và nét đứt"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 53",
        "no": 53,
        "content": "Người lái xe không được vượt xe khác khi gặp trường hợp nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Trên cầu hẹp có một làn đường; nơi đường giao nhau, đường bộ giao nhau cùng mức với đường sắt; khi gặp xe ưu tiên."
                ],
                "answer": true
            },
            {
                "option": [
                    "Trên cầu có từ 02 làn xe trở lên."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trên đường có 02 làn đường được phân chia làn bằng vạch kẻ nét đứt."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 54",
        "no": 54,
        "content": "Nơi nào cấm quay đầu xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ở phần đường dành cho người đi bộ qua đường, trên cầu, đầu cầu, gầm cầu vượt, ngầm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tại nơi đường bộ giao nhau cùng mức với đường sắt, đường hẹp, đường dốc, đoạn đường cong tầm nhìn bị che khuất, trên đường cao tốc, trong hầm đường bộ, trên đường một chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'phần đường dành cho người đi bộ qua đường' -> cấm quay đầu đè lên vạch"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 55",
        "no": 55,
        "content": "Người lái xe không được quay đầu xe trong các trường hợp nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Ở phần đường dành cho người đi bộ qua đường, trên cầu, đầu cầu, trên đường cao tốc, tại nơi đường bộ giao nhau cùng mức với đường sắt, đường hẹp, đường dốc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ở phía trước hoặc phía sau của phần đường dành cho người đi bộ qua đường, trên đường quốc lộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 56",
        "no": 56,
        "content": "Trước khi cho xe chuyển hướng, người lái xe phải làm gì để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải quan sát, bảo đảm khoảng cách an toàn với xe phía sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ và có tín hiệu báo hướng rẽ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chuyển dần sang làn gần nhất với hướng rẽ. Khi bảo đảm an toàn, không gây trở ngại cho người và phương tiện khác mới được chuyển hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Trước khi thay đổi'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 57",
        "no": 57,
        "content": "Khi chuyển làn đường, người lái xe phải bật đèn tín hiệu báo rẽ như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Khi bắt đầu chuyển làn đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trước khi thay đổi làn đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Sau khi thay đổi làn đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 58",
        "no": 58,
        "content": "Người lái xe không được lùi xe ở những khu vực nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Ở đường một chiều, khu vực cấm dừng, trên phần đường dành cho người đi bộ qua đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi đường bộ giao nhau, đường bộ giao nhau cùng mức với đường sắt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi tầm nhìn bị che khuất, trong hầm đường bộ, trên đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 59",
        "no": 59,
        "content": "Người điều khiển phương tiện tham gia giao thông không được dừng xe, đỗ xe ở những vị trí nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Trên miệng cống thoát nước, miệng hầm của đường điện thoại, điện cao thế, chỗ dành riêng cho xe chữa cháy lấy nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trong phạm vi an toàn của đường sắt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "25cm"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 60",
        "no": 60,
        "content": "Trên đường phố, người điều khiển phương tiện tham gia giao thông đường bộ được dừng xe, đỗ xe sát theo lề đường, vỉa hè phía bên phải theo chiều đi của mình; bánh xe gần nhất không được cách xa lề đường, vỉa hè không quá bao nhiêu mét trong các trường hợp dưới đây và không gây cản trở, nguy hiểm cho người và phương tiện tham gia giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "0,25 mét."
                ],
                "answer": true
            },
            {
                "option": [
                    "0,3 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "0,4 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "0,5 mét."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "20m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 61",
        "no": 61,
        "content": "Khi dừng, đỗ xe trên đường phố hẹp, người lái xe ô tô phải dừng, đỗ xe ở vị trí cách xe ô tô đang đỗ ngược chiều khoảng cách tối thiểu là bao nhiêu mét trong các trường hợp dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "10 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "15 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "20 mét."
                ],
                "answer": true
            },
            {
                "option": [
                    "25 mét."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Nơi có lề đường rộng' -> được phép dừng đỗ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 62",
        "no": 62,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ không được dừng xe, đỗ xe tại các vị trí nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nơi có lề đường rộng hoặc khu đất ở bên ngoài phần đường xe chạy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Song song cùng chiều với một xe khác đang dừng, đỗ trên đường; trên đoạn đường cong hoặc gần đầu dốc mà tầm nhìn bị che khuất; bên trái đường một chiều."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 63",
        "no": 63,
        "content": "Người điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy có được phép sử dụng xe để kéo hoặc đẩy các phương tiện khác khi tham gia giao thông không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu phương tiện được kéo, đẩy có khối lượng nhỏ hơn phương tiện của mình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tùy trường hợp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Buông cả hai tay'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 64",
        "no": 64,
        "content": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào sau đây không được phép?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Buông cả hai tay; đứng, nằm trên xe điều khiển xe; sử dụng chân chống hoặc vật khác quệt xuống đường khi xe đang chạy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chở tối đa hai người phía sau khi chở người bệnh đi cấp cứu, áp giải người có hành vi vi phạm pháp luật, trẻ em dưới 12 tuổi và người già yếu hoặc người khuyết tật."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Buông cả hai tay'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 65",
        "no": 65,
        "content": "Khi điều khiển xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy, những hành vi nào sau đây không được phép?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Buông cả hai tay; sử dụng xe để kéo, đẩy xe khác, vật khác; sử dụng chân chống hoặc vật khác quệt xuống đường khi xe đang chạy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Sử dụng xe để chở người hoặc hàng hóa; để chân chạm xuống đất khi khởi hành."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đội mũ bảo hiểm; chạy xe đúng tốc độ quy định và chấp hành đúng quy tắc giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chở người ngồi sau dưới 16 tuổi."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Người ngồi sau được sử dụng điện thoại"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 1,
        "tittle": "Câu 66",
        "no": 66,
        "content": "Người được chở trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông đường bộ không được thực hiện hành vi nào sau đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "1. Mang, vác vật cồng kềnh."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Bám, kéo hoặc đẩy các phương tiện khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Dùng tay cầm điện thoại hoặc các thiết bị điện tử khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "' bám, kéo hoặc đẩy các phương tiện khác' -> không được phép"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 67",
        "no": 67,
        "content": "Người được chở trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông đường bộ có được bám, kéo hoặc đẩy các phương tiện khác không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được bám trong trường hợp phương tiện của mình bị hỏng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được kéo, đẩy trong trường hợp phương tiện khác bị hỏng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Cả 2 phải đổi nón bảo hiểm và cài quai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 68",
        "no": 68,
        "content": "Người lái xe, người được chở trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy phải thực hiện quy định nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Đội mũ bảo hiểm theo đúng quy chuẩn kỹ thuật quốc gia và cài quai đúng quy cách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Người lái xe phải đội mũ bảo hiểm, người được chở trên xe không nhất thiết phải đội mũ bảo hiểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải đội mũ bảo hiểm nhưng không nhất thiết phải cài quai."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ được kẹp người đi cấp cứu, áp giải, ..."
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 69",
        "no": 69,
        "content": "Người lái xe mô tô hai bánh, xe gắn máy được phép chở tối đa hai người trong những trường hợp nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chở người bệnh đi cấp cứu; áp giải người có hành vi vi phạm pháp luật; trẻ em dưới 12 tuổi; người già yếu hoặc người khuyết tật."
                ],
                "answer": true
            },
            {
                "option": [
                    "Người đã uống rượu, bia; người trong cơ thể có chất ma tuý."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 70",
        "no": 70,
        "content": "Người lái xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy không được thực hiện các hành vi nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi xe dàn hàng ngang; buông cả hai tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sử dụng xe để kéo, đẩy xe khác, vật khác, dẫn dắt vật nuôi, mang, vác và chở vật cồng kềnh; chở người đứng trên xe, giá đèo hàng hoặc ngồi trên tay lái; xếp hàng hóa trên xe quá giới hạn quy định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ngồi về một bên điều khiển xe; đứng, nằm trên xe điều khiển xe; thay người lái xe khi xe đang chạy; quay người về phía sau để điều khiển xe hoặc bịt mắt điều khiển xe; sử dụng chân chống hoặc vật khác quệt xuống đường khi xe đang chạy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 71",
        "no": 71,
        "content": "Người lái xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy không được thực hiện các hành vi nào sau đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Đi xe dàn hàng ngang; đi xe vào phần đường dành cho người đi bộ và phương tiện khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sử dụng ô, thiết bị âm thanh, trừ thiết bị trợ thính."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'dàn hàng ngang' -> ko được"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 72",
        "no": 72,
        "content": "Người lái xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy không được thực hiện hành vi nào sau đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Đi trên phần đường, làn đường quy định, chấp hành hiệu lệnh của người điều khiển giao thông, đèn tín hiệu giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi xe dàn hàng ngang, đi xe vào phần đường dành cho người đi bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không được sử dụng ô"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 73",
        "no": 73,
        "content": "Người được chở trên xe mô tô hai bánh, xe mô tô ba bánh, xe gắn máy khi tham gia giao thông đường bộ có được sử dụng ô khi trời mưa hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Được sử dụng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ người ngồi sau được sử dụng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được sử dụng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được sử dụng nếu không có áo mưa."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Người được chở trên xe mô tô KHÔNG được kéo, bám gì hết"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 74",
        "no": 74,
        "content": "Người được chở trên xe mô tô có được kéo theo người đang điều khiển xe đạp hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Chỉ được phép nếu cả hai đội mũ bảo hiểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ được thực hiện trên đường vắng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xử phạt cả người lái và người ngồi sau; tương tự như ô tô ko thắt dây an toàn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 75",
        "no": 75,
        "content": "Trường hợp người được chở trên xe mô tô, xe gắn máy, các loại xe tương tự xe mô tô và các loại xe tương tự xe gắn máy không đội \"mũ bảo hiểm cho người đi mô tô, xe máy\" hoặc không cài quai đúng quy cách (trừ trường hợp chở người bệnh đi cấp cứu, trẻ em dưới 06 tuổi, áp giải người có hành vi vi phạm pháp luật) thì việc xử phạt vi phạm hành chính được quy định như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không bị xử phạt chỉ bị nhắc nhở."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người được chở không bị xử phạt, chỉ xử phạt người điều khiển xe mô tô, xe gắn máy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Người được chở bị xử phạt, không xử phạt người điều khiển xe mô tô, xe gắn máy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xử phạt cả người điều khiển và người được chở trên xe mô tô, xe gắn máy."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "luôn đội mũ bảo hiểm"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 76",
        "no": 76,
        "content": "Trong các trường hợp dưới đây, để bảo đảm an toàn khi tham gia giao thông, người lái xe mô tô cần thực hiện như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải đội mũ bảo hiểm theo đúng quy chuẩn kỹ thuật quốc gia và cài quai đúng quy cách, không sử dụng ô, điện thoại di động, thiết bị âm thanh (trừ thiết bị trợ thính)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải đội mũ bảo hiểm khi trời mưa gió hoặc trời quá nắng; có thể sử dụng ô, điện thoại di động, thiết bị âm thanh nhưng phải bảo đảm an toàn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải đội mũ bảo hiểm khi cảm thấy mất an toàn giao thông hoặc khi chuẩn bị di chuyển quãng đường xa."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe thô sơ, người đi bộ xuống sau"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 77",
        "no": 77,
        "content": "Thứ tự xuống phà như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe thô sơ, người đi bộ xuống trước, xe cơ giới, xe máy chuyên dùng xuống sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe cơ giới, xe máy chuyên dùng xuống trước, xe thô sơ, người đi bộ xuống sau."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe cơ giới, xe thô sơ xuống trước, xe máy chuyên dùng, người đi bộ xuống sau."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 78",
        "no": 78,
        "content": "Trên đường có nhiều làn đường cho xe đi cùng chiều được phân biệt bằng vạch kẻ phân làn đường, người điều khiển phương tiện tham gia giao thông đường bộ phải cho xe đi như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cho xe đi trên bất kỳ làn đường nào hoặc giữa 02 làn đường nếu không có xe đi phía trước; khi cần thiết phải chuyển làn đường, người lái xe phải quan sát xe phía trước để bảo đảm an toàn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải cho xe đi trong một làn đường và chỉ được chuyển làn đường ở những nơi cho phép; mỗi lần chuyển làn đường chỉ được phép chuyển sang một làn đường liền kề; khi chuyển làn đường phải có tín hiệu báo trước; phải quan sát bảo đảm khoảng cách an toàn với xe phía trước, phía sau và hai bên mới được chuyển làn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải cho xe đi trong một làn đường, chỉ được chuyển làn đường khi vượt xe phía trước cùng làn đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe thô sơ phải cùng; xe máy chuyên dụng trái cùng"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 79",
        "no": 79,
        "content": "Trên đường một chiều có vạch kẻ phân làn đường, xe thô sơ và xe cơ giới phải đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe thô sơ phải đi trên làn đường bên trái, xe cơ giới, xe máy chuyên dùng đi trên làn đường bên phải trong cùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe thô sơ phải đi trên làn đường bên phải trong cùng, xe cơ giới, xe máy chuyên dùng đi trên làn đường bên trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe thô sơ phải đi trên làn đường bên phải trong cùng, xe cơ giới, xe máy chuyên dùng được đi trên tất cả các làn đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm còi trong khu đô thi từ 22h-5h"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 80",
        "no": 80,
        "content": "Khi lái xe trong đô thị và khu đông dân cư trong thời gian từ 22 giờ ngày hôm trước đến 05 giờ ngày hôm sau, nếu cần vượt một xe khác, người lái xe phải báo hiệu như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ được báo hiệu bằng còi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải báo hiệu bằng cả còi và đèn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ được báo hiệu bằng đèn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "phải nhường khi đủ điền kiện an toàn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 81",
        "no": 81,
        "content": "Khi điều khiển xe chạy trên đường, biết có xe sau xin vượt, nếu đủ điều kiện an toàn người điều khiển phương tiện phải làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ và ra hiệu cho xe sau vượt, không được gây trở ngại cho xe xin vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, có tín hiệu rẽ phải để báo hiệu cho người điều khiển phương tiện tham gia giao thông đường bộ phía sau biết được vượt và đi sát về bên phải của phần đường xe chạy cho đến khi xe sau đã vượt qua, không được cản trở đối với xe xin vượt."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cho xe đi sát về bên trái của phần đường xe chạy và ra hiệu cho xe sau vượt, không được gây trở ngại cho xe xin vượt."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "báo hiệu bằng xi nhan trái khi ko đủ an toàn cho vượt"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 82",
        "no": 82,
        "content": "Khi điều khiển xe chạy trên đường, biết có xe sau xin vượt, nếu không đủ điều kiện an toàn người điều khiển phương tiện phải làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có tín hiệu rẽ trái để báo hiệu cho người điều khiển phương tiện tham gia giao thông đường bộ phía sau biết là chưa được vượt."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tiếp tục đi cho đến khi đủ điều kiện an toàn, nếu xe sau vẫn xin vượt thì báo hiệu cho xe sau vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ để báo hiệu cho xe xin vượt biết là chưa được vượt."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Nhanh chóng chuyển hướng' -> không được"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 83",
        "no": 83,
        "content": "Khi chuyển hướng, người lái xe, người điều khiển xe máy chuyên dùng phải làm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải nhường đường cho người đi bộ, xe thô sơ, xe đi ngược chiều và chỉ chuyển hướng khi không gây trở ngại hoặc nguy hiểm cho người, phương tiện khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhanh chóng chuyển hướng để không gây trở ngại hoặc nguy hiểm cho người, phương tiện khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ra tín hiệu chuyển hướng để yêu cầu các phương tiện khác dừng lại cho xe chuyển hướng di chuyển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'nhanh chóng chuyển hướng' -> sai",
            "'tăng tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 84",
        "no": 84,
        "content": "Trước khi chuyển hướng, người điều khiển phương tiện tham gia giao thông đường bộ phải thực hiện như thế nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát gương, nếu không có phương tiện gần hướng rẽ thì nhanh chóng chuyển hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát, bảo đảm khoảng cách an toàn với xe phía sau, giảm tốc độ và có tín hiệu báo hướng rẽ hoặc có tín hiệu bằng tay theo hướng rẽ đối với xe thô sơ không có đèn báo hướng rẽ, chuyển dần sang làn gần nhất với hướng rẽ. Tín hiệu báo hướng rẽ hoặc tín hiệu bằng tay phải sử dụng liên tục trong quá trình chuyển hướng. Khi bảo đảm an toàn, không gây trở ngại cho người và phương tiện khác mới được chuyển hướng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát gương, tăng tốc độ, ra tín hiệu và chuyển hướng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Quan sát cả 2 bên và phía sau và từ từ lùi khi an toàn",
            "'nhanh chóng lùi' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 85",
        "no": 85,
        "content": "Khi lùi xe, người điều khiển phương tiện tham gia giao thông đường bộ phải làm gì để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát phía sau và cho lùi xe ở tốc độ chậm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có tín hiệu báo lùi, nếu phía sau không có người hoặc phương tiện khác thì nhanh chóng lùi để bảo đảm an toàn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải quan sát hai bên và phía sau xe, có tín hiệu lùi và chỉ lùi xe khi bảo đảm an toàn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'tầm nhìn bị che khuất' -> ko được lùi"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 86",
        "no": 86,
        "content": "Khi muốn lùi xe ở nơi có tầm nhìn bị che khuất, người lái xe phải xử lý như thế nào để đảm bảo an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Phải lùi thật chậm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bấm còi 3 lần liên tiếp trước khi lùi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được lùi xe."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Giảm tốc độ'",
            "'đi về bên phải'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 87",
        "no": 87,
        "content": "Trên đường không phân chia thành hai chiều xe chạy riêng biệt, người điều khiển phương tiện tham gia giao thông đường bộ phải tránh xe đi ngược chiều như thế nào để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giảm tốc độ và cho xe đi về bên phải theo chiều xe chạy của mình."
                ],
                "answer": true
            },
            {
                "option": [
                    "Một trong hai xe phải dừng lại cho xe kia đi qua mới được đi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ, cho xe đi về bên phải theo chiều xe chạy của mình để nhanh chóng vượt qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "ưu tiên cho xe lên dốc",
            "gần chỗ tránh hơn thì tránh trước",
            "chiều không bị hẹp được ưu tiên hơn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 88",
        "no": 88,
        "content": "Khi tránh xe đi ngược chiều, các xe phải nhường đường như thế nào là đúng quy tắc giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Nơi đường hẹp chỉ đủ cho một xe chạy và có chỗ tránh xe thì xe nào ở gần chỗ tránh hơn phải vào vị trí tránh, nhường đường cho xe đi ngược chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe xuống dốc phải nhường đường cho xe lên dốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe có chướng ngại vật phía trước phải nhường đường cho xe không có chướng ngại vật phía trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "ưu tiên cho xe lên dốc"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 89",
        "no": 89,
        "content": "Khi đang lái xe xuống dốc gặp một xe đang đi lên dốc, người lái xe phải làm gì?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Tiếp tục đi và phát tín hiệu cho xe lên dốc nhường đường cho xe bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe lên dốc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ nhường đường khi xe lên dốc nháy đèn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đường cong' -> ko được vượt, ko lấn làn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 90",
        "no": 90,
        "content": "Người lái xe phải làm gì để bảo đảm an toàn khi lái xe trên đường cong có tầm nhìn bị hạn chế?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát, giảm tốc độ hoặc dừng lại để bảo đảm an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi sang làn đường của xe ngược chiều để mở rộng tầm nhìn và vượt xe khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cho xe đi sát bên phải làn đường, bật tín hiệu báo hiệu để vượt bên phải xe khác."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "từ đường ko ưu tiên phải nhường cho xe ở đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 91",
        "no": 91,
        "content": "Tại nơi đường giao nhau, người lái xe đang đi trên đường không ưu tiên, đường nhánh phải nhường đường như thế nào là đúng quy tắc giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Nhường đường cho xe đi ở bên phải mình tới."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe đi ở bên trái mình tới."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe đi trên đường ưu tiên hoặc đường chính từ bất kỳ hướng nào tới."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "đã vào vòng xuyến -> nhường trái",
            "ko có vòng xuyến -> nhường phải"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 92",
        "no": 92,
        "content": "Tại nơi đường giao nhau có báo hiệu đi theo vòng xuyến, người lái xe phải nhường đường như thế nào là đúng quy tắc giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Nhường đường cho xe đi đến từ bên phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe đi đến từ bên trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không phải nhường đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đã vào vòng xuyến -> nhường trái",
            "ko có vòng xuyến -> nhường phải"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 93",
        "no": 93,
        "content": "Tại nơi đường giao nhau không có báo hiệu đi theo vòng xuyến, người điều khiển phương tiện phải nhường đường như thế nào là đúng quy tắc giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Phải nhường đường cho xe đi đến từ bên phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe báo hiệu xin đường trước, xe đó được đi trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải nhường đường cho xe đi đến từ bên trái."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'không có tín hiệu ưu tiên' -> ko phải nhường",
            "'có báo tín hiệu xin vượt bằng còi và đèn' -> ko phải nhường"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 94",
        "no": 94,
        "content": "Người lái xe phải nhanh chóng giảm tốc độ, đi sát lề đường bên phải hoặc dừng lại để nhường đường cho các loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe chữa cháy của Cảnh sát phòng cháy, chữa cháy và cứu nạn, cứu hộ và xe chữa cháy của các lực lượng khác; xe của lực lượng quân sự, công an và kiểm sát; đoàn xe có xe Cảnh sát giao thông dẫn đường; xe cứu thương; xe hộ đê không có tín hiệu ưu tiên theo quy định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ưu tiên gồm xe chữa cháy của Cảnh sát phòng cháy, chữa cháy và cứu nạn, cứu hộ và xe chữa cháy của các lực lượng khác được huy động đi làm nhiệm vụ chữa cháy; xe của lực lượng quân sự, công an và kiểm sát đi làm nhiệm vụ khẩn cấp; đoàn xe có xe Cảnh sát giao thông dẫn đường; xe cứu thương đi làm nhiệm vụ cấp cứu; xe hộ đê đi làm nhiệm vụ; xe đi làm nhiệm vụ cứu nạn, cứu hộ, khắc phục sự cố thiên tai, dịch bệnh hoặc xe đi làm nhiệm vụ trong tình trạng khẩn cấp theo quy định của pháp luật; đoàn xe tang."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe ô tô, xe máy, đoàn xe đang diễu hành có tổ chức có báo tín hiệu xin vượt bằng còi và đèn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đã ưu tiên (trừ xe tang) thì được đi tất"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 95",
        "no": 95,
        "content": "Xe ưu tiên (trừ đoàn xe tang) tham gia giao thông đường bộ khi đi làm nhiệm vụ được quyền ưu tiên nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không bị hạn chế tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép đi không phụ thuộc vào tín hiệu đèn giao thông, đi vào đường ngược chiều, các đường khác có thể đi được."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được đi ngược chiều trên làn dừng xe khẩn cấp trên đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Tăng tốc độ' -> sai",
            "'sát lề đường bên trái' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 96",
        "no": 96,
        "content": "Khi có tín hiệu của xe ưu tiên, người và phương tiện tham gia giao thông đường bộ phải tuân thủ quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, đi sát lề đường bên phải hoặc dừng lại để nhường đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ và đi sát lề đường bên phải để nhường đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, đi sát lề đường bên trái để nhường đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không được vượt xe đang có tín hiệu ưu tiên",
            "'không phát tín hiệu ưu tiên' --> được vượt khi an toàn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 97",
        "no": 97,
        "content": "Khi đang lái xe, phía trước có một xe Cảnh sát giao thông không phát tín hiệu ưu tiên, người lái xe có được phép vượt hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Không được vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép vượt ở phần đường dành cho người đi bộ qua đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được vượt khi bảo đảm an toàn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Không được vượt xe đang có tín hiệu ưu tiên"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 98",
        "no": 98,
        "content": "Khi đang lái xe, phía trước có một xe cứu thương đang phát tín hiệu ưu tiên, người lái xe có được phép vượt hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Không được vượt."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được vượt khi đang đi trên cầu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép vượt khi đi qua nơi giao nhau có ít phương tiện cùng tham gia giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được vượt khi bảo đảm an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'nhanh chóng đi qua' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 99",
        "no": 99,
        "content": "Khi tới đường ngang không có người gác, chắn đường bộ, chuông, đèn tín hiệu, người tham gia giao thông đường bộ phải làm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng lại về bên phải đường của mình, trước vạch dừng xe và quan sát hai phía, khi không có phương tiện giao thông đường sắt tới mới được đi qua."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát hai phía, khi không có phương tiện giao thông đường sắt tới thì nhanh chóng đi qua."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại khoảng cách tối thiểu 3 mét tính từ ray đường sắt gần nhất, khi không có phương tiện giao thông đường sắt tới thì nhanh chóng đi qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "dừng bên phải"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 100",
        "no": 100,
        "content": "Tại đường ngang, cầu chung đường sắt, khi có hiệu lệnh của nhân viên gác chắn, đèn đỏ sáng nhấp nháy, chuông kêu, chắn đường bộ đang dịch chuyển hoặc đã đóng, người tham gia giao thông đường bộ phải làm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng lại về bên trái đường của mình, trước vạch dừng xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại giữa đường của mình, trước vạch dừng xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại về bên phải đường của mình, trước vạch dừng xe."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'phải ngay lập tức báo hiệu để dừng tàu'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 101",
        "no": 101,
        "content": "Khi xe ô tô bị hư hỏng, bị tai nạn trên đường ngang, cầu chung đường sắt mà không thể di chuyển ngay khỏi phạm vi an toàn đường sắt, người lái xe và người có mặt xử lý như thế nào là đúng quy định?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người lái xe và người có mặt phải ngay lập tức báo hiệu để dừng tàu, thực hiện các biện pháp bảo đảm an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để xe lại, tìm cách báo cho người quản lý đường sắt, nhà ga nơi gần nhất."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không di chuyển phương tiện, tự khắc phục sửa chữa."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 102",
        "no": 102,
        "content": "Người tham gia giao thông đường bộ phải dừng lại về bên phải đường của mình trước vạch dừng xe tại đường ngang, cầu chung đường sắt khi có báo hiệu nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Hiệu lệnh của nhân viên gác chắn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đèn đỏ sáng nhấp nháy, chuông kêu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chắn đường bộ đang dịch chuyển hoặc đã đóng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'khi cần thiết' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 103",
        "no": 103,
        "content": "Người điều khiển phương tiện tham gia giao thông trong hầm đường bộ ngoài việc phải tuân thủ các quy tắc giao thông còn phải thực hiện những quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe cơ giới, xe máy chuyên dùng phải bật đèn chiếu gần; xe thô sơ phải bật đèn hoặc có vật phát sáng báo hiệu; không dừng xe, đỗ xe trong hầm đường bộ; trường hợp gặp sự cố kỹ thuật hoặc bất khả kháng khác buộc phải dừng xe, đỗ xe, người lái xe, người điều khiển xe máy chuyên dùng phải đưa xe vào vị trí dừng xe, đỗ xe khẩn cấp, nếu không di chuyển được, phải có báo hiệu bằng đèn khẩn cấp và đặt biển hoặc đèn cảnh báo về phía sau xe khoảng cách bảo đảm an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe cơ giới, xe máy chuyên dùng phải bật đèn chiếu xa; được dừng xe, đỗ xe khi cần thiết."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải cho xe chạy trên một làn đường và chỉ chuyển làn ở nơi được phép; được quay đầu xe, lùi xe khi cần thiết."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "không được dùng dây"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 104",
        "no": 104,
        "content": "Việc nối giữa xe kéo với xe được kéo trong trường hợp hệ thống hãm của xe được kéo không còn hiệu lực thì xe kéo nhau phải nối bằng cách nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nối bằng dây cáp có độ dài 6 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nối bằng dây cáp có độ dài 8 mét."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nối bằng thanh nối cứng."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 105",
        "no": 105,
        "content": "Xe kéo rơ moóc, xe ô tô đầu kéo khi tham gia giao thông đường bộ phải tuân thủ quy tắc giao thông nào ghi ở dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ được kéo rơ moóc, sơ mi rơ moóc phù hợp với thiết kế của xe; việc kết nối xe kéo với rơ moóc, xe ô tô đầu kéo với sơ mi rơ moóc phải bảo đảm chắc chắn, an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải có tổng trọng lượng tương đương tổng trọng lượng của rơ moóc hoặc phải có hệ thống hãm có hiệu lực cho rơ moóc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải được lắp phanh phụ theo quy định để đảm bảo an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'kéo theo nhiều xe' -> ko được phép"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 106",
        "no": 106,
        "content": "Luật Trật tự, an toàn giao thông đường bộ quy định về xe kéo xe, xe kéo rơ moóc và xe ô tô đầu kéo kéo sơ mi rơ moóc như thế nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Một xe ô tô được kéo theo nhiều xe ô tô hoặc xe máy chuyên dùng khác khi xe được kéo không tự chạy được (trừ trường hợp xe vận chuyển hàng siêu trường, siêu trọng)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe được kéo phải có người điều khiển và hệ thống lái của xe đó phải còn hiệu lực; việc nối xe kéo với xe được kéo phải bảo đảm chắc chắn, an toàn; trường hợp hệ thống hãm của xe được kéo không còn hiệu lực thì xe kéo nhau phải nối bằng thanh nối cứng. Phía trước của xe kéo và phía sau của xe được kéo phải có biển báo hiệu, có đèn cảnh báo nhấp nháy màu vàng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 107",
        "no": 107,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ phải quan sát, giảm tốc độ hoặc dừng lại để bảo đảm an toàn trong các trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có báo hiệu cảnh báo nguy hiểm hoặc có chướng ngại vật trên đường; chuyển hướng xe chạy hoặc tầm nhìn bị hạn chế."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi cầu, cống hẹp, đập tràn, đường ngầm, hầm chui, hầm đường bộ; có vật nuôi đi trên đường hoặc chăn thả ở ven đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Điểm dừng xe, đỗ xe trên đường bộ có khách đang lên, xuống xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Không được vượt chung với xe khác đang vượt"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 108",
        "no": 108,
        "content": "Trên đường mà mỗi chiều đường xe chạy chỉ có một làn đường dành cho xe cơ giới, người lái xe không được vượt xe khác trong trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có chướng ngại vật phía trước, xe chạy phía trước có tín hiệu vượt xe khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe chạy phía trước đã có tín hiệu rẽ phải và tránh về bên phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'có tín hiệu rẽ trái'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 109",
        "no": 109,
        "content": "Người lái xe được phép vượt xe khác về bên phải trong trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe phía trước có tín hiệu rẽ trái hoặc đang rẽ trái hoặc khi xe chuyên dùng đang làm việc trên đường mà không thể vượt bên trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe phía trước đang đi sát lề đường bên trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'lề đường bên trái' -> sai",
            "'Tăng tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 110",
        "no": 110,
        "content": "Khi có xe xin vượt, người lái xe mô tô xử lý như thế nào nếu đủ điều kiện an toàn cho xe phía sau vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, có tín hiệu rẽ phải để báo hiệu cho người điều khiển phương tiện tham gia giao thông đường bộ phía sau biết được vượt và đi sát về bên phải của phần đường xe chạy cho đến khi xe sau đã vượt qua, không được cản trở đối với xe xin vượt."
                ],
                "answer": true
            },
            {
                "option": [
                    "Lái xe vào lề đường bên trái và giảm tốc độ để xe phía sau vượt qua, không được gây trở ngại đối với xe xin vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ, đi sát về bên phải của phần đường xe chạy cho đến khi xe sau đã vượt qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 111",
        "no": 111,
        "content": "Những trường hợp nào dưới đây không được đi trên đường cao tốc, trừ người, phương tiện giao thông đường bộ và thiết bị phục vụ việc quản lý, bảo trì đường cao tốc?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe máy chuyên dùng có tốc độ thiết kế nhỏ hơn tốc độ tối thiểu quy định đối với đường cao tốc, xe chở người bốn bánh có gắn động cơ, xe chở hàng bốn bánh có gắn động cơ, xe mô tô, xe gắn máy, các loại xe tương tự xe mô tô, xe gắn máy, xe thô sơ, người đi bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe máy chuyên dùng có tốc độ thiết kế lớn hơn tốc độ tối thiểu quy định đối với đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô và xe máy chuyên dùng có tốc độ thiết kế lớn hơn 80 km/h."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Trên cao tốc, xe ưu tiên chỉ được đi ngược chiều trên làn dừng xe khẩn cấp"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 112",
        "no": 112,
        "content": "Khi tham gia giao thông trên đường cao tốc, xe ưu tiên đi làm nhiệm vụ khẩn cấp được đi ngược chiều trong trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được đi ngược chiều bất cứ làn đường nào của đường cao tốc có thể đi được."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ được đi ngược chiều trên làn dừng xe khẩn cấp."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ được đi ngược chiều trên làn đường sát dải phân cách của đường cao tốc."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 113",
        "no": 113,
        "content": "Khi tham gia giao thông trên đường cao tốc, người lái xe không được thực hiện hành vi nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng, đỗ xe trên phần đường xe chạy, trừ trường hợp xe không thể di chuyển được vào làn đường khẩn cấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lùi xe, quay đầu xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 114",
        "no": 114,
        "content": "Khi xe gặp sự cố kỹ thuật trên đường cao tốc, bạn phải xử lý như thế nào để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bật đèn tín hiệu khẩn cấp, dừng xe ngay lập tức và đặt biển báo hiệu nguy hiểm để cảnh báo cho các xe khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bật tín hiệu khẩn cấp, lập tức đưa xe vào làn đường xe chạy bên phải trong cùng, đặt biển báo hiệu nguy hiểm để cảnh báo cho các xe khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng xe, đỗ xe ở làn dừng khẩn cấp cùng chiều xe chạy và phải có báo hiệu bằng đèn khẩn cấp; trường hợp xe không thể di chuyển được vào làn dừng khẩn cấp, phải có báo hiệu bằng đèn khẩn cấp và đặt biển hoặc đèn cảnh báo về phía sau xe khoảng cách tối thiểu 150 mét, nhanh chóng báo cho cơ quan Cảnh sát giao thông thực hiện nhiệm vụ bảo đảm trật tự, an toàn giao thông trên tuyến hoặc cơ quan quản lý đường cao tốc."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 115",
        "no": 115,
        "content": "Trên đường cao tốc, người lái xe xử lý như thế nào khi đã vượt quá lối ra của đường định rẽ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quay đầu xe, chạy trên lề đường có lối ra và rẽ khỏi đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lùi xe trên lề đường có lối ra và rẽ khỏi đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tiếp tục lái xe và rẽ ở lối ra tiếp theo."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 116",
        "no": 116,
        "content": "Khi xảy ra ùn tắc trên đường cao tốc có làn dừng xe khẩn cấp, người lái xe có được cho xe chạy ở làn dừng xe khẩn cấp để nhanh chóng thoát khỏi khu vực ùn tắc không (trừ xe ưu tiên)?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 117",
        "no": 117,
        "content": "Khi chuẩn bị nhập vào làn đường của đường cao tốc, người lái xe, người điều khiển xe máy chuyên dùng phải thực hiện như thế nào là đúng quy tắc giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Có tín hiệu xin vào và phải nhường đường cho xe đang chạy trên đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát xe phía sau bảo đảm khoảng cách an toàn mới cho xe nhập vào làn đường sát bên phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu có làn đường tăng tốc thì phải cho xe chạy trên làn đường đó trước khi nhập vào làn đường của đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            ">= 18: A1, A, B1, B, C1",
            ">= 21: C, BE",
            ">= 24: D1, D2, C1E, CE",
            ">= 27: D, D1E, D2E, DE"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 118",
        "no": 118,
        "content": "Theo quy định về độ tuổi, người đủ bao nhiêu tuổi trở lên thì được cấp giấy phép lái xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế trên 3.500 kg đến 7.500 kg; các loại xe ô tô tải quy định cho giấy phép lái xe hạng C1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "18 tuổi."
                ],
                "answer": true
            },
            {
                "option": [
                    "17 tuổi."
                ],
                "answer": false
            },
            {
                "option": [
                    "16 tuổi."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            ">= 18: A1, A, B1, B, C1",
            ">= 21: C, BE",
            ">= 24: D1, D2, C1E, CE",
            ">= 27: D, D1E, D2E, DE"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 119",
        "no": 119,
        "content": "Theo quy định về độ tuổi, người đủ bao nhiêu tuổi trở lên thì được cấp giấy phép lái xe mô tô hai bánh có dung tích xi lanh đến 125 cm3 và xe ô tô chở người đến 8 chỗ (không kể chỗ của người lái xe); xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế đến 3.500 kg?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "16 tuổi."
                ],
                "answer": false
            },
            {
                "option": [
                    "17 tuổi"
                ],
                "answer": false
            },
            {
                "option": [
                    "18 tuổi."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            ">= 18: A1, A, B1, B, C1",
            ">= 21: C, BE",
            ">= 24: D1, D2, C1E, CE",
            ">= 27: D, D1E, D2E, DE"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 120",
        "no": 120,
        "content": "Theo quy định về độ tuổi, người lái xe ô tô chở người (kể cả xe buýt) trên 29 chỗ (không kể chỗ của người lái xe); xe ô tô chở người giường nằm; các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg phải đủ bao nhiêu tuổi trở lên?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "23 tuổi."
                ],
                "answer": false
            },
            {
                "option": [
                    "24 tuổi."
                ],
                "answer": false
            },
            {
                "option": [
                    "27 tuổi."
                ],
                "answer": true
            },
            {
                "option": [
                    "30 tuổi."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 121",
        "no": 121,
        "content": "Tuổi tối đa của người lái xe ô tô chở người (kể cả xe buýt) trên 29 chỗ (không kể chỗ của người lái xe), xe ô tô chở người giường nằm là bao nhiêu tuổi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đủ 55 tuổi đối với nam và đủ 50 tuổi đối với nữ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đủ 55 tuổi đối với nam và nữ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đủ 57 tuổi đối với nam và đủ 55 tuổi đối với nữ."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            ">= 18: A1, A, B1, B, C1",
            ">= 21: C, BE",
            ">= 24: D1, D2, C1E, CE",
            ">= 27: D, D1E, D2E, DE"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 122",
        "no": 122,
        "content": "Theo quy định về độ tuổi, người lái xe ô tô chở người (kể cả xe buýt) trên 16 chỗ (không kể chỗ của người lái xe) đến 29 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D2 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg phải đủ bao nhiêu tuổi trở lên?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "23 tuổi."
                ],
                "answer": false
            },
            {
                "option": [
                    "24 tuổi."
                ],
                "answer": true
            },
            {
                "option": [
                    "22 tuổi."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe gắn máy là loại xe dưới 50cc"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 123",
        "no": 123,
        "content": "Người đủ 16 tuổi đến dưới 18 tuổi chỉ được điều khiển các loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô hai bánh có dung tích xi-lanh đến 125 cm3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe gắn máy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe ô tô chở người đến 08 chỗ (không kể chỗ của người lái xe); xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế đến 3.500 kg; các loại xe ô tô quy định cho giấy phép lái xe hạng B kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 124",
        "no": 124,
        "content": "Người có Giấy phép lái xe mô tô hạng A1 không được phép điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô hai bánh có dung tích xi-lanh 125 cm3 hoặc có công suất động cơ điện đến 11 kW."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô ba bánh."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 125",
        "no": 125,
        "content": "Người có Giấy phép lái xe mô tô hạng A1 được cấp sau ngày 01/01/2025 được phép điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô hai bánh có dung tích xi-lanh đến 125 cm3 hoặc có công suất động cơ điện đến 11 kW."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô ba bánh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 126",
        "no": 126,
        "content": "Người có Giấy phép lái xe mô tô hạng A được phép điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô hai bánh có dung tích xi-lanh đến 125 cm3 hoặc có công suất động cơ điện đến 11 kW."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô hai bánh có dung tích xi-lanh trên 125 cm3 hoặc có công suất động cơ điện trên 11 kW."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 127",
        "no": 127,
        "content": "Người có Giấy phép lái xe ô tô hạng B được phép điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 08 chỗ (không kể chỗ của người lái xe)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế đến 3.500 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 128",
        "no": 128,
        "content": "Người có Giấy phép lái xe hạng C1 được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế trên 7.500 kg; các loại xe ô tô tải quy định cho giấy phép lái xe hạng C1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế trên 3.500 kg đến 7.500 kg; các loại xe ô tô tải quy định cho giấy phép lái xe hạng C1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 129",
        "no": 129,
        "content": "Người có Giấy phép lái xe hạng C được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế trên 3.500 kg đến 7.500 kg; các loại xe ô tô tải quy định cho giấy phép lái xe hạng C1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô tải và ô tô chuyên dùng có khối lượng toàn bộ theo thiết kế trên 7.500 kg; các loại xe ô tô tải quy định cho giấy phép lái xe hạng C kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 130",
        "no": 130,
        "content": "Người có Giấy phép lái xe hạng D1 được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người (kể cả xe buýt) trên 16 chỗ (không kể chỗ của người lái xe) đến 29 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 08 chỗ (không kể chỗ của người lái xe) đến 16 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 131",
        "no": 131,
        "content": "Người có Giấy phép lái xe hạng D2 được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người (kể cả xe buýt) trên 16 chỗ (không kể chỗ của người lái xe) đến 29 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D2 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 08 chỗ (không kể chỗ của người lái xe) đến 16 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 1,
        "tittle": "Câu 132",
        "no": 132,
        "content": "Người có Giấy phép lái xe hạng D được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Xe ô tô chở người (kể cả xe buýt) trên 29 chỗ (không kể chỗ của người lái xe); xe ô tô chở người giường nằm; các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Xe ô tô chở người (kể cả xe buýt) trên 16 chỗ (không kể chỗ của người lái xe) đến 29 chỗ (không kể chỗ của người lái xe)."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Các loại xe ô tô quy định cho giấy phép lái xe hạng C kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg; xe ô tô đầu kéo kéo sơ mi rơ moóc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 133",
        "no": 133,
        "content": "Người có Giấy phép lái xe hạng BE được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người (kể cả xe buýt) trên 29 chỗ (không kể chỗ của người lái xe); xe ô tô chở người giường nằm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Các loại xe ô tô quy định cho giấy phép lái xe hạng B kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe ô tô chở người (kể cả xe buýt) trên 16 chỗ (không kể chỗ của người lái xe) đến 29 chỗ (không kể chỗ của người lái xe); các loại xe ô tô chở người quy định cho giấy phép lái xe hạng D2 kéo rơ moóc có khối lượng toàn bộ theo thiết kế đến 750 kg."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 134",
        "no": 134,
        "content": "Người có Giấy phép lái xe hạng CE được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Các loại xe ô tô quy định cho giấy phép lái xe hạng C kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg; xe ô tô đầu kéo kéo sơ mi rơ moóc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Các loại xe ô tô quy định cho giấy phép lái xe hạng D1 kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- A1: mô tô 2 bánh < 125cc hoặc < 11kW (không thời hạn)",
            "- A: all mô tô 2 bánh (không thời hạn)",
            "- B1: mô tô 3 bánh + A1 (không thời hạn)",
            "- B: ô tô <= 8 chỗ, tải < 3.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C1: tải < 7.5k tấn, kéo < 750kg theo quy định (10 năm)",
            "- C: tải > 7.5k tấn + C1 + B (5 năm)",
            "- D1: ô tô <= 16 chỗ, kéo < 750kg theo quy định + B + C1 + C (5 năm)",
            "- D2: ô tô <= 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 (5 năm)",
            "- D: ô tô > 29 chỗ (+buýt), kéo < 750kg theo quy định + B + C1 + C + D1 + D2 (5 năm)",
            "- BE: cấp cho người có B để kéo > 750kg (5 năm)",
            "- C1E: cấp cho người có C1 để kéo > 750kg (5 năm)",
            "- CE: cấp cho người có C để kéo > 750kg + sơ mi rơ moóc (5 năm)",
            "- D1E: cấp cho người có D1 để kéo > 750kg (5 năm)",
            "- D2E: cấp cho người có D2 để kéo > 750kg (5 năm)",
            "- DE: cấp cho người có D2 để kéo > 750kg + ô tô khách nối toa (5 năm)"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 135",
        "no": 135,
        "content": "Người có Giấy phép lái xe hạng DE được điều khiển loại xe nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Các loại xe ô tô quy định cho giấy phép lái xe hạng D kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg; xe ô tô chở khách nối toa."
                ],
                "answer": true
            },
            {
                "option": [
                    "Các loại xe ô tô quy định cho giấy phép lái xe hạng C kéo rơ moóc có khối lượng toàn bộ theo thiết kế trên 750 kg; xe ô tô đầu kéo kéo sơ mi rơ moóc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Phải mang theo giấy phép xe tập lái.' -> chuyện của giáo viên"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 136",
        "no": 136,
        "content": "Người tập lái xe ô tô khi tham gia giao thông đường bộ phải bảo đảm các điều kiện nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải thực hành trên xe tập lái, trên tuyến đường tập lái và có giáo viên dạy lái bảo trợ tay lái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải mang theo giấy phép xe tập lái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 137",
        "no": 137,
        "content": "Người lái xe khi tham gia giao thông đường bộ phải đảm bảo các điều kiện nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải đủ tuổi, sức khỏe theo quy định của pháp luật; có giấy phép lái xe đang còn điểm, còn hiệu lực phù hợp với loại xe đang điều khiển do cơ quan có thẩm quyền cấp (trừ người lái xe gắn máy)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải là người đứng tên trong đăng ký xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "GPLX + cà vẹt xe + BH bắt buộc"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 138",
        "no": 138,
        "content": "Khi tham gia giao thông đường bộ, người lái xe phải mang theo các giấy tờ gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chứng nhận đăng ký xe hoặc bản sao Chứng nhận đăng ký xe có chứng thực kèm bản gốc giấy tờ xác nhận của tổ chức tín dụng, chi nhánh ngân hàng nước ngoài còn hiệu lực trong trường hợp xe đang được thế chấp tại tổ chức tín dụng, chi nhánh ngân hàng nước ngoài."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giấy phép lái xe phù hợp với loại xe đang điều khiển; chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường đối với xe cơ giới theo quy định của pháp luật; chứng nhận bảo hiểm bắt buộc trách nhiệm dân sự của chủ xe cơ giới."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trường hợp các giấy tờ nêu trên đã được tích hợp vào tài khoản định danh điện tử thì việc xuất trình, kiểm tra có thể thực hiện thông qua tài khoản định danh điện tử."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Cứ có gì đó sai sai thì sẽ bị thu hồi"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 139",
        "no": 139,
        "content": "Giấy phép lái xe bị thu hồi trong các trường hợp nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người được cấp giấy phép lái xe không đủ điều kiện sức khỏe theo kết luận của cơ sở khám bệnh, chữa bệnh đối với từng hạng giấy phép lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giấy phép lái xe được cấp sai quy định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giấy phép lái xe đã quá thời hạn tạm giữ hoặc hết thời hiệu thi hành quyết định xử phạt vi phạm hành chính theo quy định của pháp luật về xử lý vi phạm hành chính nếu người vi phạm không đến nhận mà không có lý do chính đáng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'chưa bị trừ hết 12 điểm'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 140",
        "no": 140,
        "content": "Người có giấy phép lái xe chưa bị trừ hết 12 điểm, được phục hồi điểm giấy phép lái xe trong trường hợp nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được phục hồi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phục hồi đủ 12 điểm, nếu không bị trừ điểm trong thời hạn 12 tháng từ ngày bị trừ điểm gần nhất."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'đã bị trừ hết điểm' -> 6 tháng sau được thi lại lý thuyết"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 141",
        "no": 141,
        "content": "Người có giấy phép lái xe đã bị trừ hết điểm phải làm gì để phục hồi điểm giấy phép lái xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không vi phạm pháp luật trật tự, an toàn giao thông đường bộ trong thời gian 12 tháng kể từ ngày bị trừ hết điểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sau thời hạn ít nhất là 06 tháng kể từ ngày bị trừ hết điểm, người có phép lái xe được tham gia kiểm tra nội dung kiến thức pháp luật về trật tự, an toàn giao thông đường bộ theo quy định, có kết quả đạt yêu cầu thì được phục hồi đủ 12 điểm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 142",
        "no": 142,
        "content": "Trách nhiệm của tổ chức, cá nhân đứng tên trong giấy chứng nhận đăng ký xe khi chưa thực hiện thu hồi chứng nhận đăng ký xe, biển số xe được quy định như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tiếp tục chịu trách nhiệm của chủ xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không chịu trách nhiệm sau khi đã chuyển nhượng, trao đổi, tặng, cho."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe kinh doanh vận tải là bắt buộc lắp thiết bị giám sát hành trình"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 143",
        "no": 143,
        "content": "Để bảo đảm điều kiện tham gia giao thông đường bộ, loại phương tiện nào phải lắp thiết bị giám sát hành trình?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô kinh doanh vận tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người từ 08 chỗ trở lên (không kể chỗ của người lái xe) kinh doanh vận tải, xe ô tô đầu kéo, xe cứu thương."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 144",
        "no": 144,
        "content": "Tốc độ khai thác tối đa cho phép đối với xe máy chuyên dùng, xe gắn máy và các loại xe tương tự tham gia giao thông trên đường bộ (trừ đường cao tốc) là bao nhiêu km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "50 km/h."
                ],
                "answer": false
            },
            {
                "option": [
                    "40 km/h."
                ],
                "answer": true
            },
            {
                "option": [
                    "60 km/h."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 145",
        "no": 145,
        "content": "Trên đường bộ, trong khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn xe cơ giới trở lên, xe mô tô hai bánh, ô tô chở người đến 28 chỗ không kể chỗ của người lái xe tham gia giao thông với tốc độ khai thác tối đa cho phép là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "60 km/h."
                ],
                "answer": true
            },
            {
                "option": [
                    "50 km/h."
                ],
                "answer": false
            },
            {
                "option": [
                    "40 km/h."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 146",
        "no": 146,
        "content": "Trên đường bộ (trừ đường cao tốc) trong khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới, xe mô tô hai bánh, ô tô chở người đến 28 chỗ không kể chỗ của người lái xe tham gia giao thông với tốc độ khai thác tối đa cho phép là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "60 km/h."
                ],
                "answer": false
            },
            {
                "option": [
                    "50 km/h."
                ],
                "answer": true
            },
            {
                "option": [
                    "40 km/h."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 147",
        "no": 147,
        "content": "Trên đường bộ (trừ đường cao tốc) trong khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới, loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 50 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ô tô tải, ô tô chở người trên 28 chỗ không kể chỗ của người lái xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe gắn máy, xe máy chuyên dùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 148",
        "no": 148,
        "content": "Trên đường bộ (trừ đường cao tốc) trong khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn cơ giới trở lên, loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa là 60 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ô tô tải, ô tô chở người trên 28 chỗ không kể chỗ của người lái xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe gắn máy, xe máy chuyên dùng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 149",
        "no": 149,
        "content": "Trên đường bộ (trừ đường cao tốc) ngoài khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn xe cơ giới trở lên, loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 90 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 150",
        "no": 150,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn xe cơ giới trở lên (trừ đường cao tốc) loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 80 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 151",
        "no": 151,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn xe cơ giới trở lên (trừ đường cao tốc) loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 70 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 152",
        "no": 152,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường đôi hoặc đường một chiều có từ hai làn xe cơ giới trở lên (trừ đường cao tốc) loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 60 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 153",
        "no": 153,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới (trừ đường cao tốc), loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 80 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 154",
        "no": 154,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới (trừ đường cao tốc), loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 70 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 155",
        "no": 155,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới (trừ đường cao tốc), loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 60 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 156",
        "no": 156,
        "content": "Trên đường bộ ngoài khu vực đông dân cư, đường hai chiều hoặc đường một chiều có một làn xe cơ giới (trừ đường cao tốc), loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 50 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe ô tô chở người đến 28 chỗ không kể chỗ của người lái xe (trừ xe buýt); ô tô tải có trọng tải không lớn hơn 3,5 tấn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô chở người trên 28 chỗ không kể chỗ người lái xe (trừ xe buýt); ô tô tải có trọng tải trên 3,5 tấn (trừ ô tô xi téc)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe buýt; ô tô đầu kéo kéo sơ mi rơ moóc (trừ ô tô đầu kéo kéo sơ mi rơ moóc xi téc); xe mô tô; ô tô chuyên dùng (trừ ô tô trộn vữa, ô tô trộn bê tông lưu động)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ô tô kéo rơ moóc; ô tô kéo xe khác; ô tô trộn vữa, ô tô trộn bê tông lưu động, ô tô xi téc, ô tô đầu kéo kéo sơ mi rơ moóc xi téc, ô tô kéo theo rơ moóc xi téc."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 157",
        "no": 157,
        "content": "Khi tham gia giao thông trên đường bộ (trừ đường cao tốc), loại xe nào dưới đây được tham gia giao thông với tốc độ khai thác tối đa cho phép là 50 km/h?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe máy chuyên dùng, xe gắn máy và các loại xe tương tự."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe chở người bốn bánh có gắn động cơ khi tham gia giao thông trong phạm vi và thời gian cho phép hoạt động."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe chở hàng bốn bánh có gắn động cơ khi tham gia giao thông trong phạm vi và thời gian cho phép hoạt động."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- 60km/h: 35m",
            "- 60 - 80km/h: 55m",
            "- 80 - 100km/h: 70m",
            "- 100 - 120km/h: 100m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 158",
        "no": 158,
        "content": "Khi tham gia giao thông trên đoạn đường không có biển báo \"Cự ly tối thiểu giữa hai xe\", trong điều kiện mặt đường khô ráo, không có sương mù, mặt đường không trơn trượt, địa hình bằng phẳng, đường thẳng, tầm nhìn bảo đảm, xe cơ giới đang chạy với tốc độ từ trên 80 km/h đến 100 km/h, người lái xe phải giữ khoảng cách an toàn với xe đang chạy liền trước tối thiểu là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "35 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "55 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "70 m."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- 60km/h: 35m",
            "- 60 - 80km/h: 55m",
            "- 80 - 100km/h: 70m",
            "- 100 - 120km/h: 100m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 159",
        "no": 159,
        "content": "Khi tham gia giao thông trên đoạn đường không có biển báo \"cự ly tối thiểu giữa hai xe\", trong điều kiện mặt đường khô ráo, không có sương mù, mặt đường không trơn trượt, địa hình bằng phẳng, đường thẳng, tầm nhìn bảo đảm, xe cơ giới đang chạy với tốc độ từ trên 100 km/h đến 120 km/h, người lái xe phải giữ khoảng cách an toàn với xe đang chạy liền trước tối thiểu là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "55 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "70 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "100 m."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- 60km/h: 35m",
            "- 60 - 80km/h: 55m",
            "- 80 - 100km/h: 70m",
            "- 100 - 120km/h: 100m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 160",
        "no": 160,
        "content": "Khi tham gia giao thông trên đoạn đường không có biển báo \"cự ly tối thiểu giữa hai xe\", trong điều kiện mặt đường khô ráo, không có sương mù, mặt đường không trơn trượt, địa hình bằng phẳng, đường thẳng, tầm nhìn bảo đảm, xe cơ giới đang chạy với tốc độ từ trên 60 km/h đến 80 km/h, người lái xe phải giữ khoảng cách an toàn với xe đang chạy liền trước tối thiểu là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "55 m."
                ],
                "answer": true
            },
            {
                "option": [
                    "70 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "100 m."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- 60km/h: 35m",
            "- 60 - 80km/h: 55m",
            "- 80 - 100km/h: 70m",
            "- 100 - 120km/h: 100m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 161",
        "no": 161,
        "content": "Khi tham gia giao thông trên đoạn đường không có biển báo \"cự ly tối thiểu giữa hai xe\", trong điều kiện mặt đường khô ráo, không có sương mù, mặt đường không trơn trượt, địa hình bằng phẳng, đường thẳng, tầm nhìn bảo đảm, xe cơ giới đang chạy với tốc độ 60 km/h, người lái xe phải giữ khoảng cách an toàn với xe đang chạy liền trước tối thiểu là bao nhiêu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "35 m."
                ],
                "answer": true
            },
            {
                "option": [
                    "55 m."
                ],
                "answer": false
            },
            {
                "option": [
                    "70 m."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- 60km/h: 35m",
            "- 60 - 80km/h: 55m",
            "- 80 - 100km/h: 70m",
            "- 100 - 120km/h: 100m"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 162",
        "no": 162,
        "content": "Khi điều khiển xe chạy với tốc độ dưới 60 km/h, để bảo đảm khoảng cách an toàn giữa hai xe, người lái xe phải điều khiển xe như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chủ động giữ khoảng cách an toàn phù hợp với xe chạy liền trước xe của mình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bảo đảm khoảng cách an toàn tùy thuộc vào mật độ phương tiện, tình hình giao thông thực tế."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 163",
        "no": 163,
        "content": "Người lái xe phải giảm tốc độ thấp hơn tốc độ tối đa cho phép đến mức cần thiết, chú ý quan sát và chuẩn bị sẵn sàng những tình huống có thể xảy ra để phòng ngừa tai nạn trong các trường hợp nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Gặp biển báo nguy hiểm và cảnh báo trên đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Gặp biển chỉ dẫn trên đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Gặp biển báo hết mọi lệnh cấm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Gặp biển báo hết hạn chế tốc độ tối đa cho phép."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 164",
        "no": 164,
        "content": "Xe đưa đón trẻ em mầm non, học sinh được ưu tiên gì khi tham gia giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tổ chức phân luồng, điều tiết giao thông, bố trí nơi dừng xe, đỗ xe tại khu vực trường học và tại các điểm trên lộ trình đưa đón trẻ em mầm non, học sinh."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được bố trí xe dẫn đường để bảo đảm an toàn giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Chỗ nào cũng phải quan sát"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 165",
        "no": 165,
        "content": "Người điều khiển phương tiện tham gia giao thông đường bộ phải quan sát, giảm tốc độ hoặc dừng lại để bảo đảm an toàn trong các trường hợp nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Tại nơi có vạch kẻ đường hoặc báo hiệu khác dành cho người đi bộ hoặc tại nơi mà người đi bộ, xe lăn của người khuyết tật đang qua đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi đường bộ giao nhau cùng mức với đường bộ, đường bộ giao nhau cùng mức với đường sắt; đường hẹp, đường vòng, đường quanh co, đường đèo, dốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khu vực có trường học, bệnh viện, bến xe, công trình công cộng tập trung đông người, khu vực đông dân cư, chợ, khu vực đang thi công trên đường bộ, hiện trường vụ tai nạn giao thông đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- Xe ô tô con, ô tô ≤ 30 chỗ, xe tải ≤ 3,5 tấn: 90-80 / 60-50",
            "- Xe tải > 3,5 tấn; xe khách > 30 chỗ: 80-70 / 60-50",
            "- Sơ mi rơ moóc, Xe buýt, ô tô chuyên dùng: 70-60 / 60-50",
            "- Rơ moóc, trộn vữa, bê tông: 60-50 / 60-50",
            "- Xe mô tô: 70-60 / 60-50",
            "- Xe gắn máy, xe máy chuyên dùng: 40",
            "- Xe 4 bánh gắn động cơ: người-30 / hàng-50",
            "- Xe thô sơ: 25"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 166",
        "no": 166,
        "content": "Tại những đoạn đường không bố trí biển báo hạn chế tốc độ, không bố trí biển báo khoảng cách an toàn tối thiểu giữa hai xe, người lái xe phải thực hiện quy định nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép lái xe không hạn chế tốc độ và khoảng cách an toàn tối thiểu với xe phía trước cùng làn đường hoặc phần đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép lái xe không hạn chế tốc độ và khoảng cách an toàn tối thiểu với xe phía trước cùng làn đường hoặc phần đường khi tham gia giao thông trên đường nhánh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chấp hành quy định về tốc độ, khoảng cách an toàn tối thiểu với xe phía trước cùng làn đường hoặc phần đường."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'nhanh chóng vượt' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 167",
        "no": 167,
        "content": "Khi gặp xe buýt đang dừng đón, trả khách, người điều khiển xe mô tô phải xử lý như thế nào dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Tăng tốc độ để nhanh chóng vượt qua xe buýt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát, giảm tốc độ đi qua xe buýt hoặc dừng lại để bảo đảm an toàn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Đón, trả hành khách đúng nơi quy định;'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 168",
        "no": 168,
        "content": "Việc vận chuyển hành khách bằng xe ô tô phải tuân thủ các quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đón, trả hành khách đúng nơi quy định; hướng dẫn sử dụng trang thiết bị an toàn trên xe; có biện pháp giữ gìn vệ sinh trong xe; vận chuyển hành khách đúng lịch trình, lộ trình đã đăng ký, trừ trường hợp bất khả kháng; không chở hành khách trên nóc xe, trong khoang chở hành lý hoặc để hành khách đu, bám bên ngoài xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đón, trả hành khách theo yêu cầu của hành khách trên xe; hướng dẫn sử dụng trang thiết bị an toàn trên xe; có biện pháp giữ gìn vệ sinh trong xe; vận chuyển hành khách đúng lịch trình, lộ trình đã đăng ký, trừ trường hợp bất khả kháng; không chở hành khách trên nóc xe, trong khoang chở hành lý hoặc để hành khách đu, bám bên ngoài xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 169",
        "no": 169,
        "content": "Trong hoạt động vận tải đường bộ, các hành vi nào dưới đây bị nghiêm cấm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vận chuyển hàng hóa cấm lưu hành."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vận chuyển trái phép hoặc không thực hiện đầy đủ các quy định của pháp luật về vận chuyển hàng hóa nguy hiểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vận chuyển động vật hoang dã."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 170",
        "no": 170,
        "content": "Trong hoạt động vận tải hành khách, những hành vi nào dưới đây bị nghiêm cấm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cạnh tranh nhau nhằm tăng lợi nhuận."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm giá để thu hút khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đe dọa, xúc phạm, tranh giành, lôi kéo hành khách; đe doạ, cưỡng ép hành khách sử dụng dịch vụ ngoài ý muốn; chuyển tải, xuống khách hoặc các hành vi khác nhằm trốn tránh phát hiện xe chở quá tải, quá số người theo quy định của pháp luật."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không quá 4 giờ liên tục",
            "Không quá 10 giờ trong một ngày."
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 171",
        "no": 171,
        "content": "Thời gian lái xe liên tục của người lái xe ô tô kinh doanh vận tải được quy định như thế nào để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không quá 4 giờ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không quá 6 giờ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không quá 8 giờ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Liên tục tùy thuộc vào sức khỏe và khả năng của người lái xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không quá 4 giờ liên tục",
            "Không quá 10 giờ trong một ngày."
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 172",
        "no": 172,
        "content": "Thời gian làm việc của người lái xe ô tô kinh doanh vận tải trong một ngày được quy định như thế nào để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không quá 6 giờ trong một ngày."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không quá 8 giờ trong một ngày."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không quá 10 giờ trong một ngày."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không hạn chế tùy thuộc vào sức khỏe và khả năng của người lái xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 1,
        "tittle": "Câu 173",
        "no": 173,
        "content": "Trước khi xe khởi hành, người lái xe, nhân viên phục vụ trên xe ô tô vận chuyển hành khách có trách nhiệm nào sau đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Kiểm tra các điều kiện bảo đảm an toàn của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Hướng dẫn cho hành khách về an toàn giao thông đường bộ và thoát hiểm khi gặp sự cố."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Kiểm tra nhân thân và hành lý của hành khách đi xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 174",
        "no": 174,
        "content": "Xe ô tô kinh doanh vận tải chở trẻ em mầm non, học sinh phải đáp ứng các yêu cầu nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có thiết bị ghi nhận hình ảnh trẻ em mầm non, học sinh và thiết bị có chức năng cảnh báo, chống bỏ quên trẻ em trên xe; có niên hạn sử dụng không quá 20 năm; có màu sơn theo quy định của Chính phủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có dây đai an toàn phù hợp với lứa tuổi hoặc sử dụng xe có ghế ngồi phù hợp với lứa tuổi theo quy định của pháp luật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được cấp chứng nhận đăng kí xe và gắn biển số xe, bảo đảm an toàn kĩ thuật và bảo vệ môi trường theo quy định của pháp luật; xe ô tô chở người từ 08 chỗ trở lên (không kể chỗ của người lái xe) phải lắp thiết bị giám sát hành trình và thiết bị ghi nhận hình ảnh người lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 175",
        "no": 175,
        "content": "Việc vận chuyển động vật sống khi tham gia giao thông đường bộ phải thực hiện các yêu cầu nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người lái xe phải mang đủ giấy tờ theo quy định của pháp luật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phương tiện vận chuyển phải có kết cấu phù hợp với loại động vật chuyên chở."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trong quá trình vận chuyển phải chấp hành các quy định của pháp luật về trật tự, an toàn giao thông đường bộ, vệ sinh dịch tễ, phòng dịch và bảo đảm vệ sinh môi trường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'phải bố trí người áp tải'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 176",
        "no": 176,
        "content": "Việc vận chuyển hàng hóa nguy hiểm khi tham gia giao thông đường bộ phải chấp hành các quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải có giấy phép vận chuyển; trong trường hợp cần thiết, đơn vị vận chuyển hàng hoá nguy hiểm phải bố trí người áp tải để bảo đảm trật tự, an toàn giao thông đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải có giấy phép vận chuyển; không phải bố trí người áp tải khi tham gia giao thông đường bộ."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 177",
        "no": 177,
        "content": "Việc lưu hành xe ô tô của người nước ngoài đăng ký tại nước ngoài có tay lái ở bên phải tham gia giao thông tại Việt Nam, xe cơ giới nước ngoài do người nước ngoài đưa vào Việt Nam du lịch được quy định như như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải chấp hành quy định của pháp luật về trật tự, an toàn giao thông đường bộ của Việt Nam. Trường hợp điều ước quốc tế mà nước Cộng hòa xã hội chủ nghĩa Việt Nam là thành viên có quy định khác thì áp dụng theo điều ước quốc tế đó."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tham gia giao thông đúng trong phạm vi, tuyến đường, thời gian đã được cơ quan có thẩm quyền của Việt Nam cấp phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô của người nước ngoài đăng ký tại nước ngoài có tay lái ở bên phải phải đi theo đoàn và có người, phương tiện hỗ trợ, hướng dẫn giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 178",
        "no": 178,
        "content": "Việc sử dụng xe mô tô, xe gắn máy, xe thô sơ để vận chuyển hành khách, hàng hóa phải thực hiện các quy định nào dưới đây để đảm bảo an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Kiểm tra điều kiện bảo đảm an toàn của xe trước khi tham gia giao thông đường bộ; mang đủ giấy tờ theo quy định của pháp luật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Kiểm tra việc sắp xếp hàng hóa bảo đảm an toàn; không chở quá số người, chở hành lý, hàng hoá vượt quá khối lượng cho phép hoặc vượt quá khổ giới hạn của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'phải có báo hiệu kích thước của hàng'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 179",
        "no": 179,
        "content": "Xe vận chuyển hàng siêu trường, siêu trọng phải thực hiện các quy định nào dưới đây để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải chạy với tốc độ quy định trong giấy phép và phải có báo hiệu kích thước của hàng; trường hợp cần thiết, phải có người, phương tiện hỗ trợ lái xe, cảnh báo cho người, phương tiện tham gia giao thông đường bộ khác và thực hiện các biện pháp bảo đảm an toàn giao thông khi vận chuyển hàng siêu trường, siêu trọng trên đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phải chạy với tốc độ quy định trong giấy phép; phải có người, phương tiện hỗ trợ lái xe, cảnh báo cho người, phương tiện tham gia giao thông đường bộ khác và thực hiện các biện pháp bảo đảm an toàn giao thông khi vận chuyển hàng siêu trường, siêu trọng trên đường dành cho giao thông công cộng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 1,
        "tittle": "Câu 180",
        "no": 180,
        "content": "Xe cứu hộ giao thông đường bộ cần thực hiện yêu cầu nào sau đây để bảo đảm trật tự an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe cứu hộ giao thông đường bộ phải có dấu hiệu nhận diện, niêm yết thông tin trên xe, gắn thiết bị giám sát hành trình và thiết bị ghi nhận hình ảnh người lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải tuân thủ quy định của pháp luật về khối lượng hàng hóa chuyên chở của xe cứu hộ và khối lượng của xe được cứu hộ ghi trên Chứng nhận kiểm định an toàn kỹ thuật và bảo vệ môi trường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Không có chuyện cộng điểm GPLX"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 181",
        "no": 181,
        "content": "Người lái xe kinh doanh vận tải khi thực hiện tốt việc rèn luyện, nâng cao trách nhiệm, đạo đức nghề nghiệp sẽ thu được kết quả như thế nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được khách hàng, xã hội tôn trọng; được đồng nghiệp quý mến, giúp đỡ; được doanh nghiệp tin dùng và đóng góp nhiều cho xã hội; thu hút được khách hàng, góp phần quan trọng trong xây dựng thương hiệu, kinh doanh có hiệu quả cao."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được cộng điểm vào giấy phép lái xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 182",
        "no": 182,
        "content": "Những hành vi nào sau đây thể hiện là người có văn hóa giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Luôn tuân thủ pháp luật về trật tự, an toàn giao thông đường bộ, nhường nhịn và giúp đỡ người khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi nhanh, vượt đèn đỏ nếu không có lực lượng Công an."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bấm còi và nháy đèn liên tục để cảnh báo xe khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tránh nhường đường để đi nhanh hơn."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 183",
        "no": 183,
        "content": "Người lái xe kinh doanh vận tải cần thực hiện những công việc gì ghi ở dưới đây để thường xuyên rèn luyện nâng cao đạo đức nghề nghiệp?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quản lý và sử dụng xe tốt; bảo dưỡng xe đúng định kỳ; thực hành tiết kiệm vật tư, nhiên liệu; luôn tu dưỡng bản thân, có lối sống lành mạnh, tác phong làm việc công nghiệp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nắm vững và tự giác chấp hành các quy định của pháp luật về trật tự, an toàn giao thông đường bộ, lái xe an toàn; thực hiện đầy đủ trách nhiệm với khách hàng; có ý thức tổ chức kỷ luật và xây dựng doanh nghiệp vững mạnh; có tinh thần hợp tác, tương trợ, giúp đỡ đồng nghiệp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 184",
        "no": 184,
        "content": "Người lái xe ô tô vận chuyển hành khách phải có những phẩm chất, đạo đức nghề nghiệp gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải có thái độ lịch sự, tôn trọng, thân mật với hành khách; giúp đỡ những người có hoàn cảnh khó khăn, người già, người khuyết tật, phụ nữ có thai, có con nhỏ và trẻ em."
                ],
                "answer": false
            },
            {
                "option": [
                    "Luôn tu dưỡng bản thân, có lối sống lành mạnh, khiêm tốn, có tác phong làm việc công nghiệp, không tham gia vào các tệ nạn xã hội; tôn trọng người cùng tham gia giao thông đường bộ và có ý thức bảo vệ môi trường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 185",
        "no": 185,
        "content": "Khái niệm về văn hóa giao thông được hiểu như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là sự hiểu biết và chấp hành nghiêm chỉnh pháp luật về giao thông, là ý thức trách nhiệm với cộng đồng khi tham gia giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là sự tôn trọng, nhường nhịn, giúp đỡ và ứng xử có văn hóa giữa những người tham gia giao thông với nhau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 186",
        "no": 186,
        "content": "Trên làn đường dành cho ô tô có vũng nước lớn, người lái xe ô tô bắt buộc phải đi qua vũng nước, trên làn đường bên cạnh có nhiều người đang lái xe mô tô tham gia giao thông, người lái xe ô tô xử lý như thế nào khi lái xe qua vũng nước là có văn hóa giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cho xe chạy thật nhanh qua vũng nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ cho xe chạy chậm qua vũng nước."
                ],
                "answer": true
            },
            {
                "option": [
                    "Giảm tốc độ cho xe chạy qua làn đường dành cho mô tô để tránh vũng nước."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 187",
        "no": 187,
        "content": "Người lái xe không điều khiển xe đi đúng làn đường quy định, phóng nhanh, vượt ẩu, vượt đèn đỏ, đi vào đường cấm được coi là hành vi nào trong các hành vi dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là thiếu văn hóa giao thông, vi phạm pháp luật về trật tự, an toàn giao thông đường bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là thiếu văn hóa giao thông."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'chặn động mạch'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 188",
        "no": 188,
        "content": "Khi sơ cứu người bị tai nạn giao thông đường bộ, có vết thương chảy máu ngoài, phun thành tia và phun mạnh khi mạch đập, bạn phải làm gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Thực hiện cầm máu trực tiếp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Thực hiện cầm máu không trực tiếp (chặn động mạch)."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 189",
        "no": 189,
        "content": "Người lái xe có văn hóa giao thông khi tham gia giao thông đường bộ phải đáp ứng các điều kiện nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hiểu biết và chấp hành nghiêm chỉnh pháp luật về giao thông đường bộ; có ý thức trách nhiệm với cộng đồng khi tham gia giao thông; tôn trọng, nhường nhịn, giúp đỡ và ứng xử có văn hóa với những người cùng tham gia giao thông."
                ],
                "answer": true
            },
            {
                "option": [
                    "Điều khiển xe vượt quá tốc độ, đi không đúng làn đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 190",
        "no": 190,
        "content": "Người lái xe có văn hóa giao thông khi tham gia giao thông phải tuân thủ những quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Điều khiển xe đi trên phần đường, làn đường có ít phương tiện tham gia giao thông, chỉ đội mũ bảo hiểm ở nơi có biển báo bắt buộc đội mũ bảo hiểm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chấp hành hiệu lệnh, chỉ dẫn của người điều khiển giao thông, quy định về tốc độ, tín hiệu đèn, biển báo hiệu, vạch kẻ đường khi lái xe; nhường đường cho người đi bộ, người già, trẻ em, người khuyết tật."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 191",
        "no": 191,
        "content": "Người lái xe mô tô có văn hóa giao thông khi tham gia giao thông phải tuân thủ những quy định nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Điều khiển xe đi bên phải theo chiều đi của mình; đi đúng phần đường, làn đường quy định; đội mũ bảo hiểm đúng quy chuẩn kỹ thuật quốc gia, cài quai đúng quy cách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Điều khiển xe đi trên phần đường, làn đường có ít phương tiện tham gia giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Điều khiển xe và đội mũ bảo hiểm ở nơi có biển báo bắt buộc đội mũ bảo hiểm."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 192",
        "no": 192,
        "content": "Trong các hành vi dưới đây, người lái xe có văn hóa giao thông phải ứng xử như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Điều khiển xe đi bên phải theo chiều đi của mình; đi đúng phần đường, làn đường quy định; dừng, đỗ xe đúng nơi quy định; đã uống rượu, bia thì không lái xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Điều khiển xe đi trên phần đường, làn đường có ít phương tiện giao thông; dừng xe, đỗ xe ở nơi thuận tiện hoặc theo yêu cầu của hành khách, của người thân."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng và đỗ xe ở nơi thuận tiện cho việc chuyên chở hành khách và giao nhận hàng hóa; sử dụng ít rượu, bia thì có thể lái xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 193",
        "no": 193,
        "content": "Khi tham gia giao thông việc sử dụng còi xe nên dùng như thế nào để thể hiện là người có văn hóa giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ bấm còi khi thật sự cần thiết, không bấm còi liên tục hoặc kéo dài, sử dụng còi với mức âm lượng theo quy định."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bấm còi liên tục để các xe khác nhường đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bấm còi to khi đi qua khu vực đông dân cư."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không cần dùng còi, tránh gây tiếng ồn là văn minh."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 194",
        "no": 194,
        "content": "Người điều khiển phương tiện tham giao thông đường bộ gây ra tai nạn giao thông đường bộ, người liên quan đến vụ tai nạn giao thông đường bộ có trách nhiệm gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng ngay phương tiện, cảnh báo nguy hiểm, giữ nguyên hiện trường, trợ giúp người bị nạn và báo tin cho cơ quan Công an, cơ sở khám bệnh, chữa bệnh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ở lại hiện trường vụ tai nạn giao thông đường bộ cho đến khi người của cơ quan Công an đến, trừ trường hợp phải đi cấp cứu, đưa người bị nạn đi cấp cứu hoặc xét thấy bị đe dọa đến tính mạng, sức khỏe nhưng phải đến trình báo ngay cơ quan Công an, Ủy ban nhân dân nơi gần nhất."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cung cấp thông tin xác định danh tính về bản thân, người liên quan đến vụ tai nạn giao thông đường bộ và thông tin liên quan của vụ tai nạn giao thông đường bộ cho cơ quan có thẩm quyền."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 195",
        "no": 195,
        "content": "Người có mặt tại nơi xảy ra vụ tai giao thông đường bộ có trách nhiệm gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giúp đỡ, cứu chữa kịp thời người bị nạn; báo tin ngay cho cơ quan Công an, cơ sở khám bệnh, chữa bệnh hoặc Ủy ban nhân dân nơi gần nhất; tham gia bảo vệ hiện trường; tham gia bảo vệ tài sản của người bị nạn; cung cấp thông tin liên quan về vụ tai nạn theo yêu cầu của cơ quan có thẩm quyền."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chụp lại hình ảnh vụ tai nạn (nếu có thiết bị ghi hình) và nhanh chóng rời khỏi hiện trường vụ tai nạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 196",
        "no": 196,
        "content": "Khi sơ cứu ban đầu cho người bị tai nạn giao thông đường bộ không còn hô hấp, người lái xe và người có mặt tại hiện trường vụ tai nạn phải thực hiện các công việc gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đặt nạn nhân nằm ngửa, khai thông đường thở của nạn nhân; thực hiện các biện pháp hô hấp nhân tạo."
                ],
                "answer": true
            },
            {
                "option": [
                    "Thực hiện các biện pháp hô hấp nhân tạo."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 197",
        "no": 197,
        "content": "Hành vi bỏ trốn sau khi gây tai nạn để trốn tránh trách nhiệm hoặc khi có điều kiện mà cố ý không cứu giúp người bị tai nạn giao thông có bị nghiêm cấm hay không?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Không bị nghiêm cấm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nghiêm cấm tuỳ từng trường hợp cụ thể."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bị nghiêm cấm."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 198",
        "no": 198,
        "content": "Khi đang lái xe, thấy một người đi bộ đang sang đường trên vạch kẻ đường dành cho người đi bộ, người lái xe nên làm gì?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giảm tốc độ và nhường đường cho người đi bộ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bấm còi để họ đi nhanh hơn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tiếp tục đi nếu đang vội."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vượt qua nếu thấy khoảng trống đủ rộng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 199",
        "no": 199,
        "content": "Khi gặp vụ tai nạn giao thông, người lái xe nên hành động như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chạy đi để tránh rắc rối."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng xe, hỗ trợ nạn nhân và báo cho cơ quan chức năng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ quan sát rồi tiếp tục di chuyển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ giúp đỡ nếu có người thân trong vụ tai nạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 200",
        "no": 200,
        "content": "Trong đoạn đường hai chiều tại khu đông dân cư đang ùn tắc, người điều khiển xe mô tô có văn hóa giao thông sẽ lựa chọn cách xử lý tình huống nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cho xe lấn sang làn ngược chiều để nhanh chóng thoát khỏi nơi ùn tắc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Điều khiển xe trên vỉa hè để nhanh chóng thoát khỏi nơi ùn tắc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Kiên nhẫn tuân thủ hướng dẫn của người điều khiển giao thông hoặc tín hiệu đèn giao thông, di chuyển trên đúng phần đường bên phải theo chiều đi, nhường đường cho các phương tiện đi ngược chiều."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 201",
        "no": 201,
        "content": "Khi điều khiển phương tiện tham gia giao thông trên đoạn đường bộ đang xảy ra ùn tắc, những hành vi nào dưới đây là thiếu văn hóa?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bấm còi liên tục thúc giục các phương tiện phía trước nhường đường; đi trên vỉa hè, tận dụng mọi khoảng trống để nhanh chóng thoát khỏi nơi ùn tắc; lấn sang trái đường cố gắng vượt lên xe khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tuân thủ hướng dẫn của người điều khiển giao thông hoặc tín hiệu giao thông, đi đúng phần đường, làn đường quy định."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 202",
        "no": 202,
        "content": "Người lái xe, chủ phương tiện giao thông cơ giới đường bộ nên thực hiện các biện pháp phòng cháy, chữa cháy như thế nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không lắp đặt thêm thiết bị điện, phụ kiện không đúng theo thiết kế của nhà sản xuất; tuân thủ quy trình vận hành bảo trì bảo dưỡng định kỳ; thường xuyên kiểm tra phương tiện, khi phát hiện thấy dấu hiệu khác lạ (khó nổ, có hơi xăng, có tiếng kêu bất thường, nhiệt độ của máy cao, có mùi khét) cần khắc phục ngay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi để xe trong nhà, ở nơi trông giữ xe phải tắt khóa điện, để xa nguồn lửa, nguồn nhiệt; không mua xăng, dầu ở các điểm bán tự phát, không rõ nguồn gốc; không sử dụng các biện pháp “tiết kiệm xăng, dầu” khi chưa được kiểm chứng về mức độ an toàn có thể gây hỏng xe hoặc dẫn đến nguy cơ xảy ra cháy cao."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không để các chất dễ cháy, dễ bắt lửa trong xe, dưới yên xe, trong cốp xe, trong khoang động cơ. Đối với xe điện cần chọn địa điểm sạc an toàn, sử dụng các thiết bị sạc đúng cách và giám sát quá trình sạc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 203",
        "no": 203,
        "content": "Người điều khiển phương tiện cơ giới đường bộ phải thực hiện những biện pháp gì dưới đây để chữa cháy trong trường hợp phương tiện bị cháy, xét thấy có khả năng dập tắt đám cháy?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tắt khoá điện, hô hoán để mọi người đến trợ giúp chữa cháy, gọi Cảnh sát phòng cháy chữa cháy và cứu nạn cứu hộ (điện thoại 114)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu nhiên liệu chưa trào ra ngoài (ngọn lửa chưa cháy dữ dội) thì có thể sử dụng nước, hoặc bất kỳ chất, phương tiện chữa cháy có được để dập lửa; nếu nhiên liệu đã trào ra ngoài (ngọn lửa cháy dữ dội) thì phải sử dụng các bình chữa cháy, cát, chăn chiên, bao tải, vải nhúng nước để dập lửa."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "nhiên liệu trào ra ngoài thì ko được dùng nước"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 204",
        "no": 204,
        "content": "Khi phát hiện thấy có ngọn lửa, khói hoặc nhiệt độ cao bất thường từ phương tiện giao thông do mình điều khiển người lái xe phải làm gì trước tiên?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bình tĩnh, đưa xe sát vào lề đường, tránh xa nơi có nhiều người, nhiều chất dễ cháy và tắt khóa điện, thực hiện các bước chữa cháy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hô hoán để mọi người đến trợ giúp chữa cháy, gọi Cảnh sát giao thông, Cảnh sát phòng cháy, chữa cháy và cứu nạn, cứu hộ, lực lượng y tế để sẵn sàng hỗ trợ cứu người."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu nhiên liệu trào ra ngoài, ngọn lửa chưa cháy dữ dội thì tiếp tục sử dụng nước, hoặc bất kỳ chất, phương tiện chữa cháy có được để dập lửa."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 2,
        "tittle": "Câu 205",
        "no": 205,
        "content": "Khi gặp nạn nhân bị bỏng trong vụ tai nạn giao thông, người lái xe cần làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Gọi số 115 để thông báo về tình trạng tai nạn và yêu cầu hỗ trợ y tế ngay lập tức. Quan sát hiện trường để giúp nạn nhân, đồng thời tránh gây tổn thương cho mình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhanh chóng loại bỏ nguyên nhân gây bỏng bằng cách tách nạn nhân khỏi vật gây cháy, cởi bỏ quần áo nếu bén lửa, ngâm vùng da bị bỏng vào nước sạch hoặc đắp khăn mát, lưu ý không dùng khăn hoặc nước quá lạnh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu nạn nhân còn tỉnh, cần cho uống bù nước. Trong thời tiết lạnh, cần giữ ấm cho cơ thể nạn nhân, sau đó nhanh chóng đưa đến cơ sở y tế gần nhất."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 206",
        "no": 206,
        "content": "Khi điều khiển xe mô tô tay ga xuống đường dốc dài, độ dốc cao, người lái xe cần thực hiện các thao tác nào dưới đây để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giữ tay ga ở mức độ phù hợp, sử dụng phanh trước và phanh sau để giảm tốc độ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhả hết tay ga, tắt động cơ, sử dụng phanh trước và phanh sau để giảm tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sử dụng phanh trước để giảm tốc độ kết hợp với tắt chìa khóa điện của xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Phải đạp phanh trước khi vào số rồi thả phanh từ từ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 207",
        "no": 207,
        "content": "Khi vào số để khởi hành xe ô tô có số tự động, người lái xe phải thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đạp bàn đạp phanh chân hết hành trình, vào số và nhả phanh đỗ, kiểm tra lại xem có bị nhầm số không rồi mới cho xe lăn bánh."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đạp bàn đạp để tăng ga với mức độ phù hợp, vào số và kiểm tra lại xem có bị nhầm số không rồi mới cho xe lăn bánh."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Dùng lực tay phải bóp khóa hãm'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 208",
        "no": 208,
        "content": "Khi nhả phanh đỗ cơ khí điều khiển bằng tay (phanh tay), người lái xe cần phải thực hiện các thao tác nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng lực tay phải kéo cần phanh tay về phía sau hết hành trình; nếu khóa hãm bị kẹt cứng phải đẩy mạnh phanh tay về phía trước, sau đó bóp khóa hãm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng lực tay phải bóp khóa hãm đẩy cần phanh tay về phía trước hết hành trình; nếu khóa hãm bị kẹt cứng phải kéo cần phanh tay về phía sau đồng thời bóp khóa hãm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Dùng lực tay phải đẩy cần phanh tay về phía trước hết hành trình; nếu khóa hãm bị kẹt cứng phải đẩy mạnh phanh tay về phía trước, sau đó bóp khóa hãm."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đạp ly hợp (côn) hết hành trình;' --> trước tiên sau khi kiểm tra an toàn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 209",
        "no": 209,
        "content": "Khi khởi hành ô tô sử dụng hộp số cơ khí trên đường bằng, người lái xe cần thực hiện các thao tác nào theo trình tự dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Kiểm tra an toàn xung quanh xe ô tô; nhả từ từ đến 1/2 hành trình bàn đạp ly hợp (côn) và giữ trong khoảng 3 giây; vào số 1; nhả hết phanh tay, báo hiệu bằng còi, đèn trước khi xuất phát; tăng ga đủ để xuất phát, sau đó vừa tăng ga vừa nhả hết côn để cho xe ô tô chuyển động."
                ],
                "answer": false
            },
            {
                "option": [
                    "Kiểm tra an toàn xung quanh xe ô tô; đạp ly hợp (côn) hết hành trình; vào số 1; nhả hết phanh tay, báo hiệu bằng còi, đèn trước khi xuất phát; tăng ga đủ để xuất phát; nhả từ từ đến 1/2 hành trình bàn đạp côn và giữ trong khoảng 3 giây, sau đó vừa tăng ga vừa nhả hết côn để cho xe ô tô chuyển động."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'với tốc độ tối đa' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 210",
        "no": 210,
        "content": "Khi quay đầu xe, người lái xe cần phải quan sát và thực hiện các thao tác nào để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát biển báo hiệu để biết nơi được phép quay đầu; quan sát kỹ địa hình nơi chọn để quay đầu; lựa chọn quỹ đạo quay đầu xe cho thích hợp; quay đầu xe với tốc độ thấp; thường xuyên báo tín hiệu để người, các phương tiện xung quanh được biết; nếu quay đầu xe ở nơi nguy hiểm thì đưa đầu xe về phía nguy hiểm, đưa đuôi xe về phía an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát biển báo hiệu để biết nơi được phép quay đầu; quan sát kỹ địa hình nơi chọn để quay đầu; lựa chọn quỹ đạo quay đầu xe; quay đầu xe với tốc độ tối đa; thường xuyên báo tín hiệu để người, các phương tiện xung quanh được biết; nếu quay đầu xe ở nơi nguy hiểm thì đưa đuôi xe về phía nguy hiểm và đầu xe về phía an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 211",
        "no": 211,
        "content": "Khi ngồi lái ô tô tư thế chân, lưng, tay của người lái xe như thế nào là đúng để bảo đảm an toàn và thoải mái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Điều chỉnh ghế sao cho chân có thể đạp phanh và ga dễ dàng, ngồi thẳng lưng, hai tay nắm vô lăng, tay trái nắm ở vị trí 9 đến 10 giờ và tay phải nắm ở vị trí từ 2 đến 4 giờ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ngồi sát vô lăng để dễ quan sát hoặc ngồi tự do, không cần điều chỉnh ghế."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ngồi ngả người về phía sau nhiều để thư giãn, chân trái để ở vị trí chân ga, hai tay nắm vô lăng ở vị trí bất kỳ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "số thấp là số mạnh để lên dốc"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 212",
        "no": 212,
        "content": "Khi điều khiển ô tô lên dốc cao, người lái xe cần thực hiện các thao tác nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng lên số cao từ chân dốc, điều chỉnh ga cho xe nhanh lên dốc; đến gần đỉnh dốc phải tăng ga để xe nhanh chóng qua dốc; về số thấp, đi sát về phía bên phải đường, có tín hiệu (còi, đèn) để báo cho người lái xe đi ngược chiều biết."
                ],
                "answer": false
            },
            {
                "option": [
                    "Về số thấp từ chân dốc, điều chỉnh ga cho xe từ từ lên dốc; đến gần đỉnh dốc phải đi chậm, đi sát về phía bên phải đường, có tín hiệu (còi, đèn) để báo cho người lái xe đi ngược chiều biết."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "số thấp thì máy sẽ ghì giúp giảm tốc độ quán tính của xe"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 213",
        "no": 213,
        "content": "Khi điều khiển ô tô xuống dốc dài, người lái xe cần thực hiện các thao tác nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng lên số cao, nhả bàn đạp ga ở mức độ phù hợp, kết hợp với phanh chân để khống chế tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Về số thấp, nhả bàn đạp ga ở mức độ phù hợp, kết hợp với phanh chân để khống chế tốc độ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Về số không (0), nhả bàn đạp ga ở mức độ phù hợp, kết hợp với phanh chân để khống chế tốc độ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ về N khi xe đã dừng hẳn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 214",
        "no": 214,
        "content": "Khi xuống dốc, muốn dừng xe, người lái xe cần thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có tín hiệu rẽ phải, điều khiển xe sát vào lề đường bên phải; đạp phanh sớm và mạnh hơn lúc dừng xe trên đường bằng để xe đi với tốc độ chậm đến mức dễ dàng dừng lại được; về số 1, đạp 1/2 ly hợp (côn) cho xe đến chỗ dừng; khi xe đã dừng, về số không (N), đạp phanh chân, sử dụng phanh đỗ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Có tín hiệu rẽ phải, điều khiển xe sát vào lề đường bên trái; đạp hết hành trình ly hợp (côn) và nhả bàn đạp ga để xe đi với tốc độ chậm đến mức dễ dàng dừng lại được tại chỗ dừng; khi xe đã dừng, đạp và giữ phanh chân."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có tín hiệu rẽ trái, điều khiển xe sát vào lề đường bên phải; đạp phanh sớm và mạnh hơn lúc dừng xe trên đường bằng để xe đi với tốc độ chậm đến mức dễ dàng dừng lại được; về số không (N) để xe đi đến chỗ dừng, khi xe đã dừng, sử dụng phanh đỗ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'tăng tốc để nhanh chóng' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 215",
        "no": 215,
        "content": "Khi điều khiển xe trên đường vòng người lái xe cần phải làm gì để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát cẩn thận các chướng ngại vật và báo hiệu bằng coi, đèn; giảm tốc độ tới mức cần thiết, về số thấp và thực hiện quay vòng với tốc độ phù hợp với bán kính cong của đường vòng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát cẩn thận các chướng ngại vật và báo hiệu bằng còi, đèn; tăng tốc để nhanh chóng qua đường vòng và giảm tốc độ sau khi qua đường vòng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Phải xi nhan trước và giảm tốc độ"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 216",
        "no": 216,
        "content": "Khi điều khiển xe ô tô rẽ phải, người lái xe cần thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Có tín hiệu rẽ phải; quan sát an toàn phía sau; điều khiển xe sang làn đường bên trái; giảm tốc độ và quan sát an toàn phía bên phải để điều khiển xe qua chỗ đường giao nhau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cách chỗ rẽ một khoảng cách an toàn có tín hiệu rẽ phải; giảm tốc độ, quan sát an toàn phía trước, sau, bên phải và điều khiển xe từ từ rẽ phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cách chỗ rẽ một khoảng cách an toàn có tín hiệu rẽ phải; quan sát an toàn phía sau; điều khiển xe bám sát vào phía phải đường; tăng tốc độ và quan sát an toàn phía bên trái để điều khiển xe qua chỗ đường giao nhau."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đổi làn đường sang phải' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 217",
        "no": 217,
        "content": "Khi điều khiển xe ô tô rẽ trái, người lái xe cần thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cách chỗ rẽ một khoảng cách an toàn có tín hiệu rẽ trái; giảm tốc độ, quan sát an toàn xung quanh đặc biệt là bên trái; đổi sang làn đường bên trái và điều khiển xe từ từ rẽ trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cách chỗ rẽ một khoảng cách an toàn có tín hiệu rẽ trái, tăng tốc độ để xe nhanh chóng qua chỗ đường giao nhau; có tín hiệu xin đổi làn đường; quan sát an toàn xung quanh đặc biệt là bên trái; đổi làn đường sang phải để mở rộng vòng cua."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 218",
        "no": 218,
        "content": "Khi điều khiển xe sử dụng hộp số cơ khí vượt qua rãnh lớn cắt ngang mặt đường, người lái xe cần thực hiện các thao tác nào để đảm bảo an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vào số một (1) và từ từ cho hai bánh xe trước xuống rãnh, tăng ga cho hai bánh xe trước vượt lên khỏi rãnh, tăng số, tăng tốc độ để bánh xe sau vượt qua rãnh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng ga, tăng số để hai bánh xe trước và bánh xe sau vượt qua khỏi rãnh và chạy bình thường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vào số một (1) và từ từ cho hai bánh xe trước xuống rãnh, tăng ga cho hai bánh xe trước vượt lên khỏi rãnh, tiếp tục để bánh xe sau từ từ xuống rãnh rồi tăng dần ga cho xe ô tô lên khỏi rãnh."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 219",
        "no": 219,
        "content": "Khi điều khiển xe qua đường sắt, người lái xe cần phải thực hiện các thao tác nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Khi có chuông báo hoặc thanh chắn đã hạ xuống, người lái xe phải dừng xe tạm thời đúng khoảng cách an toàn, kéo phanh tay nếu đường dốc hoặc phải chờ lâu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi không có chuông báo hoặc thanh chắn không hạ xuống, người lái xe cần phải quan sát nếu thấy đủ điều kiện an toàn thì về số thấp, tăng ga nhẹ và không thay đổi số trong quá trình vượt qua đường sắt để tránh động cơ chết máy cho xe cho vượt qua."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 3,
        "tittle": "Câu 220",
        "no": 220,
        "content": "Khi điều khiển xe ô tô tự đổ, người lái xe cần chú ý những điểm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Khi chạy trên đường xấu, nhiều ổ gà nên chạy chậm để thùng xe không bị lắc mạnh, không gây hiện tượng lệch \"ben\"; khi chạy vào đường vòng, cần giảm tốc độ, không lấy lái gấp và không phanh gấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Khi chạy trên đường quốc lộ, đường bằng phẳng không cần hạ hết thùng xe xuống."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Khi đổ hàng phải chọn vị trí có nền đường cứng và phẳng, dừng hẳn xe, kéo hết phanh đỗ; sau đó mới điều khiển cơ cấu nâng \"ben\" để đổ hàng, đổ xong hàng mới hạ thùng xuống."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Không được nhìn xuống buồng lái'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 221",
        "no": 221,
        "content": "Khi điều khiển xe tăng số, người lái xe cần chú ý những điểm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được nhìn xuống buồng lái, cần phải tăng thứ tự từ thấp đến cao, phối hợp các động tác phải nhịp nhàng, chính xác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhìn xuống buồng lái để biết chính xác vị trí các tay số, cần phải tăng thứ tự từ thấp đến cao, phối hợp các động tác phải nhịp nhàng, vù ga phải phù hợp với tốc độ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Không được nhìn xuống buồng lái'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 222",
        "no": 222,
        "content": "Khi điều khiển xe giảm số, người lái xe cần phải chú ý những điểm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhìn xuống buồng lái để biết chính xác vị trí các tay số, cần phải giảm thứ tự từ cao xuống thấp, phối hợp các động tác phải nhịp nhàng, chính xác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được nhìn xuống buồng lái, cần phải giảm thứ tự từ cao xuống thấp, phối hợp các động tác phải nhịp nhàng, chính xác, vù ga phải phù hợp với tốc độ."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Về số thấp phù hợp'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 223",
        "no": 223,
        "content": "Để giảm tốc độ khi ô tô đi xuống đường dốc dài, người lái xe phải thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhả bàn đạp ga, đạp ly hợp (côn) hết hành trình, đạp mạnh phanh chân để giảm tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Về số thấp phù hợp, nhả bàn đạp ga, kết hợp đạp phanh chân với mức độ phù hợp để giảm tốc độ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhả bàn đạp ga, tăng lên số cao, đạp phanh chân với mức độ phù hợp để giảm tốc độ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'liên tục để thay đổi tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 224",
        "no": 224,
        "content": "Khi điều khiển ô tô qua đường ngập nước, người lái xe cần thực hiện các thao tác nào để đảm bảo an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng lên số cao, tăng ga và giảm ga liên tục để thay đổi tốc độ, giữ vững tay lái để ô tô vượt qua đoạn đường ngập nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đạp ly hợp (côn) hết hành trình, tăng ga và giảm ga liên tục để thay đổi tốc độ, giữ vững tay lái để ô tô vượt qua đoạn đường ngập nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát, ước lượng độ ngập nước mà xe ô tô có thể vượt qua an toàn, về số thấp, giữ đều ga và giữ vững tay lái để ô tô vượt qua đoạn đường ngập nước."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'chiếu xa sang đèn chiếu gần; không nhìn thẳng vào đèn'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 225",
        "no": 225,
        "content": "Khi điều khiển xe ô tô tới gần xe chạy ngược chiều vào ban đêm, người lái xe cần thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chuyển từ đèn chiếu xa sang đèn chiếu gần; không nhìn thẳng vào đèn của xe chạy ngược chiều mà nhìn chếch sang phía phải theo chiều chuyển động của xe mình."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chuyển từ đèn chiếu gần sang đèn chiếu xa; không nhìn thẳng vào đèn của xe chạy ngược chiều mà nhìn chếch sang phía phải theo chiều chuyển động của xe mình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chuyển từ đèn chiếu xa sang đèn chiếu gần; nhìn thẳng vào đèn của xe chạy ngược chiều để tránh xe bảo đảm an toàn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'không lấy nhiều lái'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 226",
        "no": 226,
        "content": "Khi điều khiển xe ô tô trên đường trơn cần chú ý những điểm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giữ vững tay lái cho xe đi đúng vệt bánh xe đi trước, sử dụng số thấp đi chậm, giữ đều ga, đánh lái ngoặt và phanh gấp khi cần thiết."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giữ vững tay lái cho xe đi đúng vệt bánh xe đi trước, sử dụng số thấp đi chậm, gài cầu (nếu có), giữ đều ga, không lấy nhiều lái, không đánh lái ngoặt và phanh gấp."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "brake: phanh"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/227.PNG", "/resources/images/600bca/227.PNG"],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 227",
        "no": 227,
        "content": "Khi động cơ xe ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây là báo hiệu tình trạng gì của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đang sử dụng phanh đỗ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhiệt độ nước làm mát quá mức cho phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cửa xe đang mở."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/228.PNG", "/resources/images/600bca/228.PNG"],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 228",
        "no": 228,
        "content": "Khi động cơ xe ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây là báo hiệu tình trạng gì của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đang sử dụng phanh đỗ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Thiếu dầu phanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhiệt độ nước làm mát tăng quá mức cho phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Áp suất dầu ở mức thấp."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/229.PNG", "/resources/images/600bca/229.PNG"],
        "shuffle": false,
        "chapter": 3,
        "tittle": "Câu 229",
        "no": 229,
        "content": "Khi động cơ xe ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây là báo hiệu tình trạng gì của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Cửa xe đóng chưa chặt hoặc có cửa xe chưa đóng."
                ],
                "answer": true
            },
            {
                "option": [
                    "2. Bộ nạp ắc quy gặp sự cố kỹ thuật."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Dầu bôi trơn bị thiếu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 2 và ý 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/230.PNG", "/resources/images/600bca/230.PNG"],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 230",
        "no": 230,
        "content": "Khi động cơ xe ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây là báo hiệu tình trạng gì của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Thiếu dầu phanh, phanh tay đang hãm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hệ thống túi khí an toàn gặp sự cố."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lái xe và người ngồi ghế trước chưa cài dây đai an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cửa đóng chưa chặt, có cửa chưa đóng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/231.PNG", "/resources/images/600bca/231.PNG"],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 231",
        "no": 231,
        "content": "Khi động cơ xe ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây là báo hiệu tình trạng gì của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu thiếu dầu phanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đang sử dụng phanh đỗ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sắp hết nhiên liệu."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 3,
        "tittle": "Câu 232",
        "no": 232,
        "content": "Trong các loại nhiên liệu dưới đây, loại nhiên liệu nào giảm thiểu ô nhiễm môi trường?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Xăng và dầu diesel."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Xăng sinh học và khí sinh học."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Lốp non sẽ gây tốn nhiên liệu hơn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 233",
        "no": 233,
        "content": "Các biện pháp tiết kiệm nhiên liệu khi chạy xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bảo dưỡng xe theo định kỳ và có kế hoạch lộ trình trước khi xe chạy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Kiểm tra áp suất lốp theo quy định và chạy xe với tốc độ phù hợp với tình trạng mặt đường và mật độ giao thông trên đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'mở hé cánh cửa'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 234",
        "no": 234,
        "content": "Khi đã đỗ xe ô tô sát lề đường bên phải, người lái xe phải thực hiện các thao tác nào dưới đây khi mở cửa xuống xe để đảm bảo an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát tình hình giao thông phía trước, phía sau và phía bên mở cửa xe, mở hé cánh cửa, nếu đảm bảo an toàn thì mở cửa ở mức cần thiết để xuống xe ô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Mở cánh cửa và quan sát tình hình giao thông phía trước, nếu đảm bảo an toàn thì mở cửa ở mức cần thiết để xuống xe ô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Mở cánh cửa hết hành trình và nhanh chóng ra khỏi xe ô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 235",
        "no": 235,
        "content": "Khi điều khiển xe ô tô qua đường sắt không có rào chắn, không có người điều khiển giao thông, người lái xe phải xử lý như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, dừng lại trước vạch dừng, quan sát cả hai phía, nếu không có tàu đi tới, tăng ga nhẹ vượt qua đường sắt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nếu thấy có tàu đi tới thì dừng lại trước vạch dừng, chỉ khi tàu đi qua mới được đi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 236",
        "no": 236,
        "content": "Khi lái xe ô tô qua đường sắt không có rào chắn, không có người điều khiển giao thông, người lái xe thực hiện thao tác: “giảm tốc độ, dừng lại trước vạch dừng, quan sát cả hai phía, nếu không có tàu đi tới, tăng ga nhẹ vượt qua đường sắt. Nếu thấy có tàu đi tới thì dừng lại trước vạch dừng, chỉ khi tàu đi qua mới được đi” để đảm bảo an toàn là đúng hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không đúng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đúng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không cần thiết, vì nếu nhìn thấy tàu còn cách xa, người lái xe có thể tăng số cao, tăng ga để cho xe nhanh chóng vượt qua đường sắt."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "số thấp thì máy sẽ mạnh hơn và xe sẽ ghì hơn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 237",
        "no": 237,
        "content": "Khi điều khiển xe ô tô có hộp số tự động đi vào đường trơn trượt, lầy lội, người lái xe phải xử lý như thế nào để đảm bảo an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Về số thấp, kết hợp phanh chân để giảm tốc độ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Giữ nguyên tay số D, kết hợp phanh đỗ để giảm tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Về số N (số 0), kết hợp phanh chân để giảm tốc độ."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 238",
        "no": 238,
        "content": "Khi động cơ ô tô đã khởi động, muốn điều chỉnh ghế của người lái, người lái xe phải để cần số ở vị trí nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vị trí N hoặc vị trí P hoặc số 0."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vị trí D hoặc số 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vị trí R."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 239",
        "no": 239,
        "content": "Khi điều khiển xe ô tô có hộp số tự động, người lái xe sử dụng chân như thế nào là đúng để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không sử dụng chân trái; chân phải điều khiển bàn đạp phanh và bàn đạp ga."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chân trái điều khiển bàn đạp phanh, chân phải điều khiển bàn đạp ga."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không sử dụng chân phải; chân trái điều khiển bàn đạp phanh và bàn đạp ga."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Tăng tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 240",
        "no": 240,
        "content": "Khi tầm nhìn bị hạn chế bởi sương mù hoặc mưa to, người lái xe phải thực hiện các thao tác nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ, chạy gần xe trước, nhìn đèn hậu để định hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, chạy cách xa xe trước với khoảng cách an toàn, bật đèn sương mù và đèn chiếu gần."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ, bật đèn pha vượt qua xe chạy trước."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 241",
        "no": 241,
        "content": "Khi đèn pha của xe đi ngược chiều gây chói mắt, làm giảm khả năng quan sát trên đường, người lái xe xử lý như thế nào dưới đây để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, giữ vững tay lái, nhìn chếch sang lề đường bên phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bật đèn pha chiếu xa và giữ nguyên tốc độ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ, bật đèn pha đối diện xe phía trước."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 242",
        "no": 242,
        "content": "Để đạt được hiệu quả phanh cao nhất, người lái xe mô tô phải sử dụng các kỹ năng như thế nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Sử dụng phanh trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sử dụng phanh sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm hết ga, sử dụng đồng thời cả phanh sau và phanh trước."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Tăng tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 243",
        "no": 243,
        "content": "Khi lái xe ô tô trên mặt đường có nhiều \"ổ gà\", người lái xe phải thực hiện thao tác như thế nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, về số thấp và giữ đều ga."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ cho xe lướt qua nhanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ, đánh lái liên tục để tránh \"ổ gà\"."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Tăng tốc độ' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 244",
        "no": 244,
        "content": "Khi điều khiển xe ô tô gặp mưa to hoặc sương mù, người lái xe phải làm gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bật đèn chiếu gần và đèn vàng (nếu có), điều khiển gạt nước, điều khiển ô tô đi với tốc độ chậm để có thể quan sát được; tìm chỗ an toàn dừng xe, bật đèn dừng khẩn cấp báo hiệu cho các xe khác biết."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bật đèn chiếu xa và đèn vàng, điều khiển gạt nước, tăng tốc độ điều khiển ô tô qua khỏi khu vực mưa hoặc sương mù."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng tốc độ, bật đèn pha vượt qua xe chạy phía trước."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 245",
        "no": 245,
        "content": "Điều khiển xe ô tô trong trời mưa, người lái xe phải xử lý như thế nào để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giảm tốc độ, tăng cường quan sát, không nên phanh gấp, không nên tăng ga hay đánh vô lăng đột ngột, bật đèn chiếu gần, mở chế độ gạt nước ở chế độ phù hợp để đảm bảo quan sát."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phanh gấp khi xe đi vào vũng nước và tăng ga ngay sau khi ra khỏi vũng nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bật đèn chiếu xa, tăng tốc độ điều khiển ô tô qua khỏi khu vực mưa."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'bên trái, bên phải, phía sau'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 246",
        "no": 246,
        "content": "Khi lùi xe, người lái xe phải xử lý như thế nào để bảo đảm an toàn giao thông?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát bên trái, bên phải, phía sau xe, có tín hiệu cần thiết và lùi xe với tốc độ phù hợp."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát phía trước xe và lùi xe với tốc độ nhanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát bên trái và phía trước của xe và lùi xe với tốc độ nhanh."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 247",
        "no": 247,
        "content": "Điều khiển xe ô tô trong khu vực đông dân cư cần lưu ý điều gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giảm tốc độ đến mức an toàn, quan sát, nhường đường cho người đi bộ, giữ khoảng cách an toàn với các xe phía trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi đúng làn đường quy định, chỉ được chuyển làn đường ở nơi cho phép, nhưng phải quan sát."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 248",
        "no": 248,
        "content": "Khi điều khiển xe ô tô nhập vào đường cao tốc người lái xe cần thực hiện như thế nào dưới đây để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát, phát tín hiệu, nhường đường cho các xe đang chạy trên đường cao tốc, khi đủ điều kiện an toàn thì tăng tốc độ cho xe nhập vào làn đường cao tốc, nếu có làn đường tăng tốc thì phải cho xe chạy trên làn đường đó trước khi cho xe nhập vào làn của đường cao tốc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phát tín hiệu, quan sát các xe đang chạy phía trước, nếu bảo đảm các điều kiện an toàn thì tăng tốc độ cho xe nhập ngay vào làn đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phát tín hiệu và lái xe nhập vào làn đường tăng tốc, quan sát các xe phía sau đang chạy trên đường cao tốc, khi đủ điều kiện an toàn thì giảm tốc độ, từ từ cho xe nhập vào làn đường cao tốc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không được lùi xe trên cao tốc"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 249",
        "no": 249,
        "content": "Khi điều khiển xe ô tô ra khỏi đường cao tốc người lái xe cần thực hiện như thế nào dưới đây để bảo đảm an toàn giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát phía trước để tìm biển báo chỉ dẫn \"lối ra đường cao tốc\", kiểm tra tình trạng giao thông phía sau và bên phải, nếu bảo đảm điều kiện an toàn thì phát tín hiệu và điều khiển xe chuyển dần sang làn bên phải, nếu có làn đường giảm tốc thì phải cho xe di chuyển trên làn đường đó trước khi ra khỏi đường cao tốc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát phía trước để tìm biển báo chỉ dẫn \"lối ra đường cao tốc\", trường hợp vượt qua \"lối ra đường cao tốc\" thì phát tín hiệu, di chuyển sang làn đường giảm tốc và lùi xe quay trở lại."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ được trong trường hợp bất khả kháng"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 250",
        "no": 250,
        "content": "Người lái xe được dừng xe, đỗ xe trên làn dừng khẩn cấp của đường cao tốc trong trường hợp nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe gặp sự cố, tai nạn hoặc trường hợp khẩn cấp không thể di chuyển bình thường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để nghỉ ngơi, đi vệ sinh, chụp ảnh, làm việc riêng..."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 251",
        "no": 251,
        "content": "Trên đường đôi muốn vượt xe kéo rơ moóc phía trước, người lái xe phải xử lý như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giữ khoảng cách an toàn, tránh đi vào vị trí điểm mù của xe kéo rơ moóc, bật xi nhan trái đồng thời kết hợp đèn, còi xin vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi xe kéo rơ moóc đã có tín hiệu cho vượt (không có chướng ngại vật phía trước và xe đi ngược chiều), thấy đủ điều kiện an toàn thì vượt dứt khoát, không di chuyển song song bên cạnh xe kéo rơ moóc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi vượt qua, phải quan sát gương chiếu hậu bên phải nếu có khoảng trống an toàn mới được cho xe chạy vào làn của mình, tắt xi nhan và tiếp tục hành trình."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "số thấp thì máy sẽ mạnh hơn và xe sẽ ghì hơn"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 252",
        "no": 252,
        "content": "Khi điều khiển xe ô tô xuống đường dốc dài, độ dốc cao, người lái xe số tự động cần thực hiện các thao tác nào dưới đây để bảo đảm an toàn?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Nhả bàn đạp ga, về số thấp, đạp phanh chân với mức độ phù hợp để giảm tốc độ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nhả bàn đạp ga, về số N đạp phanh chân và kéo phanh tay để giảm tốc độ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "từ đường nhánh thì phải nhường tất cả xe ở đường chính"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 253",
        "no": 253,
        "content": "Khi đi từ đường nhánh ra đường chính, người lái xe phải xử lý như thế nào là đúng?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Quan sát, giảm tốc độ, phát tín hiệu, nhường đường cho xe trên đường chính từ bất kỳ hướng nào tới."
                ],
                "answer": true
            },
            {
                "option": [
                    "Nháy đèn, bấm còi để xe đi trên đường chính biết và tăng tốc độ cho xe đi ra đường chính."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát xe đang đi trên đường chính, nếu là xe có kích thước lớn hơn thì nhường đường, xe có kích thước nhỏ hơn thì tăng tốc độ cho xe đi ra đường chính."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Không được sử dụng đt khi đang lái xe"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 254",
        "no": 254,
        "content": "Khi đang lái xe mô tô hoặc ô tô, nếu có nhu cầu sử dụng điện thoại để nhắn tin hoặc gọi điện, người lái xe phải thực hiện như thế nào trong các tình huống nêu dưới đây?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Giảm tốc độ để bảo đảm an toàn với xe phía trước và sử dụng điện thoại để liên lạc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ để dừng xe ở nơi cho phép sau đó sử dụng điện thoại để liên lạc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ để cách xa xe phía sau và sử dụng điện thoại để liên lạc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Lái xe mô tô chỉ sử dụng phanh trước dễ gây lếch bánh"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 255",
        "no": 255,
        "content": "Những thói quen nào dưới đây khi điều khiển xe mô tô tay ga tham gia giao thông dễ gây tai nạn nguy hiểm?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Sử dụng còi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phanh đồng thời cả phanh trước và phanh sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ sử dụng phanh trước."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'không cần quan sát' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 256",
        "no": 256,
        "content": "Người ngồi trên xe ô tô cần thực hiện những thao tác mở cửa như thế nào dưới đây để xuống xe để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát phía trước, phía sau và bên phía mở cửa để phát hiện các phương tiện đang di chuyển tới gần, khi đủ điều kiện an toàn, mở hé cửa, sau đó mở ở mức cần thiết để xuống xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quan sát tình hình giao thông phía trước, không cần quan sát phía sau và bên mở cửa; mở cánh cửa hết hành trình và nhanh chóng ra khỏi xe ô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 257",
        "no": 257,
        "content": "Khi điều khiển xe mô tô quay đầu, người lái xe cần thực hiện như thế nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bật tín hiệu báo rẽ trước khi quay đầu, từ từ giảm tốc độ đến mức có thể dừng lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ quay đầu xe tại những nơi được phép quay đầu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát an toàn các phương tiện tới từ phía trước, phía sau, hai bên đồng thời nhường đường cho xe từ bên phải và phía trước đi tới."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 3,
        "tittle": "Câu 258",
        "no": 258,
        "content": "Tay ga trên xe mô tô hai bánh có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Để điều khiển xe chạy về phía trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Để điều tiết công suất động cơ qua đó điều khiển tốc độ của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Để điều khiển xe chạy lùi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'chiếu hậu' nghĩa là phía sau"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 259",
        "no": 259,
        "content": "Gương chiếu hậu của xe mô tô hai bánh có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để quan sát an toàn phía bên trái khi chuẩn bị rẽ trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để quan sát an toàn phía bên phải khi chuẩn bị rẽ phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để quan sát an toàn phía sau của bên trái và bên phải trước khi chuyển hướng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để quan sát an toàn phía trước cả bên trái và bên phải trước khi chuyển hướng. "
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 260",
        "no": 260,
        "content": "Để bảo đảm an toàn khi tham gia giao thông, người lái xe mô tô hai bánh cần điều khiển tay ga như thế nào?",
        "isImportant": true,
        "options": [
            {
                "option": [
                    "Tăng ga thật mạnh, giảm ga từ từ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng ga thật mạnh, giảm ga thật nhanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tăng ga từ từ, giảm ga thật nhanh."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng ga từ từ, giảm ga từ từ."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 261",
        "no": 261,
        "content": "Để tránh đổ, ngã khi điều khiển xe mô tô hai bánh ở nơi đường xấu, nhỏ và hẹp, người lái xe cần xử lý như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi ở tốc độ thấp, quan sát liên tục khoảng cách từ 05 m đến 10 m phía trước để điều chỉnh sớm hướng di chuyển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trong quá trình di chuyển không nên dùng phanh trước tránh làm khóa bánh dẫn hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được lắc người sang trái hoặc phải nhiều, trọng tâm cơ thể cần trùng với trọng tâm của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 262",
        "no": 262,
        "content": "Khi lái xe ô tô điện xuống dốc dài, đổ đèo, người lái xe cần chú ý những vấn đề gì để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Kiểm tra hệ thống an toàn, pin của xe trước khi xuất phát."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhả chân ga để phanh tái sinh hoạt động."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rà phanh chân để kịp thời xử lý tình huống khẩn cấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 3,
        "tittle": "Câu 263",
        "no": 263,
        "content": "Khi lái xe ô tô điện qua khu vực ngập nước, người lái xe cần phải chú ý những vấn đề gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Người lái xe phải tìm hiểu khả năng chìm trong nước của xe để xác định cung đường di chuyển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giữ vững tay lái, đi đều ga, tránh không để xe chết máy giữa dòng, không nên dừng xe trên đường ngập nước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lái xe tốc độ chậm, không tạo sóng và giữ khoảng cách an toàn với các phương tiện xung quanh, nhất là người đi bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'lau sạch que thăm'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 264",
        "no": 264,
        "content": "Phương pháp kiểm tra mức dầu bôi trơn động cơ nào dưới đây là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Kiểm tra que thăm dầu trên các-te. Quan sát vệt dầu trên que thăm, mức dầu này phải nằm ở mức tối đa được thể hiện trên que thăm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rút que thăm dầu trên các-te. Quan sát vệt dầu trên que thăm, mức dầu này phải nằm ở mức tối thiểu được thể hiện trên que thăm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rút que thăm dầu trên các-te, lau sạch que thăm sau đó cắm vào các-te và rút ra quan sát vệt dầu trên que thăm, mức dầu phải nằm trong khoảng vạch mức tối thiểu và tối đa được thể hiện trên que thăm."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 265",
        "no": 265,
        "content": "Xe ô tô tham gia giao thông đường bộ phải bảo đảm các quy định về chất lượng, an toàn kỹ thuật và bảo vệ môi trường nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Kính chắn gió, kính cửa phải là loại kính an toàn, bảo đảm tầm nhìn cho người điều khiển; có đủ hệ thống hãm và hệ thống chuyển hướng có hiệu lực, tay lái xe ô tô ở bên trái của xe, có còi với âm lượng đúng quy chuẩn kỹ thuật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có đủ đèn chiếu sáng gần và xa, đèn soi biển số, đèn báo hãm, đèn tín hiệu; có đủ bộ phận giảm thanh, giảm khói, các kết cấu phải đủ độ bền và bảo đảm tính năng vận hành ổn định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 266",
        "no": 266,
        "content": "Xe mô tô và xe ô tô tham gia giao thông trên đường bộ có bắt buộc phải đủ bộ phận giảm thanh không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không bắt buộc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bắt buộc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tùy từng trường hợp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Dàn đèn pha trên nóc xe' -> bị lụm liền"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": false,
        "chapter": 4,
        "tittle": "Câu 267",
        "no": 267,
        "content": "Xe ô tô tham gia giao thông trên đường bộ phải có đủ các loại đèn nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Đèn chiếu sáng gần và xa."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Đèn soi biển số, đèn báo hãm và đèn tín hiệu."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Dàn đèn pha trên nóc xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 268",
        "no": 268,
        "content": "Kính chắn gió của xe ô tô phải bảo đảm yêu cầu nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là loại kính an toàn, kính nhiều lớp, đúng quy cách, không rạn nứt, bảo đảm hình ảnh quan sát rõ ràng, không bị méo mó."
                ],
                "answer": true
            },
            {
                "option": [
                    "Là loại kính trong suốt, không rạn nứt, bảo đảm tầm nhìn cho người điều khiển về phía trước mặt và hai bên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 269",
        "no": 269,
        "content": "Bánh xe, lốp lắp cho xe ô tô phải bảo đảm an toàn kỹ thuật như thế nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bánh xe phải có kết cấu chắc chắn, lắp đặt đúng quy cách của nhà sản xuât."
                ],
                "answer": false
            },
            {
                "option": [
                    "Lốp phải đủ số lượng, đủ áp suất, không phồng rộp, đúng cỡ lốp của nhà sản xuất hoặc tài liệu kỹ thuật quy định; lốp trên cùng một trục của xe sử dụng trong điều kiện hoạt động bình thường phải cùng kiểu loại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 270",
        "no": 270,
        "content": "Hệ thống lái trên xe ô tô phải bảo đảm yêu cầu nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bảo đảm cho xe chuyển hướng chính xác, điều khiển nhẹ nhàng, an toàn ở mọi vận tốc và tải trọng trong phạm vi tính năng kỹ thuật cho phép của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Khi hoạt động các cơ cấu chuyển động của hệ thống lái không được va chạm với bất kỳ bộ phận nào của xe; khi quay vô lăng lái về bên phải và bên trái thì không được có sự khác biệt đáng kể về lực tác động lên vành tay lái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 271",
        "no": 271,
        "content": "Mục đích của bảo dưỡng thường xuyên đối với xe ô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bảo dưỡng ô tô thường xuyên làm cho ô tô luôn luôn có tính năng kỹ thuật tốt, giảm cường độ hao mòn của các chi tiết, kéo dài tuổi thọ của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ngăn ngừa và phát hiện kịp thời các hư hỏng và sai lệch kỹ thuật để khắc phục, giữ gìn được hình thức bên ngoài."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'không có tia lửa điện' -> sai"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 272",
        "no": 272,
        "content": "Trong các nguyên nhân nêu dưới đây, nguyên nhân nào làm động cơ diesel không nổ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hết nhiên liệu, lõi lọc nhiên liệu bị tắc, lọc khí bị tắc, nhiên liệu lẫn không khí, tạp chất."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hết nhiên liệu, lõi lọc nhiên liệu bị tắc, lọc khí bị tắc, nhiên liệu lẫn không khí, không có tia lửa điện."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hết nhiên liệu, lõi lọc nhiên liệu bị tắc, lọc khí bị tắc, nhiên liệu lẫn không khí và nước, không có tia lửa điện."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 273",
        "no": 273,
        "content": "Ống xả lắp trên xe ô tô phải bảo đảm yêu cầu an toàn kỹ thuật nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ống xả không được đặt ở vị trí có thể gây cháy xe hoặc ảnh hưởng đến người ngồi trên xe và gây cản trở hoạt động của hệ thống khác."
                ],
                "answer": false
            },
            {
                "option": [
                    "Miệng thoát khí thải của ống xả không được hướng về phía trước và không được hướng về bên phải theo chiều tiến của xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'cơ cấu hãm giữ chặt dây khi giật dây đột ngột'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 274",
        "no": 274,
        "content": "Dây đai an toàn lắp trên xe ô tô phải bảo đảm yêu cầu an toàn kỹ thuật nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đủ số lượng, lắp đặt chắc chắn không bị rách, đứt, khóa cài đóng, mở nhẹ nhàng, không tự mở, không bị kẹt; kéo ra thu vào dễ dàng, cơ cấu hãm giữ chặt dây khi giật dây đột ngột."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đủ số lượng, lắp đặt chắc chắn không bị rách, đứt, khóa cài đóng, mở nhẹ nhàng, không tự mở, không bị kẹt; kéo ra thu vào dễ dàng, cơ cấu hãm mở ra khi giật dây đột ngột."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "4 kỳ = 4 (bốn) hành trình"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 275",
        "no": 275,
        "content": "Thế nào là động cơ 4 kỳ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Là loại động cơ: để hoàn thành một chu trình công tác của động cơ, pít tông thực hiện 2 (hai) hành trình, trong đó có một lần sinh công."
                ],
                "answer": false
            },
            {
                "option": [
                    "Là loại động cơ: để hoàn thành một chu trình công tác của động cơ, pít tông thực hiện 4 (bốn) hành trình, trong đó có một lần sinh công."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "dầu bôi trơn ko phải nhiên liệu"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 276",
        "no": 276,
        "content": "Công dụng của hệ thống bôi trơn đối với động cơ ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cung cấp một lượng dầu bôi trơn đủ và sạch dưới áp suất nhất định đi bôi trơn cho các chi tiết của động cơ để giảm ma sát, giảm mài mòn, làm kín, làm sạch, làm mát và chống gỉ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cung cấp một lượng nhiên liệu đầy đủ và sạch để cho động cơ ô tô hoạt động."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 277",
        "no": 277,
        "content": "Niên hạn sử dụng của xe ô tô tải (tính bắt đầu từ năm sản xuất) không quá bao nhiêu năm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "15 năm."
                ],
                "answer": false
            },
            {
                "option": [
                    "20 năm."
                ],
                "answer": false
            },
            {
                "option": [
                    "25 năm."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 278",
        "no": 278,
        "content": "Niên hạn sử dụng của xe ô tô chở người trên 8 chỗ ngồi (không kể chỗ của người lái xe) tính bắt đầu từ năm sản xuất không quá bao nhiêu năm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "5 năm."
                ],
                "answer": false
            },
            {
                "option": [
                    "20 năm."
                ],
                "answer": true
            },
            {
                "option": [
                    "25 năm."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'cơ năng'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 279",
        "no": 279,
        "content": "Hãy nêu công dụng của động cơ xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Khi làm việc, nhiệt năng được biến đổi thành cơ năng làm trục khủy động cơ quay, truyền lực đến các bánh xe chủ động tạo ra chuyển động tịnh tiến cho xe ô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Khi làm việc, cơ năng được biến đổi thành nhiệt năng và truyền đến các bánh xe chủ động tạo ra chuyển động tịnh tiến cho xe ô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'mô men quay'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 280",
        "no": 280,
        "content": "Hãy nêu công dụng hệ thống truyền lực của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng để truyền mô men quay từ động cơ tới các bánh xe chủ động của xe ô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Dùng để thay đổi hướng chuyển động hoặc giữ cho xe ô tô chuyển động ổn định theo hướng xác định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để làm giảm tốc độ, dừng chuyển động của xe ô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 281",
        "no": 281,
        "content": "Hãy nêu công dụng ly hợp (côn) của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng để truyền mô men xoắn giữa các trục không cùng nằm trên một đường thẳng và góc lệch trục luôn thay đổi trong quá trình xe ô tô chuyển động."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để truyền hoặc ngắt truyền động từ động cơ đến hộp số của xe ô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Dùng để truyền truyền động từ hộp số đến bánh xe chủ động của ô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 282",
        "no": 282,
        "content": "Hãy nêu công dụng hộp số của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Truyền và tăng mô men xoắn giữa các trục vuông góc nhau, bảo đảm cho các bánh xe chủ động quay với tốc độ khác nhau khi sức cản chuyển động ở bánh xe hai bên không bằng nhau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Truyền và thay đổi mô men xoắn giữa các trục không cùng nằm trên một đường thẳng và góc lệch trục luôn thay đổi trong quá trình ô tô chuyển động, chuyển số êm dịu, dễ điều khiển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Truyền và thay đổi mô men từ động cơ đến bánh xe chủ động, cắt truyền động từ động cơ đến bánh xe chủ động, bảo đảm cho xe ô tô chuyển động lùi."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'đổi hướng chuyển động'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 283",
        "no": 283,
        "content": "Hãy nêu công dụng hệ thống lái của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng để thay đổi mô men từ động cơ tới các bánh xe chủ động khi xe ô tô chuyển động theo hướng xác định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để thay đổi mô men giữa các trục vuông góc nhau khi xe ô tô chuyển động theo hướng xác định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để thay đổi hướng chuyển động hoặc giữ cho xe ô tô chuyển động ổn định theo hướng xác định."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'giảm tốc độ, dừng chuyển động'"
        ],
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 284",
        "no": 284,
        "content": "Hãy nêu công dụng hệ thống phanh của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng để giảm tốc độ, dừng chuyển động của xe ô tô và giữ cho xe ô tô đứng yên trên dốc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Dùng để thay đổi hướng chuyển động hoặc giữ cho xe ô tô chuyển động ổn định theo hướng xác định."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để truyền hoặc ngắt truyền động từ động cơ đến bánh xe chủ động của xe ô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 285",
        "no": 285,
        "content": "Đèn phanh trên xe mô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có tác dụng cảnh báo cho các xe phía sau biết xe đang giảm tốc để chủ động tránh hoặc giảm tốc để tránh va chạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Có tác dụng định vị vào ban đêm với các xe từ phía sau tới để tránh va chạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai ý trên."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/286.PNG", "/resources/images/600bca/286.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 286",
        "no": 286,
        "content": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhiệt độ nước làm mát động cơ quá ngưỡng cho phép."
                ],
                "answer": true
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đang hãm phanh tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cần kiểm tra động cơ."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/287.PNG", "/resources/images/600bca/287.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 287",
        "no": 287,
        "content": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu hệ thống chống bó cứng khi phanh bị lỗi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đang hãm phanh tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cần kiểm tra động cơ."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/288.PNG", "/resources/images/600bca/288.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 288",
        "no": 288,
        "content": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu thiếu dầu phanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đang hãm phanh tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sắp hết nhiên liệu."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/289.PNG", "/resources/images/600bca/289.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 289",
        "no": 289,
        "content": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu hệ thống chống bó cứng phanh bị lỗi."
                ],
                "answer": true
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đang hãm phanh tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sắp hết nhiên liệu."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/290.PNG", "/resources/images/600bca/290.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 290",
        "no": 290,
        "content": "Khi khởi động xe ô tô số tự động có trang bị chìa khóa thông minh có cần đạp hết hành trình bàn đạp chân phanh hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phải đạp hết hành trình bàn đạp chân phanh."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không cần đạp phanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tùy từng trường hợp."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [""],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 291",
        "no": 291,
        "content": "Ắc quy được trang bị trên xe ô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Giúp người lái xe kịp thời tạo xung lực tối đa lên hệ thống phanh trong khoảnh khắc đầu tiên của tình huống khẩn cấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ổn định chuyển động của xe ô tô khi đi vào đường vòng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hỗ trợ người lái xe khởi hành ngang dốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để tích trữ điện năng, cung cấp cho các phụ tải khi máy phát chưa làm việc."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [""],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 292",
        "no": 292,
        "content": "Máy phát điện được trang bị trên xe ô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để phát điện năng cung cấp cho các phụ tải làm việc và nạp điện cho ắc quy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ổn định chuyển động của xe ô tô khi đi vào đường vòng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hỗ trợ người lái xe khởi hành ngang dốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để tích trữ điện năng và cung cấp điện cho các phụ tải làm việc."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [""],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 293",
        "no": 293,
        "content": "Dây đai an toàn được trang bị trên xe ô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Ổn định chuyển động của xe ô tô khi đi vào đường vòng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giữ chặt người lái và hành khách trên ghế ngồi khi xe ô tô đột ngột dừng lại."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": [""],
        "shuffle": false,
        "chapter": 4,
        "tittle": "Câu 294",
        "no": 294,
        "content": "Túi khí được trang bị trên xe ô tô có tác dụng gì dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Giữ chặt người lái và hành khách trên ghế ngồi khi xe ô tô đột ngột dừng lại."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Giảm khả năng va đập của một số bộ phận cơ thể quan trọng với các vật thể trong xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Hấp thụ một phần lực va đập lên người lái và hành khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 2 và ý 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/295.PNG", "/resources/images/600bca/295.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 295",
        "no": 295,
        "content": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây không tắt trong thời gian dài, báo hiệu tình trạng như thế nào của xe ô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhiệt độ nước làm mát động cơ quá ngưỡng cho phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Áp suất lốp không đủ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đang hãm phanh tay."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hệ thống lái gặp sự cố."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/296.PNG", "/resources/images/600bca/296.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 296",
        "no": 296,
        "content": "Trên xe ô tô có trang bị thiết bị như hình vẽ dưới đây có tác dụng gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dùng để kích (hay nâng) xe ô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vặn ốc lắp bánh xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ổn định chuyển động của xe ô tô khi đi vào đường vòng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giữ chặt người lái và hành khách trên ghế ngồi khi xe ô tô đột ngột dừng lại."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/297.PNG", "/resources/images/600bca/297.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 297",
        "no": 297,
        "content": "Trên xe ô tô có trang bị thiết bị như hình vẽ dưới đây, dùng để làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Thay lốp xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chữa cháy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phá cửa kính xe ô tô trong các trường hợp khẩn cấp."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vặn ốc để tháo lắp bánh xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/298.PNG", "/resources/images/600bca/298.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 298",
        "no": 298,
        "content": "Trên xe ô tô có trang bị thiết bị như hình vẽ dưới đây, dùng để làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Thay lốp xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chữa cháy trong các trường hợp hỏa hoạn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cầm máu cho người bị nạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/299.PNG", "/resources/images/600bca/299.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 299",
        "no": 299,
        "content": "Nút bấm biểu tượng như hình vẽ trên xe ô tô có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu xin đường cho xe đi thẳng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu hệ thống phanh bị lỗi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu xe đang ở tình huống nguy hiểm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo hiệu đến thời gian cần bảo dưỡng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/300.PNG", "/resources/images/600bca/300.PNG"],
        "shuffle": true,
        "chapter": 4,
        "tittle": "Câu 300",
        "no": 300,
        "content": "Khi động cơ đã hoạt động, bảng đồng hồ xuất hiện biểu tượng hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu hệ thống túi khí đã bật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu đèn chiếu sáng xa đã bật."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu chế độ lái tiết kiệm nhiên liệu đã bật."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo hiệu đèn cảnh báo khoảng cách đã bật."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/301.PNG", "/resources/images/600bca/301.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 301",
        "no": 301,
        "content": "Biển nào cấm các loại xe cơ giới đi vào, trừ xe máy hai bánh, xe gắn máy và các loại xe ưu tiên theo quy định?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/302.PNG", "/resources/images/600bca/302.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 302",
        "no": 302,
        "content": "Biển nào cấm xe ô tô tải?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/303.PNG", "/resources/images/600bca/303.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 303",
        "no": 303,
        "content": "Biển nào cấm máy kéo?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "xe mô tô ba bánh chở hàng là loại lai giữa mô tô và ô tô, nên nên cấm 2 thằng cha thì thằng lai bị cấm luôn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/304.PNG", "/resources/images/600bca/304.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 304",
        "no": 304,
        "content": "Biển nào báo hiệu cấm xe mô tô ba bánh chở hàng đi qua?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/305.PNG", "/resources/images/600bca/305.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 305",
        "no": 305,
        "content": "Biển nào dưới đây xe gắn máy được phép đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/306.PNG", "/resources/images/600bca/306.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 306",
        "no": 306,
        "content": "Biển nào báo hiệu cấm xe mô tô đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/307.PNG", "/resources/images/600bca/307.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 307",
        "no": 307,
        "content": "Khi gặp biển nào thì xe mô tô hai bánh được đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 3 là chỉ cấm xe tải trên lên vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/308.PNG", "/resources/images/600bca/308.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 308",
        "no": 308,
        "content": "Biển nào cho phép xe ô tô con được vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 3 là chỉ cấm xe tải trên lên vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/309.PNG", "/resources/images/600bca/309.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 309",
        "no": 309,
        "content": "Biển nào không cho phép xe ô tô con vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 2 là cấm tất cả ô tô vượt",
            "Biển 3 là chỉ cấm xe tải trên lên vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/310.PNG", "/resources/images/600bca/310.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 310",
        "no": 310,
        "content": "Biển nào cấm xe ô tô tải vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1 là cấm tất cả ô tô vượt",
            "Biển 2 là chỉ cấm xe tải trên lên vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/311.PNG", "/resources/images/600bca/311.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 311",
        "no": 311,
        "content": "Biển nào cấm xe tải vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1 là cấm tất cả ô tô vượt",
            "Biển 2 là chỉ cấm xe tải trên lên vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/312.PNG", "/resources/images/600bca/312.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 312",
        "no": 312,
        "content": "Biển nào xe ô tô con được phép vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Cấm rẻ trái và Cấm quay đầu là riêng biết, ko ảnh hưởng lẫn nhau"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/313.PNG", "/resources/images/600bca/313.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 313",
        "no": 313,
        "content": "Biển nào cấm quay đầu xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm rẻ trái và Cấm quay đầu là riêng biết, ko ảnh hưởng lẫn nhau"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/314.PNG", "/resources/images/600bca/314.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 314",
        "no": 314,
        "content": "Biển nào cấm xe rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm rẻ trái và Cấm quay đầu là riêng biết, ko ảnh hưởng lẫn nhau"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/315.PNG", "/resources/images/600bca/315.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 315",
        "no": 315,
        "content": "Khi gặp biển nào xe được rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biến 1: cấm tất cả rẻ trái",
            "Biến 2: cấm ô tô quay đầu hoặc rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/316.PNG", "/resources/images/600bca/316.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 316",
        "no": 316,
        "content": "Biển nào cấm xe ô tô rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 3: cấm ô tô rẻ phải hoặc quay đầu"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/317.PNG", "/resources/images/600bca/317.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 317",
        "no": 317,
        "content": "Biển nào cấm các phương tiện rẽ phải?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 3: cấm ô tô rẻ trái hoặc quay đầu"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/318.PNG", "/resources/images/600bca/318.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 318",
        "no": 318,
        "content": "Biển nào cấm các phương tiện rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm ô tô quay đầu",
            "Biển 2: cấm ô tô quay đầu hoặc rẻ trái",
            "Biển 3: cấm ô tô quay đầu hoặc rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/319.PNG", "/resources/images/600bca/319.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 319",
        "no": 319,
        "content": "Biển nào dưới đây chỉ cấm xe ô tô quay đầu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm ô tô quay đầu",
            "Biển 2: cấm ô tô quay đầu hoặc rẻ trái",
            "Biển 3: cấm ô tô quay đầu hoặc rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/320.PNG", "/resources/images/600bca/320.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 320",
        "no": 320,
        "content": "Biển nào dưới đây cấm xe ô tô rẽ trái và quay đầu?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/321.PNG", "/resources/images/600bca/321.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 321",
        "no": 321,
        "content": "Biển nào cấm xe taxi mà không cấm các phương tiện khác?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm rẻ trái",
            "Biển 2: biển chỉ dẫn -> ko cấm gì cả"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/322.PNG", "/resources/images/600bca/322.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 322",
        "no": 322,
        "content": "Biển nào xe được phép rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm rẻ trái -> được quay đầu",
            "Biển 2: biển chỉ dẫn -> được quay đầu"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/323.PNG", "/resources/images/600bca/323.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 323",
        "no": 323,
        "content": "Biển nào xe quay đầu không bị cấm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 2: hiệu lệnh bắt buộc rẻ trái -> không được quay đầu, phải rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/324.PNG", "/resources/images/600bca/324.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 324",
        "no": 324,
        "content": "Biển nào xe được phép quay đầu nhưng không được rẽ trái?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm cả 2 chiều",
            "Biển 2: cấm đi ngược chiều",
            "Biển 3: cấm đỗ xe",
            "Không gọp chung 2 khái niệm 'cấm cả 2 chiều' và 'cấm đi ngược chiều'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/325.PNG", "/resources/images/600bca/325.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 325",
        "no": 325,
        "content": "Biển nào là biển \"Cấm đi ngược chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm đi ngược chiều -> cấm đi vào"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/326.PNG", "/resources/images/600bca/326.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 326",
        "no": 326,
        "content": "Biển nào dưới đây các phương tiện không được phép đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm đỗ xe (tức bao gồm lẻ + chẵn)",
            "Biển 2: cấm đỗ xe ngày lẻ",
            "Biển 3: cấm đỗ xe ngày chẵn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/327.PNG", "/resources/images/600bca/327.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 327",
        "no": 327,
        "content": "Gặp biển nào người lái xe không được đỗ xe vào ngày chẵn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm đỗ xe (tức bao gồm lẻ + chẵn)",
            "Biển 2: cấm đỗ xe ngày lẻ",
            "Biển 3: cấm đỗ xe ngày chẵn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/328.PNG", "/resources/images/600bca/328.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 328",
        "no": 328,
        "content": "Gặp biển nào người lái xe không được đỗ xe vào ngày lẻ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường cấm, trừ xe ưu tiên",
            "Biển 2: dừng lại để quan sát cho an toàn -> thằng nào cũng phải dừng lại",
            "Biển 3: cấm đi ngược chiều, trừ xe ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/329.PNG", "/resources/images/600bca/329.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 329",
        "no": 329,
        "content": "Khi gặp biển nào xe ưu tiên theo luật định vẫn phải dừng lại?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường cấm, trừ xe ưu tiên",
            "Biển 2: dừng lại để quan sát cho an toàn -> quan sát rồi đi tiếp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/330.PNG", "/resources/images/600bca/330.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 330",
        "no": 330,
        "content": "Biển nào cấm tất cả các loại xe cơ giới và thô sơ đi lại trên đường, trừ xe ưu tiên theo luật định (nếu đường vẫn cho xe chạy được)?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Cấm xe tải",
            "Biển 2: Cấm xe tải từ 2.5 tấn",
            "Biển 2: Cấm xe chở hàng nguy hiểm"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/331.PNG", "/resources/images/600bca/331.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 331",
        "no": 331,
        "content": "Biển nào là biển \"Cấm xe chở hàng nguy hiểm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm xe lam",
            "Biển 2: cấm xe xích lô máy",
            "Biển 3: cấm xe xích lô (đạp)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/332.PNG", "/resources/images/600bca/332.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 332",
        "no": 332,
        "content": "Gặp biển nào xe xích lô được phép đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cấm xe lam",
            "Biển 2: cấm xe xích lô máy",
            "Biển 3: cấm xe xích lô (đạp)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/333.PNG", "/resources/images/600bca/333.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 333",
        "no": 333,
        "content": "Gặp biển nào xe lam, xe xích lô máy được phép đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/334.PNG", "/resources/images/600bca/334.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 334",
        "no": 334,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đường cấm súc vật vận tải hàng hóa."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đường cấm súc vật vận tải hành khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đường cấm súc vật vận tải hàng hóa hoặc hành khách dù kéo xe hay chở trên lưng đi qua."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/335.PNG", "/resources/images/600bca/335.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 335",
        "no": 335,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tốc độ tối đa cho phép về ban đêm cho các phương tiện là 70 km/h."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tốc độ tối thiểu cho phép về ban đêm cho các phương tiện là 70 km/h."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Dù là xe ưu tiên mà vượt quá các chỉ số an toàn thì đều ko được phép"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/336.PNG", "/resources/images/600bca/336.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 336",
        "no": 336,
        "content": "Khi gặp các biển này xe ưu tiên theo luật định (có tải trọng hay chiều cao toàn bộ vượt quá chỉ số ghi trên biển) có được phép đi qua hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Chiều cao tối đa của xe và hàng",
            "Biển 2: Tải trọng trên trục xe",
            "Biển 3: Tải trọng toàn bộ xe và hàng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/337.PNG", "/resources/images/600bca/337.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 337",
        "no": 337,
        "content": "Biển nào hạn chế chiều cao của xe và hàng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Chiều cao tối đa của xe và hàng",
            "Biển 2: Tải trọng trên trục xe",
            "Biển 3: Tải trọng toàn bộ xe và hàng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/338.PNG", "/resources/images/600bca/338.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 338",
        "no": 338,
        "content": "Biển số 2 có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cho phép xe ô tô có tải trọng trục lớn hơn 7 tấn đi qua."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cho phép xe ô tô có tải trọng trên trục xe từ 7 tấn trở xuống đi qua."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Chiều cao tối đa của xe và hàng",
            "Biển 2: Tải trọng trên trục xe",
            "Biển 3: Tải trọng toàn bộ xe và hàng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/339.PNG", "/resources/images/600bca/339.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 339",
        "no": 339,
        "content": "Biển số 3 có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cấm các loại xe có tải trọng toàn bộ trên 10 tấn đi qua."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hạn chế khối lượng hàng hóa chở trên xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hạn chế tải trọng trên trục xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/340.PNG", "/resources/images/600bca/340.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 340",
        "no": 340,
        "content": "Biển nào cấm máy kéo kéo theo rơ moóc?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/341.PNG", "/resources/images/600bca/341.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 341",
        "no": 341,
        "content": "Khi gặp biển số 1, xe ô tô tải có được đi vào không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được đi vào."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không được đi vào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/342.PNG", "/resources/images/600bca/342.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 342",
        "no": 342,
        "content": "Biển nào không có hiệu lực đối với xe ô tô tải không kéo moóc?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- P.103a (Xe con): Cấm hết (trừ xe máy 2 bánh)",
            "- P.106a (Xe tải): Cấm tải ->  Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.109 (Máy kéo): Cấm máy kéo ->  Cấm rơ-moóc",
            "- P.108 (Rơ-moóc): Chỉ cấm mình nó",
            "- P.107a (Xe khách): Chỉ cấm xe khách",
            "- P.104 (Xe mô tô): Cấm mô tô (xe gắn máy vẫn được đi)",
            "- P.111a (Xe gắn máy): Xe gắn máy (Xe mô tô vẫn được đi)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/343.PNG", "/resources/images/600bca/343.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 343",
        "no": 343,
        "content": "Biển nào cấm máy kéo?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "xe mô tô ba bánh chở hàng là loại lai giữa mô tô và ô tô, nên nên cấm 2 thằng cha thì thằng lai bị cấm luôn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/344.PNG", "/resources/images/600bca/344.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 344",
        "no": 344,
        "content": "Khi gặp biển này, xe mô tô ba bánh chở hàng có được phép rẽ trái hoặc rẽ phải hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "xe mô tô ba bánh chở hàng là loại lai giữa mô tô và ô tô, nên nên cấm 2 thằng cha thì thằng lai bị cấm luôn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/345.PNG", "/resources/images/600bca/345.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 345",
        "no": 345,
        "content": "Biển này có hiệu lực đối với xe mô tô hai bánh, ba bánh chở hàng không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/346.PNG", "/resources/images/600bca/346.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 346",
        "no": 346,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cấm xe cơ giới (trừ xe ưu tiên theo luật định) đi thẳng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cấm các loại xe cơ giới và xe mô tô (trừ xe ưu tiên theo luật định) đi về bên trái và bên phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng trái và phải không cấm xe cơ giới."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/347.PNG", "/resources/images/600bca/347.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 347",
        "no": 347,
        "content": "Biển phụ đặt dưới biển cấm bóp còi có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo khoảng cách đến nơi cấm bóp còi."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chiều dài đoạn đường cấm bóp còi từ nơi đặt biển."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo cấm dùng còi có độ vang xa 500m."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/348.PNG", "/resources/images/600bca/348.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 348",
        "no": 348,
        "content": "Chiều dài đoạn đường 500 m từ nơi đặt biển này, người lái xe có được phép bấm còi không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/349.PNG", "/resources/images/600bca/349.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 349",
        "no": 349,
        "content": "Biển nào xe mô tô hai bánh được đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/350.PNG", "/resources/images/600bca/350.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 350",
        "no": 350,
        "content": "Biển nào xe mô tô hai bánh không được đi vào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/351.PNG", "/resources/images/600bca/351.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 351",
        "no": 351,
        "content": "Ba biển này có hiệu lực như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cấm các loại xe ở biển phụ đi vào."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cấm các loại xe cơ giới đi vào trừ loại xe ở biển phụ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển phụ có mũi tên: bảng chính có hiệu lực ngay lập tức tới số liệu ghi trên bảng phụ",
            "biển phụ KHÔNG có mũi tên: bảng chính có hiệu lực sau số liệu ghi trên bảng phụ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/352.PNG", "/resources/images/600bca/352.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 352",
        "no": 352,
        "content": "Biển nào báo hiệu chiều dài đoạn đường phải giữ cự ly tối thiểu giữa hai xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1. "
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2. "
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển phụ có mũi tên: bảng chính có hiệu lực ngay lập tức tới số liệu ghi trên bảng phụ",
            "biển phụ KHÔNG có mũi tên: bảng chính có hiệu lực sau số liệu ghi trên bảng phụ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/353.PNG", "/resources/images/600bca/353.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 353",
        "no": 353,
        "content": "Biển nào báo hiệu khoảng cách thực tế từ nơi đặt biển đến nơi cần cự ly tối thiểu giữa hai xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/354.PNG", "/resources/images/600bca/354.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 354",
        "no": 354,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cấm dừng xe về hướng bên trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cấm dừng và đỗ xe theo hướng bên phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được phép đỗ xe và dừng xe theo hướng bên phải."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/355.PNG", "/resources/images/600bca/355.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 355",
        "no": 355,
        "content": "Theo hướng bên phải có được phép đỗ xe, dừng xe không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'lớn hơn' -> ko được phép"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/356.PNG", "/resources/images/600bca/356.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 356",
        "no": 356,
        "content": "Gặp biển này, xe ô tô sơ mi rơ moóc có chiều dài toàn bộ kể cả xe, moóc và hàng lớn hơn trị số ghi trên biển có được phép đi vào hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'quá' -> lớn hơn --> ko được phép"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/357.PNG", "/resources/images/600bca/357.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 357",
        "no": 357,
        "content": "Xe ô tô chở hàng vượt quá phía trước và sau thùng xe, mỗi phía quá 10% chiều dài toàn bộ thân xe, tổng chiều dài xe (cả hàng) từ trước đến sau nhỏ hơn trị số ghi trên biển thì có được phép đi vào không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không được phép."
                ],
                "answer": true
            },
            {
                "option": [
                    "Được phép."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/358.PNG", "/resources/images/600bca/358.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 358",
        "no": 358,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cấm ô tô buýt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cấm xe ô tô khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cấm xe ô tô con."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/359.PNG", "/resources/images/600bca/359.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 359",
        "no": 359,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hạn chế chiều cao của xe và hàng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hạn chế chiều ngang của xe và hàng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hạn chế chiều dài của xe và hàng."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/360.PNG", "/resources/images/600bca/360.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 360",
        "no": 360,
        "content": "Biển nào là biển \"Tốc độ tối đa cho phép về ban đêm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/361.PNG", "/resources/images/600bca/361.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 361",
        "no": 361,
        "content": "Biển báo nào báo hiệu bắt đầu đoạn đường vào phạm vi khu dân cư, các phương tiện tham gia giao thông phải tuân theo các quy định đi đường được áp dụng ở khu đông dân cư?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: tốc độ tối thiểu",
            "Biển 2: tốc độ tối đa"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/362.PNG", "/resources/images/600bca/362.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 362",
        "no": 362,
        "content": "Biển nào báo hiệu hạn chế tốc độ của phương tiện không vượt quá trị số ghi trên biển?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/363.PNG", "/resources/images/600bca/363.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 363",
        "no": 363,
        "content": "Trong các biển báo dưới đây biển nào báo hiệu \"Kết thúc đường cao tốc\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/364.PNG", "/resources/images/600bca/364.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 364",
        "no": 364,
        "content": "Số 50 ghi trên biển báo dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tốc độ tối đa các xe cơ giới được phép chạy."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tốc độ tối thiểu các xe cơ giới được phép chạy."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/365.PNG", "/resources/images/600bca/365.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 365",
        "no": 365,
        "content": "Biển nào dưới đây chỉ dẫn bắt đầu đường cao tốc phân làn đường có tốc độ khác nhau?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/366.PNG", "/resources/images/600bca/366.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 366",
        "no": 366,
        "content": "Biển báo dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu tốc độ tối đa cho phép các xe cơ giới chạy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu tốc độ tối thiểu cho phép các xe cơ giới chạy."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cảnh báo người đi bộ",
            "Biển 2: cấm người đi bộ",
            "Biển 3: hiệu lệnh đường dành cho người đi bộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/367.PNG", "/resources/images/600bca/367.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 367",
        "no": 367,
        "content": "Gặp biển nào người lái xe phải nhường đường cho người đi bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cảnh báo người đi bộ",
            "Biển 2: cấm người đi bộ",
            "Biển 3: hiệu lệnh đường dành cho người đi bộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/368.PNG", "/resources/images/600bca/368.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 368",
        "no": 368,
        "content": "Biển nào chỉ đường dành cho người đi bộ, các loại xe không được đi vào khi gặp biển này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường dành cho xe thô sơ",
            "Biển 2: cấm xe đạp",
            "Biển 3: cảnh báo có xe đạp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/369.PNG", "/resources/images/600bca/369.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 369",
        "no": 369,
        "content": "Biển nào báo hiệu \"Đường dành cho xe thô sơ\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau có rào chắn",
            "Biển 2: giao nhau với đường ưu tiên",
            "Biển 3: giao nhau có tính hiệu đèn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/370.PNG", "/resources/images/600bca/370.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 370",
        "no": 370,
        "content": "Biển nào báo hiệu sắp đến chỗ giao nhau nguy hiểm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau có rào chắn",
            "Biển 2: giao nhau với đường ưu tiên",
            "Biển 3: giao nhau có tính hiệu đèn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/371.PNG", "/resources/images/600bca/371.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 371",
        "no": 371,
        "content": "Biển nào báo hiệu \"Giao nhau với đường sắt có rào chắn\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau có rào chắn",
            "Biển 2: giao nhau với đường ưu tiên",
            "Biển 3: giao nhau có tính hiệu đèn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/372.PNG", "/resources/images/600bca/372.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 372",
        "no": 372,
        "content": "Biển nào báo hiệu \"Giao nhau có tín hiệu đèn\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau với đường sắt có rào",
            "Biển 2: giao nhau với đường 2 chiều",
            "Biển 3: giao nhau với đường sắt không rào"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/373.PNG", "/resources/images/600bca/373.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 373",
        "no": 373,
        "content": "Biển nào báo hiệu nguy hiểm giao nhau với đường sắt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau với đường sắt có rào",
            "Biển 2: giao nhau với đường sắt không rào",
            "Biển 3: giao nhau với đường sắt không rào"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/374.PNG", "/resources/images/600bca/374.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 374",
        "no": 374,
        "content": "Biển nào báo hiệu đường bộ giao nhau với đường sắt không có rào chắn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao nhau với đường sắt không rào",
            "Biển 2: giao nhau với đường ưu tiên",
            "Biển 3: giao nhau với đường tàu điện"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/375.PNG", "/resources/images/600bca/375.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 375",
        "no": 375,
        "content": "Biển nào báo hiệu sắp đến chỗ giao nhau giữa đường bộ và đường sắt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: sắp đến đường có cầu vòng lớn",
            "Biển 2: cửa chui",
            "Biển 3: hầm chui"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/376.PNG", "/resources/images/600bca/376.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 376",
        "no": 376,
        "content": "Biển nào báo hiệu \"Cửa chui\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đường sắt và đường bộ ko cùng mức, 2 biển này báo ko có rào chắn và giao vuông góc"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/377.PNG", "/resources/images/600bca/377.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 377",
        "no": 377,
        "content": "Hai biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để chỉ nơi đường sắt giao vuông góc với đường bộ không có rào chắn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để báo trước sắp đến vị trí giao cắt đường bộ với đường sắt cùng mức, không vuông góc và không có người gác, không có rào chắn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi đường sắt giao nhau với đường bộ."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1 và 2: giao vuông góc với đường sắt ko có rào chắn",
            "Biển 3: giao ko vuông góc với đường sắt ko có rào chắn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/378.PNG", "/resources/images/600bca/378.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 378",
        "no": 378,
        "content": "Biển nào báo hiệu \"Nơi đường sắt giao vuông góc với đường bộ\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/379.PNG", "/resources/images/600bca/379.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 379",
        "no": 379,
        "content": "Các biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nơi đường sắt giao nhau với đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nơi đường sắt giao vuông góc với đường bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để báo trước sắp đến vị trí đường sắt giao không vuông góc với đường bộ, không có người gác và không có rào chắn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao nhau với đường nhánh",
            "Biển 2: giao nhau với đường chính",
            "Biển 3: Hết đoạn đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/380.PNG", "/resources/images/600bca/380.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 380",
        "no": 380,
        "content": "Biển nào báo hiệu \"Hết đoạn đường ưu tiên\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao nhau với đường nhánh",
            "Biển 2: giao nhau với đường chính",
            "Biển 3: bắt đầu đoạn đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/381.PNG", "/resources/images/600bca/381.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 381",
        "no": 381,
        "content": "Biển nào báo hiệu, chỉ dẫn xe đi trên đường này được quyền ưu tiên qua nơi giao nhau?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao nhau với đường nhánh",
            "Biển 2: giao nhau với đường chính",
            "Biển 3: bắt đầu đoạn đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/382.PNG", "/resources/images/600bca/382.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 382",
        "no": 382,
        "content": "Biển nào báo hiệu \"Giao nhau với đường không ưu tiên\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao nhau với đường nhánh",
            "Biển 2: giao nhau với đường chính",
            "Biển 3: bắt đầu đoạn đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/383.PNG", "/resources/images/600bca/383.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 383",
        "no": 383,
        "content": "Biển nào báo hiệu \"Giao nhau với đường ưu tiên\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường hẹp 2 bên",
            "Biển 2: đường hẹp bên trái",
            "Biển 3: đường cong"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/384.PNG", "/resources/images/600bca/384.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 384",
        "no": 384,
        "content": "Biển nào báo hiệu \"Đường bị thu hẹp\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết đoạn đường có dãy phân cách",
            "Biển 2: đường hẹp bên trái",
            "Biển 3: đường hẹp bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/385.PNG", "/resources/images/600bca/385.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 385",
        "no": 385,
        "content": "Khi gặp biển nào, người lái xe phải giảm tốc độ, chú ý xe đi ngược chiều, xe đi ở phía đường bị hẹp phải nhường đường cho xe đi ngược chiều?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao đường cùng cấp",
            "Biển 2: Giao đường nhánh",
            "Biển 3: Giao đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/386.PNG", "/resources/images/600bca/386.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 386",
        "no": 386,
        "content": "Biển nào báo hiệu \"Giao nhau với đường ưu tiên\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao đường cùng cấp",
            "Biển 2: Giao đường nhánh",
            "Biển 3: Giao đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/387.PNG", "/resources/images/600bca/387.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 387",
        "no": 387,
        "content": "Biển nào báo hiệu \"Đường giao nhau\" của các tuyến đường cùng cấp?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Giao đường cùng cấp",
            "Biển 2: Giao đường nhánh",
            "Biển 3: Giao đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/388.PNG", "/resources/images/600bca/388.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 388",
        "no": 388,
        "content": "Biển nào báo hiệu \"Giao nhau với đường không ưu tiên\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: đường hẹp phía mình, cần nhường đường",
            "Biển 3: đường hẹp, mình được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/389.PNG", "/resources/images/600bca/389.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 389",
        "no": 389,
        "content": "Biển nào báo hiệu \"Đường hai chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: đường hẹp phía mình, cần nhường đường",
            "Biển 3: đường hẹp, mình được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/390.PNG", "/resources/images/600bca/390.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 390",
        "no": 390,
        "content": "Biển nào báo hiệu phải giảm tốc độ, nhường đường cho xe cơ giới đi ngược chiều qua đường hẹp?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: đường hẹp phía mình, cần nhường đường",
            "Biển 3: đường hẹp, mình được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/391.PNG", "/resources/images/600bca/391.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 391",
        "no": 391,
        "content": "Biển nào chỉ dẫn \"Được ưu tiên qua đường hẹp\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường hẹp, mình được ưu tiên",
            "Biển 2: vào đường đôi",
            "Biển 3: hét đường đôi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/392.PNG", "/resources/images/600bca/392.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 392",
        "no": 392,
        "content": "Biển nào báo hiệu \"Đường đôi\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: giao với đường 2 chiều",
            "Biển 3: vào đường đôi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/393.PNG", "/resources/images/600bca/393.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 393",
        "no": 393,
        "content": "Biển nào báo hiệu \"Đường đôi\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: vào đường đôi",
            "Biển 3: hết đường đôi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/394.PNG", "/resources/images/600bca/394.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 394",
        "no": 394,
        "content": "Biển nào báo hiệu \"Kết thúc đường đôi\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao đường 2 chiều",
            "Biển 2: vào đường đôi",
            "Biển 3: giao cùng cấp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/395.PNG", "/resources/images/600bca/395.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 395",
        "no": 395,
        "content": "Biển nào báo hiệu \"Giao nhau với đường hai chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: giao cùng cấp",
            "Biển 2: đường 2 chiều",
            "Biển 3: hết đường đôi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/396.PNG", "/resources/images/600bca/396.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 396",
        "no": 396,
        "content": "Biển nào báo hiệu \"Đường hai chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: đường 2 chiều",
            "Biển 2: giao đường 2 chiều",
            "Biển 3: giao cùng cấp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/397.PNG", "/resources/images/600bca/397.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 397",
        "no": 397,
        "content": "Biển nào báo hiệu \"Giao nhau với đường hai chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết đường đôi",
            "Biển 2: có chướng ngại vật, có thể đi 2 bên",
            "Biển 3: có chướng ngại vật, đi về bên trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/398.PNG", "/resources/images/600bca/398.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 398",
        "no": 398,
        "content": "Biển nào báo hiệu \"Chú ý chướng ngại vật\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/399.PNG", "/resources/images/600bca/399.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 399",
        "no": 399,
        "content": "Biển nào chỉ dẫn cho người tham gia giao thông biết vị trí và khoảng cách có làn đường cứu nạn hay làn thoát xe khẩn cấp?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cửa chui",
            "Biển 2: hầm chui",
            "Biển 3: sắp đến đường có cầu vòng lớn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/400.PNG", "/resources/images/600bca/400.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 400",
        "no": 400,
        "content": "Biển nào báo hiệu \"Đường hầm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cầu tạm",
            "Biển 2: cầu hẹp",
            "Biển 3: cầu xoay, cầu cất"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/401.PNG", "/resources/images/600bca/401.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 401",
        "no": 401,
        "content": "Biển nào dưới đây là biển \"Cầu hẹp\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cầu tạm",
            "Biển 2: cầu hẹp",
            "Biển 3: cầu xoay, cầu cất"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/402.PNG", "/resources/images/600bca/402.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 402",
        "no": 402,
        "content": "Biển nào dưới đây là biển \"Cầu quay - cầu cất\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Kè, vực sâu phía trước",
            "Biển 2: Kè, vực sâu phía phải",
            "Biển 3: Kè, vực sâu phía trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/403.PNG", "/resources/images/600bca/403.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 403",
        "no": 403,
        "content": "Biển nào dưới đây là biển \"Kè, vực sâu phía trước\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Kè, vực sâu phía trước",
            "Biển 2: Kè, vực sâu phía phải",
            "Biển 3: Kè, vực sâu phía trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/404.PNG", "/resources/images/600bca/404.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 404",
        "no": 404,
        "content": "Biển nào sau đây là biển \"Kè, vực sâu bên đường phía bên trái\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Kè, vực sâu phía trước",
            "Biển 2: Kè, vực sâu phía phải",
            "Biển 3: Kè, vực sâu phía trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/405.PNG", "/resources/images/600bca/405.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 405",
        "no": 405,
        "content": "Biển nào sau đây là biển \"Kè, vực sâu bên đường phía bên phải\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: nguy cơ lật xe bên phải",
            "Biển 2: Đường trơn",
            "Biển 3: Bến phà"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/406.PNG", "/resources/images/600bca/406.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 406",
        "no": 406,
        "content": "Biển nào sau đây là biển \"Đường trơn\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Kè, vực sâu phía phải",
            "Biển 2: Lề đường nguy hiểm",
            "Biển 3: nguy cơ lật xe bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/407.PNG", "/resources/images/600bca/407.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 407",
        "no": 407,
        "content": "Biển nào sau đây là biển \"Lề đường nguy hiểm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: gần tới đoạn đường đang thi công",
            "Biển 2: nguy cơ sạt lỡ",
            "Biển 3: nguy cơ đá văng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/408.PNG", "/resources/images/600bca/408.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 408",
        "no": 408,
        "content": "Biển nào sau đây báo trước gần tới đoạn đường đang tiến hành thi công sửa chữa?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: cảnh báo ùn tắc",
            "Biển 2: đoạn đường thường xảy ra tai nạn",
            "Biển 3: nguy cơ lật xe bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/409.PNG", "/resources/images/600bca/409.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 409",
        "no": 409,
        "content": "Biển nào sau đây cảnh báo nguy hiểm đoạn đường thường xảy ra tai nạn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hầm chui",
            "Biển 2: cảnh báo ùn tắc",
            "Biển 3: đoạn đường thường xảy ra tai nạn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/410.PNG", "/resources/images/600bca/410.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 410",
        "no": 410,
        "content": "Biển nào dưới đây báo hiệu đoạn đường hay xảy ra ùn tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: người đi bộ",
            "Biển 2: trẻ em"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/411.PNG", "/resources/images/600bca/411.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 411",
        "no": 411,
        "content": "Gặp biển nào người tham gia giao thông phải đi chậm và thận trọng đề phòng khả năng xuất hiện và di chuyển bất ngờ của trẻ em trên mặt đường?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: người đi bộ",
            "Biển 2: đường đi bộ",
            "Biển 3: trẻ em"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/412.PNG", "/resources/images/600bca/412.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 412",
        "no": 412,
        "content": "Biển nào chỉ dẫn nơi bắt đầu đoạn đường dành cho người đi bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: người đi bộ",
            "Biển 2: trẻ em",
            "Biển 3: xe đạp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/413.PNG", "/resources/images/600bca/413.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 413",
        "no": 413,
        "content": "Biển nào dưới đây báo hiệu gần đến đoạn đường thường có trẻ em đi ngang qua?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: gió thổi",
            "Biển 2: nguy cơ lật xe bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/414.PNG", "/resources/images/600bca/414.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 414",
        "no": 414,
        "content": "Gặp biển nào dưới đây người tham gia giao thông cần phải điều chỉnh tốc độ xe chạy cho thích hợp, đề phòng gió ngang thổi mạnh gây lật xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biến 1: xuống dốc",
            "Biển 2: lên dốc"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/415.PNG", "/resources/images/600bca/415.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 415",
        "no": 415,
        "content": "Biển nào sau đây là biển \"Dốc xuống nguy hiểm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biến 1: xuống dốc",
            "Biển 2: lên dốc"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/416.PNG", "/resources/images/600bca/416.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 416",
        "no": 416,
        "content": "Biển nào sau đây là biển \"Dốc lên nguy hiểm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/417.PNG", "/resources/images/600bca/417.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 417",
        "no": 417,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỗ ngoặt nguy hiểm có nguy cơ lật xe bên phải khi đường cong vòng sang trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỗ ngoặt nguy hiểm có nguy cơ lật xe bên trái khi đường cong vòng sang phải."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/418.PNG", "/resources/images/600bca/418.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 418",
        "no": 418,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo trước đoạn đường có gió ngang."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo trước đoạn đường trơn trượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo trước sắp đến bến phà."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/419.PNG", "/resources/images/600bca/419.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 419",
        "no": 419,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu đường có ổ gà, lồi lõm."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo hiệu đường có gồ giảm tốc phía trước."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/420.PNG", "/resources/images/600bca/420.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 420",
        "no": 420,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu đường có ổ gà, lồi lõm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu đường có gồ giảm tốc phía trước."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/421.PNG", "/resources/images/600bca/421.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 421",
        "no": 421,
        "content": "Biển báo dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để báo trước gần tới đoạn đường có hiện tượng đất đá từ trên ta luy dương sụt lở bất ngờ gây nguy hiểm cho xe cộ và người đi đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để báo trước nơi có kết cấu mặt đường rời rạc, khi phương tiện đi qua, làm cho các viên đá, sỏi văng lên gây nguy hiểm và mất an toàn cho người và phương tiện tham gia giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để cảnh báo những đoạn nền đường yếu, đoạn đường đang theo dõi lún mà việc vận hành xe ở tốc độ cao có thể gây nguy hiểm."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/422.PNG", "/resources/images/600bca/422.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 422",
        "no": 422,
        "content": "Các biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để báo trước gần tới đoạn đường có hiện tượng đất đá từ trên ta luy dương sụt lở bất ngờ gây nguy hiểm cho xe cộ và người đi đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để báo trước nơi có kết cấu mặt đường rời rạc, khi phương tiện đi qua, làm cho các viên đá, sỏi văng lên gây nguy hiểm và mất an toàn cho người và phương tiện tham gia giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để cảnh báo những đoạn nền đường yếu, đoạn đường đang theo dõi lún mà việc vận hành xe ở tốc độ cao có thể gây nguy hiểm."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'đá, sỏi văng'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/423.PNG", "/resources/images/600bca/423.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 423",
        "no": 423,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để báo trước gần tới đoạn đường có hiện tượng đất đá từ trên ta luy dương sụt lở bất ngờ gây nguy hiểm cho xe cộ và người đi đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Để báo trước nơi có kết cấu mặt đường rời rạc, khi phương tiện đi qua, làm cho các viên đá, sỏi văng lên gây nguy hiểm và mất an toàn cho người và phương tiện tham gia giao thông."
                ],
                "answer": true
            },
            {
                "option": [
                    "Để cảnh báo những đoạn nền đường yếu, đoạn đường đang theo dõi lún mà việc vận hành xe ở tốc độ cao có thể gây nguy hiểm."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/424.PNG", "/resources/images/600bca/424.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 424",
        "no": 424,
        "content": "Gặp biển báo này người lái xe phải xử lý thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi chậm, quan sát và dừng lại nếu gặp gia súc trên đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bấm còi to để gia súc tránh đường và nhanh chóng di chuyển qua đoạn đường có gia súc."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/425.PNG", "/resources/images/600bca/425.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 425",
        "no": 425,
        "content": "Biển báo này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo hiệu khu vực nguy hiểm thường xuyên có sét đánh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu khu vực có đường dây điện cắt ngang phía trên tuyến đường."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỉ quy định tốc độ theo làn",
            "Biến 2: quy định tốc độ và phương tiện làn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/426.PNG", "/resources/images/600bca/426.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 426",
        "no": 426,
        "content": "Biển nào báo hiệu các phương tiện phải đi đúng làn đường quy định và tuân thủ tốc độ tối đa cho phép?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỉ quy định tốc độ theo làn",
            "Biến 2: quy định tốc độ và phương tiện làn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/427.PNG", "/resources/images/600bca/427.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 427",
        "no": 427,
        "content": "Biển nào báo hiệu các phương tiện phải tuân thủ tốc độ tối đa cho phép trên từng làn đường?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt đầu đường dành cho ô tô",
            "Biến 2: hết đường dành cho ô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/428.PNG", "/resources/images/600bca/428.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 428",
        "no": 428,
        "content": "Biển nào báo hiệu \"Đường dành cho xe ô tô\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt đầu đường dành cho ô tô",
            "Biến 2: hết đường dành cho ô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/429.PNG", "/resources/images/600bca/429.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 429",
        "no": 429,
        "content": "Biển nào báo hiệu \"Hết đoạn đường dành cho xe ô tô\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt đầu đường dành cho ô tô, mô tô",
            "Biến 2: hết đường dành cho ô tô, mô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/430.PNG", "/resources/images/600bca/430.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 430",
        "no": 430,
        "content": "Khi gặp biển nào thì các phương tiện không được đi vào, trừ xe ô tô và xe mô tô?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/431.PNG", "/resources/images/600bca/431.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 431",
        "no": 431,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ hướng đi phải theo."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển báo hiệu cho người lái xe biết số lượng làn đường trên mặt đường và hướng đi trên mỗi làn đường phải theo."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ hướng đường phải theo."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt buộc đi thẳng (có thể đặt trước hoặc sau giao lộ)",
            "Biển 2: bắt buộc rẻ trái hoặc phải (chỉ được đặt sau giao lộ)"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/432.PNG", "/resources/images/600bca/432.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 432",
        "no": 432,
        "content": "Biển nào (đặt trước ngã ba, ngã tư) cho phép xe được rẽ sang hướng khác?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt buộc đi thẳng (có thể đặt trước hoặc sau giao lộ)",
            "Biển 2: báo hiệu được 1 chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/433.PNG", "/resources/images/600bca/433.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 433",
        "no": 433,
        "content": "Biển nào báo hiệu \"Hướng đi thẳng phải theo\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt buộc đi thẳng (có thể đặt trước hoặc sau giao lộ)",
            "Biển 2: báo hiệu được 1 chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/434.PNG", "/resources/images/600bca/434.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 434",
        "no": 434,
        "content": "Biển nào báo hiệu \"Đường một chiều\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết giới hạn tốc độ tối đa 50",
            "Biển 2: hết mọi lệnh cấm",
            "Biển 3: Hết giới hạn tốc độc tối thiểu 60",
            "Chú ý câu hỏi ý nghĩa trong nháy kép, nếu hỏi gặp biển nào thì hết giới hạn tốc độ thì gồm cả 2 biển 1 và 2"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/435.PNG", "/resources/images/600bca/435.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 435",
        "no": 435,
        "content": "Trong các biển dưới đây biển nào là biển \"Hết tốc độ tối đa cho phép\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết giới hạn tốc độ tối đa 50",
            "Biển 2: hết mọi lệnh cấm",
            "Biển 3: Hết giới hạn tốc độc tối thiểu 60"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/436.PNG", "/resources/images/600bca/436.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 436",
        "no": 436,
        "content": "Hiệu lực của biển \"Tốc độ tối đa cho phép\" hết tác dụng khi gặp biển nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết giới hạn tốc độ tối đa 50",
            "Biển 2: hết mọi lệnh cấm",
            "Biển 3: Hết giới hạn tốc độc tối thiểu 60",
            "Lưu ý việc hỏi ý nghĩa của biển trong nháy kép"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/437.PNG", "/resources/images/600bca/437.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 437",
        "no": 437,
        "content": "Trong các biển dưới đây biển nào là biển \"Hết tốc độ tối thiểu\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết giới hạn tốc độ tối đa 50",
            "Biển 2: hết mọi lệnh cấm",
            "Biển 3: Hết cấm vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/438.PNG", "/resources/images/600bca/438.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 438",
        "no": 438,
        "content": "Biển nào dưới đây báo hiệu hết cấm vượt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết giới hạn tốc độ tối đa 50",
            "Biển 2: hết mọi lệnh cấm",
            "Biển 3: Hết giới hạn tốc độc tối thiểu 60"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/439.PNG", "/resources/images/600bca/439.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 439",
        "no": 439,
        "content": "Trong các biển dưới đây biển nào là biển \"Hết mọi lệnh cấm\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: bắt buộc rẻ trái (trước giao lộ)",
            "Biển 2: bắt buộc rẻ trái hoặc phải (sau giao lộ)",
            "Biển 3: bắt buộc rẻ trái, hoặc đi thẳng (trước giao lộ)",
            "Biển 1 chỉ có rẻ trái, biển 2 đặt sau giao lộ, biển 3 đặt trước giao lộ và cho phép quay đầu tại giao lộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/440.PNG", "/resources/images/600bca/440.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 440",
        "no": 440,
        "content": "Biển nào cho phép được quay đầu xe đi theo hướng ngược lại khi đặt biển trước ngã ba, ngã tư?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1 chỉ cho rẻ trái",
            "biển 2 bắt rẻ trái hoặc phải hoặc quay đầu",
            "biển 3 bắt rẻ phải hoặc đi thẳng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/441.PNG", "/resources/images/600bca/441.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 441",
        "no": 441,
        "content": "Biển nào không cho phép rẽ phải?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1 bắt rẻ trái",
            "biển 2 bắt trái hoặc phải hoặc quay đầu",
            "biển 3 bắt thẳng hoặc phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/442.PNG", "/resources/images/600bca/442.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 442",
        "no": 442,
        "content": "Khi đến chỗ giao nhau, gặp biển nào thì người lái xe không được cho xe đi thẳng, phải rẽ sang hướng khác?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỗ quay đầu xe",
            "Biển 2: khu vực quay đầu xe"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/443.PNG", "/resources/images/600bca/443.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 443",
        "no": 443,
        "content": "Biển nào cho phép quay đầu xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Khu vưc cấm đỗ xe",
            "Biển 2: Khu vực cấm đỗ xe theo giờ",
            "Biển 3: Tên đường đối ngoại"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/444.PNG", "/resources/images/600bca/444.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 444",
        "no": 444,
        "content": "Biển nào chỉ dẫn tên đường trên các tuyến đường đối ngoại?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: hết khu vực cấm đổ xe theo giờ",
            "Biển 2: hết khu vực cấm đổ xe",
            "BIển 3: hết khu vực đổ xe"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/445.PNG", "/resources/images/600bca/445.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 445",
        "no": 445,
        "content": "Biển số 1 có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển chỉ dẫn hết cấm đỗ xe theo giờ trong khu vực."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển chỉ dẫn hết hiệu lực khu vực đỗ xe trên các tuyến đường đối ngoại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển chỉ dẫn khu vực đỗ xe trên các tuyến đường đối ngoại."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Khu vưc cấm đỗ xe",
            "Biển 2: hết khu vực đổ xe",
            "Biển 3: khu vực tốc độ tối đa 50"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/446.PNG", "/resources/images/600bca/446.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 446",
        "no": 446,
        "content": "Biển số 3 có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển chỉ dẫn khu vực cấm đỗ xe trên các tuyến đường đối ngoại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển chỉ dẫn khu vực đỗ xe trên các tuyến đường đối ngoại."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển hạn chế tốc độ tối đa trong khu vực."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển chỉ dẫn hết hiệu lực khu vực cấm đỗ xe theo giờ trên các tuyến đường đối ngoại."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: làn đường cho ô tô",
            "BIển 2: phía trước có làn riêng xe khách ngược chiều",
            "Biển 3: rẻ phải là làn riêng cho xe khách",
            "chú ý: phía trước có nghĩa là thẳng tới phía trước"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/447.PNG", "/resources/images/600bca/447.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 447",
        "no": 447,
        "content": "Biển nào báo hiệu \"Đường phía trước có làn đường dành cho ô tô khách\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: làn đường cho ô tô",
            "BIển 2: phía trước có làn riêng xe khách ngược chiều",
            "Biển 3: rẻ phải là làn riêng cho xe khách",
            "chú ý: phía trước có nghĩa là thẳng tới phía trước"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/448.PNG", "/resources/images/600bca/448.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 448",
        "no": 448,
        "content": "Biển nào báo hiệu \"Rẽ ra đường có làn đường dành cho ô tô khách\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 3 không có nơi giao nhau nên ko đúng ý câu hỏi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/449.PNG", "/resources/images/600bca/449.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 449",
        "no": 449,
        "content": "Biển nào đặt trên đường chính trước khi đến nơi đường giao nhau để rẽ vào đường cụt?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỉ dẫn đi bộ dùng cầu vượt",
            "Biển 2: chỉ dẫn đi bộ dùng hầm chui"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/450.PNG", "/resources/images/600bca/450.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 450",
        "no": 450,
        "content": "Biển nào chỉ dẫn cho người đi bộ sử dụng cầu vượt qua đường?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỉ dẫn đi bộ dùng cầu vượt",
            "Biển 2: chỉ dẫn đi bộ dùng hầm chui"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/451.PNG", "/resources/images/600bca/451.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 451",
        "no": 451,
        "content": "Biển nào chỉ dẫn cho người đi bộ sử dụng hầm chui qua đường?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không biển nào."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: làn dành cho xe thô sơ",
            "Biển 2: nơi đỗ xe cho người khuyết tật",
            "Biển 3: làn dành cho người đi bộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/452.PNG", "/resources/images/600bca/452.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 452",
        "no": 452,
        "content": "Biển nào báo hiệu \"Nơi đỗ xe dành cho người khuyết tật\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ dẫn đổ xe như hình"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/453.PNG", "/resources/images/600bca/453.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 453",
        "no": 453,
        "content": "Gặp biển báo này, người lái xe phải đỗ xe như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đỗ xe hoàn toàn trên hè phố."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đỗ xe hoàn toàn dưới lòng đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đỗ từ 1/2 thân xe trở lên trên hè phố."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "giảm tốc độ + ko được vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/454.PNG", "/resources/images/600bca/454.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 454",
        "no": 454,
        "content": "Gặp biển báo này, người tham gia giao thông phải xử lý như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Dừng xe tại khu vực có trạm Cảnh sát giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tiếp tục lưu thông với tốc độ bình thường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phải giảm tốc độ đến mức an toàn và không được vượt khi đi qua khu vực này."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "chạy theo vòng xuyến"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/455.PNG", "/resources/images/600bca/455.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 455",
        "no": 455,
        "content": "Gặp biển báo dưới đây, người lái xe có bắt buộc phải chạy vòng theo đảo an toàn theo hướng mũi tên khi muốn chuyển hướng hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bắt buộc."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không bắt buộc."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: chỉ hướng đi",
            "Biển 2: địa phận hành chính",
            "Biển 3: chỉ địa danh, ko phải địa phận hành chính"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/456.PNG", "/resources/images/600bca/456.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 456",
        "no": 456,
        "content": "Biển nào dưới đây chỉ dẫn địa giới hành chính giữa các thành phố, tỉnh, huyện?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cầu vượt liên thông là biển báo chỉ dẫn, hình chữ nhật",
            "Cầu vượt cắt qua là biển báo hiểu lệnh, hình tròn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/457.PNG", "/resources/images/600bca/457.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 457",
        "no": 457,
        "content": "Biển nào báo hiệu \"Cầu vượt liên thông\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cầu vượt liên thông là biển báo chỉ dẫn, hình chữ nhật",
            "Cầu vượt cắt qua là biển báo hiểu lệnh, hình tròn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/458.PNG", "/resources/images/600bca/458.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 458",
        "no": 458,
        "content": "Biển số 1 có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi thẳng hoặc rẽ trái trên cầu vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi thẳng hoặc rẽ phải trên cầu vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu cầu vượt liên thông."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Cầu vượt liên thông là biển báo chỉ dẫn, hình chữ nhật",
            "Cầu vượt cắt qua là biển báo hiểu lệnh, hình tròn",
            "Biển 3: đường có độ vòng lớn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/459.PNG", "/resources/images/600bca/459.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 459",
        "no": 459,
        "content": "Biển nào báo hiệu \"Tuyến đường cầu vượt cắt qua\"?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2 và biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/460.PNG", "/resources/images/600bca/460.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 460",
        "no": 460,
        "content": "Biển báo dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ dẫn khoảng cách đến làn đường cứu nạn (làn thoát xe khẩn cấp)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo hiệu đường cụt phía trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu nút giao gần nhất phía trước."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu trạm dừng nghỉ phía trước."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "được phép, thực tế thông thường sẽ có bảng phần làn hướng rẻ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/461.PNG", "/resources/images/600bca/461.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 461",
        "no": 461,
        "content": "Tại đoạn đường có biển \"Làn đường dành riêng cho từng loại xe\" dưới đây, các phương tiện có được phép chuyển sang làn khác để đi theo hành trình mong muốn khi đến gần nơi đường bộ giao nhau hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép chuyển sang làn khác."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không được phép chuyển sang làn khác, chỉ được đi trong làn quy định theo biển."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "hình đầu ô tô là tất cả các loại ô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/462.PNG", "/resources/images/600bca/462.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 462",
        "no": 462,
        "content": "Tại đoạn đường có cắm biển dưới đây, xe tải và xe khách có được phép đi vào không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "hình thân ô tô là ô tô con"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/463.PNG", "/resources/images/600bca/463.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 463",
        "no": 463,
        "content": "Tại đoạn đường có cắm biển dưới đây, xe tải và xe khách có được phép đi vào không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Có."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển 1: Hết đoạn đường ưu tiên",
            "Biển 2: kết thúc cao tốc",
            "Biển 3: hết đường dành riêng cho ô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/464.PNG", "/resources/images/600bca/464.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 464",
        "no": 464,
        "content": "Biển nào báo hiệu kết thúc đường cao tốc?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/465.PNG", "/resources/images/600bca/465.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 465",
        "no": 465,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ dẫn sắp đến vị trí nhập làn xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ dẫn vị trí nhập làn xe cách 250 m."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ dẫn vị trí nhập làn cách trạm thu phí 250 m."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/466.PNG", "/resources/images/600bca/466.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 466",
        "no": 466,
        "content": "Biển nào chỉ dẫn nhập làn xe?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai biển."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/467.PNG", "/resources/images/600bca/467.PNG"],
        "shuffle": false,
        "chapter": 5,
        "tittle": "Câu 467",
        "no": 467,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Bắt đầu đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Chỉ dẫn địa giới đường cao tốc, chiều dài đường cao tốc."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Tên và ký hiệu đường cao tốc, giá trị hạn chế tốc độ tối đa và tối thiểu."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'thông tin'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/468.PNG", "/resources/images/600bca/468.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 468",
        "no": 468,
        "content": "Ý nghĩa các biểu tượng ghi trên biển chỉ dẫn là như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xăng dầu, ăn uống, thông tin, sửa chữa xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xăng dầu, ăn uống, nhà nghỉ, sửa chữa xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xăng dầu, ăn uống, cấp cứu, sửa chữa xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "KTTT = Kiểm tra tải trọng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/469.PNG", "/resources/images/600bca/469.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 469",
        "no": 469,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ dẫn đến trạm kiểm tra tải trọng xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ dẫn hướng rẽ vào nơi đặt trạm kiểm tra tải trọng xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ dẫn khoảng cách đến trạm kiểm tra tải trọng xe cách 750 m."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/470.PNG", "/resources/images/600bca/470.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 470",
        "no": 470,
        "content": "Trên đường cao tốc, gặp biển nào thì người lái xe đi theo hướng bên trái để tránh chướng ngại vật?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/471.PNG", "/resources/images/600bca/471.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 471",
        "no": 471,
        "content": "Trên đường cao tốc, gặp biển nào thì người lái xe đi theo hướng bên phải để tránh chướng ngại vật?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/472.PNG", "/resources/images/600bca/472.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 472",
        "no": 472,
        "content": "Trên đường cao tốc, gặp biển nào thì người lái xe đi được cả hai hướng (bên trái hoặc bên phải) để tránh chướng ngại vật?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1,3: chỉ dẫn hướng rẽ",
            "Biển 2: tránh chướng ngại vật về 2 bên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/473.PNG", "/resources/images/600bca/473.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 473",
        "no": 473,
        "content": "Trên đường cao tốc, gặp biển nào người lái xe phải chú ý đổi hướng đi khi sắp vào đường cong nguy hiểm?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1 và biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 1 và biển 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển 1: phải đi về bên phải",
            "Biển 2: đường đi cả 2 bên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/474.PNG", "/resources/images/600bca/474.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 474",
        "no": 474,
        "content": "Biển nào chỉ dẫn người lái xe đi được cả hai hướng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Biển 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Biển 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "biển này ko phải chỉ vượt qua chướng ngại vật"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/475.PNG", "/resources/images/600bca/475.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 475",
        "no": 475,
        "content": "Biển này có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ dẫn chướng ngại vật phía trước để cảnh báo phía trước có sự cản trở lưu thông bình thường (nằm bên trong phần xe chạy hay ngay sát phần đường xe chạy) và chỉ dẫn hướng đi qua đó cần đặt biển."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ dẫn hướng rẽ để nhắc người điều khiển phương tiện chuẩn bị đổi hướng đi khi sắp vào đường cong nguy hiểm, có bán kính cong nhỏ."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/476.PNG", "/resources/images/600bca/476.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 476",
        "no": 476,
        "content": "Vạch mũi tên chỉ hướng trên mặt đường nào dưới đây cho phép xe chỉ được đi thẳng và rẽ phải?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vạch 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 2 và vạch 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vạch 1 và vạch 2."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "trắng -> cùng chiều",
            "vàng -> ngược chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/477.PNG", "/resources/images/600bca/477.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 477",
        "no": 477,
        "content": "Vạch kẻ đường nào dưới đây là vạch phân chia các làn xe cùng chiều?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vạch 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 1 và vạch 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "vàng -> 2 chiều",
            "nét liền -> ko được cán"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/478.PNG", "/resources/images/600bca/478.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 478",
        "no": 478,
        "content": "Vạch kẻ đường nào dưới đây là vạch phân chia hai chiều xe chạy (vạch tim đường), xe không được lấn làn, không được đè lên vạch?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vạch 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vạch 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba vạch."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "vàng -> 2 chiều",
            "nét liền -> ko được cán",
            "nét đứt -> được cán trong đk an toàn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/479.PNG", "/resources/images/600bca/479.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 479",
        "no": 479,
        "content": "Vạch kẻ đường nào dưới đây là vạch phân chia hai chiều xe chạy (vạch tim đường)?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vạch 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 1 và vạch 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "vàng -> 2 chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/480.PNG", "/resources/images/600bca/480.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 480",
        "no": 480,
        "content": "Các vạch dưới đây có tác dụng như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phân chia hai chiều xe chạy ngược chiều nhau."
                ],
                "answer": true
            },
            {
                "option": [
                    "Phân chia các làn xe chạy cùng chiều nhau."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "trắng -> cùng chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/481.PNG", "/resources/images/600bca/481.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 481",
        "no": 481,
        "content": "Các vạch dưới đây có tác dụng như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phân chia hai chiều xe chạy ngược chiều nhau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phân chia các làn xe chạy cùng chiều nhau."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "nét đứt -> được cán trong đk an toàn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/482.PNG", "/resources/images/600bca/482.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 482",
        "no": 482,
        "content": "Khi gặp vạch kẻ đường nào các xe được phép đè vạch?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vạch 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vạch 1 và vạch 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "mỗi cặp cách nhau 50m"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/483.PNG", "/resources/images/600bca/483.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 483",
        "no": 483,
        "content": "Vạch dưới đây có tác dụng như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Để xác định làn đường."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu người lái xe chỉ được phép đi thẳng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để xác định khoảng cách giữa các phương tiện trên đường."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/484.PNG", "/resources/images/600bca/484.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 484",
        "no": 484,
        "content": "Vạch dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Báo cho người điều khiển không được dừng phương tiện trong phạm vi phần mặt đường có bố trí vạch để tránh ùn tắc giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Báo hiệu sắp đến chỗ có bố trí vạch đi bộ qua đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Dùng để xác định khoảng cách giữa các phương tiện trên đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "thường thấy ở trạm xe buýt á"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/485.PNG", "/resources/images/600bca/485.PNG"],
        "shuffle": true,
        "chapter": 5,
        "tittle": "Câu 485",
        "no": 485,
        "content": "Vạch dưới đây có ý nghĩa như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vị trí dừng xe của các phương tiện vận tải hành khách công cộng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Báo cho người điều khiển được dừng phương tiện trong phạm vi phần mặt đường có bố trí vạch để tránh ùn tắc giao thông."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dùng để xác định vị trí giữa các phương tiện trên đường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe khách sai vì đi thẳng ở làn rẻ trái",
            "Xe tải (góc dưới trái) sai vi rẻ trái ở làn đi thẳng và đèn đang đỏ",
            "Xe con đúng vì rẻ phải ở làn rẻ phải và đèn đang xanh",
            "Xe mô tô sai vì rẻ phải ở làn rẻ trái",
            "Xe tải (góc trên phải) sai vì rẻ trái ở làn rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/486.PNG", "/resources/images/600bca/486.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 486",
        "no": 486,
        "content": "Theo hướng mũi tên, xe nào chấp hành đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ xe con."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "Xe tải và mô tô đang ở đường ưu tiên",
            "Xe tải đi thẳng nên ưu tiên hơn mô tô rẻ trái",
            "Xe khách đi thẳng nên ưu tiên hơn xe con rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/487.PNG", "/resources/images/600bca/487.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 487",
        "no": 487,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe khách, xe con, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe mô tô, xe khách, xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe khách, xe tải, xe con, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe khách, xe tải, xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "Xe công an là xe ưu tiên",
            "Xe con đang ở đường ưu tiên",
            "Xe tải đi thẳng nên ưu tiên hơn xe khách rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/488.PNG", "/resources/images/600bca/488.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 488",
        "no": 488,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe con, xe tải, xe khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe khách, xe con, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe tải, xe khách, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe công an đi làm nhiệm vụ khẩn cấp, xe tải, xe khách."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "Xe công an là xe ưu tiên",
            "Xe tải đang ở đường ưu tiên",
            "Xe khách ko bị cản trở bên phải nên được ưu tiên hơn xe con"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/489.PNG", "/resources/images/600bca/489.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 489",
        "no": 489,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe công an đi làm nhiệm vụ khẩn cấp, xe khách, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe khách, xe con, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe con, xe tải, xe khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe tải, xe khách, xe con."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "Xe mô tô bên phải trống",
            "Xe con bên phải trống sau khi mô tô đã đi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/490.PNG", "/resources/images/600bca/490.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 490",
        "no": 490,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe con, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe con, xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con, xe mô tô, xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Ở vòng xuyến, ưu tiên xe bên trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/491.PNG", "/resources/images/600bca/491.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 491",
        "no": 491,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe moto phải dừng lại trước biển STOP để quan sát"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/492.PNG", "/resources/images/600bca/492.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 492",
        "no": 492,
        "content": "Trường hợp này xe nào được quyền đi trước?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "A đã vào giao lộ",
            "Xe cứu thương ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/493.PNG", "/resources/images/600bca/493.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 493",
        "no": 493,
        "content": "Thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (A), xe cứu thương đi làm nhiệm vụ cấp cứu, xe con (B)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe cứu thương đi làm nhiệm vụ cấp cứu, xe con (B), xe con (A)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (B), xe con (A), xe cứu thương đi làm nhiệm vụ cấp cứu."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Hỏa - Sự - Công - Thương - Hộ đê - Tang"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/494.PNG", "/resources/images/600bca/494.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 494",
        "no": 494,
        "content": "Thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe cứu thương đi làm nhiệm vụ cấp cứu, xe chữa cháy đi làm nhiệm vụ chữa cháy, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe chữa cháy đi làm nhiệm vụ chữa cháy, xe cứu thương đi làm nhiệm vụ cấp cứu, xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe cứu thương đi làm nhiệm vụ cấp cứu, xe con, xe chữa cháy đi làm nhiệm vụ chữa cháy."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Hỏa - Sự - Công - Thương - Hộ đê - Tang"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/495.PNG", "/resources/images/600bca/495.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 495",
        "no": 495,
        "content": "Xe nào được quyền đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe cứu thương đi làm nhiệm vụ cấp cứu."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe con trên đường ưu tiên",
            "xe tải rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/496.PNG", "/resources/images/600bca/496.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 496",
        "no": 496,
        "content": "Theo hướng mũi tên, xe nào phải nhường đường đi cuối cùng qua nơi giao nhau này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "- Cả 2 xe đều gặp biển W208 (Giao nhau với đường ưu tiên) nên cả 2 đều đang ở trên đường KHÔNG ưu tiên.",
            "- Biển phụ (S506b dưới biển W208): chỉ để chỉ rõ đường ưu tiên là đường nào.",
            "- Như vậy, dựa vào biển, ko xác định được xe nào ưu tiên hơn.",
            "- Xét phía bên phải xe nào không bị cản trở sẽ được ưu tiên hơn -> xe tải ưu tiên hơn",
            "- Kết luận: xe con phải nhường đường."

        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/497.PNG", "/resources/images/600bca/497.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 497",
        "no": 497,
        "content": "Theo hướng mũi tên, xe nào phải nhường đường là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Hỏa - Sự - Công - Thương - Hộ đê - Tang"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/498.PNG", "/resources/images/600bca/498.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 498",
        "no": 498,
        "content": "Xe nào được quyền đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe chữa cháy đi làm nhiệm vụ chữa cháy."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xanh được đi, đỏ dừng chờ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/499.PNG", "/resources/images/600bca/499.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 499",
        "no": 499,
        "content": "Theo tín hiệu đèn, xe nào được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con và xe khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xanh được đi, đỏ dừng chờ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/500.PNG", "/resources/images/600bca/500.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 500",
        "no": 500,
        "content": "Theo tín hiệu đèn, xe nào đi là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải, xe mô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Hỏa - Sự - Công - Thương - Hộ đê - Tang"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/501.PNG", "/resources/images/600bca/501.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 501",
        "no": 501,
        "content": "Trong trường hợp này xe nào được quyền đi trước?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe quân sự đi làm nhiệm vụ khẩn cấp."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Chỉ có đèn rẻ trái xanh, nên chỉ có hướng 1",
            "Hướng 2: ngược chiều hoặc được xem là đi thẳng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/502.PNG", "/resources/images/600bca/502.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 502",
        "no": 502,
        "content": "Theo tín hiệu đèn, xe tải đi theo hướng nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 2, 3, 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ hướng 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 1 và 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 3 và 4."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe con đúng",
            "Xe khách sai vì đi thẳng ở làn rẻ trái",
            "Xe tải (dưới trái) sai vì đèn đỏ và rẻ trái ở làn đi thẳng",
            "Xe tải (trên phải) sai vì rẻ trái ở làn rẻ phải",
            "Xe mô tô sai vì rẻ phải ở làn rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/503.PNG", "/resources/images/600bca/503.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 503",
        "no": 503,
        "content": "Các xe đi theo hướng mũi tên, những xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe tải, xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải, xe con, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách, xe con, xe mô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Chưa vào vòng xuyến thì nhường trống bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/504.PNG", "/resources/images/600bca/504.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 504",
        "no": 504,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe tải, xe mô tô, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe khách, xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe tải, xe khách, xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô, xe tải, xe con, xe khách."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển cấm đổ cho xe tải trở lên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/505.PNG", "/resources/images/600bca/505.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 505",
        "no": 505,
        "content": "Trong trường hợp này xe nào đỗ vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con và mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con và xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "B đang ở đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/506.PNG", "/resources/images/600bca/506.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 506",
        "no": 506,
        "content": "Theo hướng mũi tên, xe nào được quyền đi trước?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (B)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con (A)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biến cấm ô tô --> xe gắn máy được đi",
            "Biến cấm mô tô --> xe gắn máy được đi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/507.PNG", "/resources/images/600bca/507.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 507",
        "no": 507,
        "content": "Theo hướng mũi tên, những hướng nào xe gắn máy được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả ba hướng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ hướng 1 và 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ hướng 1."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển phụ cho thấy cấm dừng đổ cả trước và sau biển"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/508.PNG", "/resources/images/600bca/508.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 508",
        "no": 508,
        "content": "Xe nào đỗ vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả hai xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không xe nào vi phạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ xe mô tô vi phạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ xe tải vi phạm."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe con và mô tô đỗ đè vạch -> sai",
            "Xe tải đỗ ngược chiều -> sai"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/509.PNG", "/resources/images/600bca/509.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 509",
        "no": 509,
        "content": "Xe nào đỗ vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả ba xe."
                ],
                "answer": true
            },
            {
                "option": [
                    "Chỉ xe mô tô và xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Có biển cấm xe kéo rờ móc"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/510.PNG", "/resources/images/600bca/510.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 510",
        "no": 510,
        "content": "Xe tải kéo xe mô tô ba bánh như hình này có đúng quy tắc giao thông không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đúng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không đúng."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "hướng 1 có biển cấm ô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/511.PNG", "/resources/images/600bca/511.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 511",
        "no": 511,
        "content": "Theo hướng mũi tên, hướng nào xe không được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 2 và 5."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ hướng 1."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "có biển cấm rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/512.PNG", "/resources/images/600bca/512.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 512",
        "no": 512,
        "content": "Theo hướng mũi tên, những hướng nào xe ô tô không được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 1 và 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 1 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 2 và 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển cấm xe tải vượt -> xe khách và xe con được vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/513.PNG", "/resources/images/600bca/513.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 513",
        "no": 513,
        "content": "Xe nào vượt đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả hai xe đều đúng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển này bắt đi thẳng hoặc rẻ trái hoặc quay đầu"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/514.PNG", "/resources/images/600bca/514.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 514",
        "no": 514,
        "content": "Theo hướng mũi tên, gặp biển hướng đi phải theo đặt trước ngã tư, những hướng nào xe được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 2 và 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 1, 2 và 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe kéo rơ móc hoặc sơ mi rơ móc đã kéo rơ móc thì ko được kéo xe khác, chỉ được kéo 1"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/515.PNG", "/resources/images/600bca/515.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 515",
        "no": 515,
        "content": "Xe kéo nhau như hình này có vi phạm quy tắc giao thông không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vi phạm."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe khách gặp biển phải nhường đường do đường hẹp",
            "Xe tải gặp biển được ưu tiên ở đường hẹp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/516.PNG", "/resources/images/600bca/516.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 516",
        "no": 516,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "mô tô rẻ phải nên được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/517.PNG", "/resources/images/600bca/517.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 517",
        "no": 517,
        "content": "Xe nào được quyền đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe kéo rơ móc hoặc sơ mi rơ móc đã kéo rơ móc thì ko được kéo xe khác, chỉ được kéo 1"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/518.PNG", "/resources/images/600bca/518.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 518",
        "no": 518,
        "content": "Xe kéo nhau trong trường hợp này đúng quy định không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không đúng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đúng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển hiệu lệnh chỉ có tác dụng cho xe tải",
            "có biển cấm ô tô ở hướng 2"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/519.PNG", "/resources/images/600bca/519.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 519",
        "no": 519,
        "content": "Theo hướng mũi tên, những hướng nào xe ô tô con được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1, 3 và 4."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 2, 3 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả bốn hướng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe đạp và mô tô ko vướng bên phải --> được ưu tiên",
            "xe đạp ưu tiên hơn mô tô vì đi thẳng",
            "sau đó xe A sẽ trống phải nên được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/520.PNG", "/resources/images/600bca/520.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 520",
        "no": 520,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (A), xe mô tô, xe con (B), xe đạp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (B), xe đạp, xe mô tô, xe con (A)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (A), xe con (B), xe mô tô + xe đạp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô + xe đạp, xe con (A), xe con (B)."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "biển hiệu lệnh bắt buộc xe tải rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/521.PNG", "/resources/images/600bca/521.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 521",
        "no": 521,
        "content": "Theo hướng mũi tên, những hướng nào xe tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ hướng 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 1, 3 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1, 2 và 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả bốn hướng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển cấm xe tải rẻ phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/522.PNG", "/resources/images/600bca/522.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 522",
        "no": 522,
        "content": "Những hướng nào xe tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả ba hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 2 và 3."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "biển cấm ô tô nên hướng 2,3,4 tải ko được đi vào"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/523.PNG", "/resources/images/600bca/523.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 523",
        "no": 523,
        "content": "Những hướng nào xe ô tô tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ hướng 1."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 5."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 1, 4 và 5."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ cấm hướng 2 vì có biển"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/524.PNG", "/resources/images/600bca/524.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 524",
        "no": 524,
        "content": "Những hướng nào xe ô tô tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả bốn hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trừ hướng 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 2, 3 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trừ hướng 4."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe mô tô đang ở đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/525.PNG", "/resources/images/600bca/525.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 525",
        "no": 525,
        "content": "Xe nào được quyền đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "biển báo chỉ được đi thẳng ở giao lộ này"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/526.PNG", "/resources/images/600bca/526.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 526",
        "no": 526,
        "content": "Xe ô tô con đi theo chiều mũi tên có vi phạm quy tắc giao thông không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không vi phạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vi phạm."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe con sai vì cán vạch"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/527.PNG", "/resources/images/600bca/527.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 527",
        "no": 527,
        "content": "Xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con và xe mô tô."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "tư thế của CSGT là tất cả các xe ở tất cả các hướng phải dừng lại, từ xe đã vào giao lộ thì được phép đi tiếp"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/528.PNG", "/resources/images/600bca/528.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 528",
        "no": 528,
        "content": "Các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Các xe ở phía tay phải và tay trái của người điều khiển được phép đi thẳng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cho phép các xe ở mọi hướng được phép rẽ phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tất cả các xe phải dừng lại trước ngã tư, trừ những xe đã ở trong ngã tư được phép tiếp tục đi."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "xe ở 2 hướng theo tay trái phải của CSGT thì được đi, xe 2 hướng còn lại phải dừng lại"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/529.PNG", "/resources/images/600bca/529.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 529",
        "no": 529,
        "content": "Theo hướng mũi tên, xe nào được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Đúng vì xe tải đã sát lề trái và đang rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/530.PNG", "/resources/images/600bca/530.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 530",
        "no": 530,
        "content": "Xe con vượt xe tải như trường hợp này có đúng không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đúng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không đúng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Nét như hình thì nét đứt áp dụng chiều xe con, nét liền cho chiều xe tải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/531.PNG", "/resources/images/600bca/531.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 531",
        "no": 531,
        "content": "Xe nào vượt đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai xe."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe tải sai biển, xe cứu hỏa được phép đi ngược chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/532.PNG", "/resources/images/600bca/532.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 532",
        "no": 532,
        "content": "Đi theo hướng mũi tên, xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe chữa cháy đi làm nhiệm vụ chữa cháy."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả hai xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "bên phải cả 3 xe đều có xe khác, nên xét hướng đi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/533.PNG", "/resources/images/600bca/533.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 533",
        "no": 533,
        "content": "Thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe tải, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải, xe khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe khách, xe con."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "bên phải cả 3 xe đều có xe khác, nên xét hướng đi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/534.PNG", "/resources/images/600bca/534.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 534",
        "no": 534,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách và xe tải, xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải, xe khách, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe khách, xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "hướng 4 là ngược chiều nên cấm"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/535.PNG", "/resources/images/600bca/535.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 535",
        "no": 535,
        "content": "Những hướng nào xe ô tô tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả bốn hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Chỉ hướng 1 và 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Trừ hướng 4."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/536.PNG", "/resources/images/600bca/536.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 536",
        "no": 536,
        "content": "Theo hướng mũi tên, thứ tự các xe đi như thế nào là đúng?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe con, xe tải, xe khách."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con, xe khách và xe công an đi làm nhiệm vụ khẩn cấp, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe con, xe khách, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải, xe khách, xe công an đi làm nhiệm vụ khẩn cấp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ cấm rẻ trái (hướng 2)",
            "biển cấm xe kéo -> ko cấm xe tải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/537.PNG", "/resources/images/600bca/537.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 537",
        "no": 537,
        "content": "Những hướng nào ô tô tải được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả bốn hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1, 2 và 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 4."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1, 3 và 4."
                ],
                "answer": true
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/538.PNG", "/resources/images/600bca/538.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 538",
        "no": 538,
        "content": "Trong hình dưới đây, xe nào chấp hành đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ xe khách, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tất cả các loại xe trên."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không xe nào chấp hành đúng quy tắc giao thông."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "hướng 2 có biển cấm mô tô"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/539.PNG", "/resources/images/600bca/539.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 539",
        "no": 539,
        "content": "Theo hướng mũi tên, những hướng nào xe mô tô được phép đi?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cả ba hướng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 3."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 2 và 3."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái",
            "Hỏa - Sự - Công - Thương - Hộ đê - Tang"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/540.PNG", "/resources/images/600bca/540.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 540",
        "no": 540,
        "content": "Trong trường hợp này, thứ tự xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe công an đi làm nhiệm vụ khẩn cấp, xe quân sự đi làm nhiệm vụ khẩn cấp, xe con + xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe quân sự đi làm nhiệm vụ khẩn cấp, xe công an đi làm nhiệm vụ khẩn cấp, xe con + xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô + xe con, xe quân sự đi làm nhiệm vụ khẩn cấp, xe công an đi làm nhiệm vụ khẩn cấp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "ưu tiên cho xe lên dốc",
            "gần chỗ tránh hơn thì tránh trước",
            "chiều không bị hẹp được ưu tiên hơn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/541.PNG", "/resources/images/600bca/541.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 541",
        "no": 541,
        "content": "Xe nào phải nhường đường là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe A."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe B."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "vi phạm do cán vạch đi bộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/542.PNG", "/resources/images/600bca/542.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 542",
        "no": 542,
        "content": "Xe con quay đầu đi ngược lại như hình vẽ dưới có vi phạm quy tắc giao thông không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Không vi phạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vi phạm."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "C và E đi sai làn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/543.PNG", "/resources/images/600bca/543.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 543",
        "no": 543,
        "content": "Trong hình dưới, những xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (E), xe mô tô (C)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải (A), xe mô tô (D)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách (B), xe mô tô (C)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách (B), xe mô tô (D)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Nhường đường vì xe rẻ trái đã trong giao lộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/544.PNG", "/resources/images/600bca/544.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 544",
        "no": 544,
        "content": "Để điều khiển cho xe đi thẳng, người lái xe phải làm gì là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhường xe con rẽ trái trước."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi thẳng không nhường."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Cấm rẻ phải: hướng 4",
            "Cấm đi ngược chiều: hướng 3"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/545.PNG", "/resources/images/600bca/545.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 545",
        "no": 545,
        "content": "Người lái xe điều khiển xe đi theo hướng nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chỉ hướng 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Hướng 1 và 2."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tất cả các hướng trừ hướng 3."
                ],
                "answer": false
            },
            {
                "option": [
                    "Tất cả các hướng trừ hướng 4."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "A đang đi trước nên được ưu tiên -> B phải nhường"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/546.PNG", "/resources/images/600bca/546.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 546",
        "no": 546,
        "content": "Xe nào phải nhường đường là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (A)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (B)."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe tải được đi trước tiên, kế là xe khách -> cần nhường đường"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/547.PNG", "/resources/images/600bca/547.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 547",
        "no": 547,
        "content": "Người lái xe điều khiển xe rẽ trái như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Rẽ trái ngay trước xe buýt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rẽ trái trước xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe buýt và xe tải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "E và D sai làn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/548.PNG", "/resources/images/600bca/548.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 548",
        "no": 548,
        "content": "Trong hình dưới, những xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (B), xe mô tô (C)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (A), xe mô tô (C)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (E), xe mô tô (D)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tất cả các loại xe trên."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe tải ở đường ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/549.PNG", "/resources/images/600bca/549.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 549",
        "no": 549,
        "content": "Xe nào đi trước là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "B cán vạch nên sai"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/550.PNG", "/resources/images/600bca/550.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 550",
        "no": 550,
        "content": "Người lái xe có thể quay đầu xe như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quay đầu theo hướng A."
                ],
                "answer": true
            },
            {
                "option": [
                    "Quay đầu theo hướng B."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cấm quay đầu."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "xe mình đang trên đường ưu tiên nên đi trước",
            "xe con rẻ phải nên đi cùng hoặc đi thứ 2"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/551.PNG", "/resources/images/600bca/551.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 551",
        "no": 551,
        "content": "Thứ tự các xe đi như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con và xe tải, xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn, xe tải, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn và xe con, xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe của bạn, xe tải + xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'khi đủ điều kiện an toàn'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/552.PNG", "/resources/images/600bca/552.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 552",
        "no": 552,
        "content": "Khi muốn vượt xe tải, người lái xe phải làm gì là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc cho xe chạy vượt qua."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bật tín hiệu báo hiệu bằng đèn hoặc còi, khi đủ điều kiện an toàn, tăng tốc cho xe chạy vượt qua."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đánh lái sang làn bên trái và tăng tốc cho xe chạy vượt qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đèn đỏ thì dừng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/553.PNG", "/resources/images/600bca/553.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 553",
        "no": 553,
        "content": "Theo tín hiệu đèn, xe nào phải dừng lại là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "B và D cán vạch -> vi phạm"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/554.PNG", "/resources/images/600bca/554.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 554",
        "no": 554,
        "content": "Trong hình dưới, những xe nào chấp hành quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải ( D), xe con (B)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con (A), xe con (C), xe con (E), xe buýt (G)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con (A), xe con (B), xe tải (D)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "nét liền + ngay sau đó là giao lộ có vạch cho người đi bộ -> cấm vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/555.PNG", "/resources/images/600bca/555.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 555",
        "no": 555,
        "content": "Người lái xe có được phép vượt xe tải để đi thẳng trong trường hợp này không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cấm vượt."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "nét liền + ngay sau đó là giao lộ có vạch cho người đi bộ -> cấm vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/556.PNG", "/resources/images/600bca/556.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 556",
        "no": 556,
        "content": "Bạn có được phép vượt xe mô tô phía trước không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Cho phép."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được vượt."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Biển cấm đổ, ko cấm dừng",
            "A sai vì ngược chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/557.PNG", "/resources/images/600bca/557.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 557",
        "no": 557,
        "content": "Người lái xe dừng tại vị trí nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vị trí A và B."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vị trí A và C."
                ],
                "answer": false
            },
            {
                "option": [
                    "Vị trí B và C."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cả ba vị trí A, B, C."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Biển cấm dừng đỗ trước và sau biển"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/558.PNG", "/resources/images/600bca/558.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 558",
        "no": 558,
        "content": "Bạn được dừng xe ở vị trí nào trong tình huống này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được phép dừng ở vị trí A."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép dừng ở vị trí B."
                ],
                "answer": false
            },
            {
                "option": [
                    "Được phép dừng ở vị trí A và B."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được dừng."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "có biển buộc đi thẳng --> 2 xe đều sai"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/559.PNG", "/resources/images/600bca/559.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 559",
        "no": 559,
        "content": "Theo tín hiệu đèn của xe cơ giới, xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe ô tô con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không xe nào vi phạm."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai xe."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe tải sai làn rẽ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/560.PNG", "/resources/images/600bca/560.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 560",
        "no": 560,
        "content": "Các xe đi theo hướng mũi tên, xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con, xe tải."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe khách sai vì sai làn rẻ trái mà đi thẳng",
            "Xe tải sai vì đèn đỏ và rẻ trái ở làn đi thẳng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/561.PNG", "/resources/images/600bca/561.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 561",
        "no": 561,
        "content": "Các xe đi theo hướng mũi tên, những xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách, xe tải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "chỉ có xe con đúng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/562.PNG", "/resources/images/600bca/562.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 562",
        "no": 562,
        "content": "Các xe đi theo hướng mũi tên, xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con, xe tải, xe khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe khách, xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe khách, xe mô tô, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả bốn xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "chỉ có xe con đúng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/563.PNG", "/resources/images/600bca/563.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 563",
        "no": 563,
        "content": "Các xe đi theo hướng mũi tên, xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe khách, xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe khách, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách, xe tải, xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'khi đủ điều kiện an toàn'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/564.PNG", "/resources/images/600bca/564.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 564",
        "no": 564,
        "content": "Trong tình huống dưới đây, để tránh xe phía trước bị hỏng đột xuất trên đường, người lái xe phải làm gì?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đánh lái sang trái cho xe vượt qua."
                ],
                "answer": false
            },
            {
                "option": [
                    "Quan sát phía trước, phía sau, khi đủ điều kiện an toàn, bật tín hiệu bằng đèn hoặc còi rồi cho xe chạy vượt qua."
                ],
                "answer": true
            },
            {
                "option": [
                    "Cấm vượt."
                ],
                "answer": false
            }
        ]
    },
    {
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/565.PNG", "/resources/images/600bca/565.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 565",
        "no": 565,
        "content": "Các xe đi theo hướng mũi tên, xe nào chấp hành đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe khách, xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "B và D cán vạch"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/566.PNG", "/resources/images/600bca/566.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 566",
        "no": 566,
        "content": "Trong hình dưới, những xe nào vi phạm quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con (A), xe con (B), xe tải (D)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải (D), xe con (E), xe buýt (G)."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải ( D), xe con (B)."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con (B), xe con (C)."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe mô tô đang đường ưu tiên",
            "sau đó, xe con ko vướng bên phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/567.PNG", "/resources/images/600bca/567.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 567",
        "no": 567,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn, xe mô tô, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe của bạn, xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe con, xe của bạn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/568.PNG", "/resources/images/600bca/568.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 568",
        "no": 568,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn, xe mô tô, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe của bạn, xe mô tô."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô, xe con, xe của bạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xe con đã qua chỗ rẻ phải -> phải dừng",
            "xe mình: đèn sau chỗ rẻ phải -> ko cần dừng đèn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/569.PNG", "/resources/images/600bca/569.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 569",
        "no": 569,
        "content": "Xe nào phải dừng lại trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai xe."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đi theo chỉ dẫn trên mặt đường"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/570.PNG", "/resources/images/600bca/570.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 570",
        "no": 570,
        "content": "Xe của bạn được đi theo hướng nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đi thẳng, rẽ trái."
                ],
                "answer": true
            },
            {
                "option": [
                    "Đi thẳng, rẽ phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Rẽ trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Đi thẳng, rẽ phải, rẽ trái."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "dừng chờ đèn xanh rồi rẻ trái hoặc đi  thẳng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/571.PNG", "/resources/images/600bca/571.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 571",
        "no": 571,
        "content": "Xe của bạn được đi theo hướng nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chuyển sang làn đường bên phải và rẽ phải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại trước vạch dừng và rẽ phải khi đèn xanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại trước vạch dừng và đi thẳng hoặc rẽ trái khi đèn xanh."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "xe tải và xe đạp đang được ưu tiên hơn -> mình phải giảm tốc độ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/572.PNG", "/resources/images/600bca/572.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 572",
        "no": 572,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ, rẽ phải trước xe tải và xe đạp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, rẽ phải sau xe tải và xe đạp."
                ],
                "answer": true
            },
            {
                "option": [
                    "Tăng tốc độ, rẽ phải trước xe đạp."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "nhường đường cho người đi bộ"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/573.PNG", "/resources/images/600bca/573.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 573",
        "no": 573,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ, rẽ phải trước xe con màu xanh phía trước và người đi bộ."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, để người đi bộ qua đường và rẽ phải trước xe con màu xanh."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, để người đi bộ qua đường và rẽ phải sau xe con màu xanh."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "có biển STOP, mình phải dừng nên nhường tất cả"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/574.PNG", "/resources/images/600bca/574.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 574",
        "no": 574,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Nhường đường cho xe khách và đi trước xe đạp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe đạp và đi trước xe khách."
                ],
                "answer": false
            },
            {
                "option": [
                    "Nhường đường cho xe đạp và xe khách."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe tải đang đường ko ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/575.PNG", "/resources/images/600bca/575.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 575",
        "no": 575,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "đường hẹp phía bên mình nên mình phải nhường"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/576.PNG", "/resources/images/600bca/576.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 576",
        "no": 576,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe đi ngược chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'đoàn người đi xe đạp có tổ chức' -> ko được vượt"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/577.PNG", "/resources/images/600bca/577.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 577",
        "no": 577,
        "content": "Bạn xử lý như thế nào khi lái xe ô tô vượt qua đoàn người đi xe đạp có tổ chức?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ, chuyển sang làn đường bên trái để vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được vượt những người đi xe đạp."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Tăng tốc độ' -> bậy liền"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/578.PNG", "/resources/images/600bca/578.PNG"],
        "shuffle": false,
        "chapter": 6,
        "tittle": "Câu 578",
        "no": 578,
        "content": "Phía trước có một xe đang lùi vào nơi đỗ, xe con phía trước đang chuyển sang làn đường bên trái, bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "1. Nếu phía sau không có xe xin vượt, chuyển sang làn đường bên trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "2. Nếu phía sau có xe xin vượt, thì giảm tốc độ, ở lại làn đường, dừng lại khi cần thiết."
                ],
                "answer": false
            },
            {
                "option": [
                    "3. Tăng tốc độ trên làn đường của mình và vượt xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Ý 1 và ý 2."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "'Giảm tốc độ'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/579.PNG", "/resources/images/600bca/579.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 579",
        "no": 579,
        "content": "Bạn xử lý như thế nào khi xe phía trước đang lùi ra khỏi nơi đỗ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Chuyển sang nửa đường bên trái để đi tiếp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Bấm còi, nháy đèn báo hiệu và đi tiếp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, dừng lại nhường đường."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "nhường nó thôi"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/580.PNG", "/resources/images/600bca/580.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 580",
        "no": 580,
        "content": "Phía trước có một xe màu xanh đang vượt xe màu vàng trên làn đường của bạn, bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Phanh xe giảm tốc độ và đi sát lề đường bên phải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bấm còi, nháy đèn báo hiệu, giữ nguyên tốc độ và đi tiếp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phanh xe giảm tốc độ và đi sát vào lề đường bên trái."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'giảm tốc độ'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/581.PNG", "/resources/images/600bca/581.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 581",
        "no": 581,
        "content": "Xe tải phía trước có tín hiệu xin chuyển làn đường, bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bật tín hiệu xin chuyển làn đường sang trái để vượt xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Phanh xe giảm tốc độ chờ xe tải phía trước chuyển làn đường."
                ],
                "answer": true
            },
            {
                "option": [
                    "Bấm còi báo hiệu và vượt qua xe tải trên làn đường của mình."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Giảm tốc độ'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/582.PNG", "/resources/images/600bca/582.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 582",
        "no": 582,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ và đi thẳng qua ngã tư."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng xe trước vạch dừng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ và đi thẳng qua ngã tư."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/583.PNG", "/resources/images/600bca/583.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 583",
        "no": 583,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn, xe mô tô, xe đạp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe mô tô, xe đạp, xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe đạp, xe mô tô, xe của bạn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/584.PNG", "/resources/images/600bca/584.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 584",
        "no": 584,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn, xe tải, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe con, xe tải, xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe của bạn, xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn, xe con, xe tải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xe mình đang trên đường ko ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/585.PNG", "/resources/images/600bca/585.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 585",
        "no": 585,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "có biển nhường đường cho xe ngược chiều"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/586.PNG", "/resources/images/600bca/586.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 586",
        "no": 586,
        "content": "Xe nào phải nhường đường trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "nhường cho người đi bộ qua trước"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/587.PNG", "/resources/images/600bca/587.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 587",
        "no": 587,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ, đi qua vạch người đi bộ sang đường, để người đi bộ sang đường sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, đi qua vạch người đi bộ sang đường, để người đi bộ sang đường sau."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ, để người đi bộ sang đường trước, sau đó cho xe đi qua vạch người đi bộ sang đường."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "xe mình đang trên được ưu tiên"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/588.PNG", "/resources/images/600bca/588.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 588",
        "no": 588,
        "content": "Xe nào được đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/589.PNG", "/resources/images/600bca/589.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 589",
        "no": 589,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con, xe tải, xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe tải, xe con, xe của bạn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe tải, xe của bạn, xe con."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "giảm + phải"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/590.PNG", "/resources/images/600bca/590.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 590",
        "no": 590,
        "content": "Bạn xử lý như thế nào trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Tăng tốc độ cho xe lấn sang phần đường bên trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ cho xe lấn sang phần đường bên trái."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ cho xe đi sát phần đường bên phải."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/591.PNG", "/resources/images/600bca/591.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 591",
        "no": 591,
        "content": "Xe nào được đi trước trong trường hợp này?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe của bạn."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "phải dừng trước vạch trắng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/592.PNG", "/resources/images/600bca/592.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 592",
        "no": 592,
        "content": "Xe nào dừng đúng theo quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe con."
                ],
                "answer": true
            },
            {
                "option": [
                    "Xe mô tô."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả 2 xe đều đúng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "Xét: xe ưu tiên, đường ưu tiên, bên phải trống, rẻ phải, đi thẳng, rẻ trái"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/593.PNG", "/resources/images/600bca/593.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 593",
        "no": 593,
        "content": "Các xe đi theo thứ tự nào là đúng quy tắc giao thông đường bộ?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Xe tải, xe đạp, xe của bạn."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn, xe đạp, xe tải."
                ],
                "answer": false
            },
            {
                "option": [
                    "Xe của bạn, xe tải, xe đạp."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "ko được lấn làn"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/594.PNG", "/resources/images/600bca/594.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 594",
        "no": 594,
        "content": "Để điều khiển xe rẽ trái, bạn chọn hướng đi nào dưới đây?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Hướng 1."
                ],
                "answer": true
            },
            {
                "option": [
                    "Hướng 2."
                ],
                "answer": false
            },
            {
                "option": [
                    "Cả hai hướng đều được."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'giảm tốc độ'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/595.PNG", "/resources/images/600bca/595.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 595",
        "no": 595,
        "content": "Khi gặp xe ngược chiều bật đèn pha trong tình huống dưới dây, bạn xử lý như thế nào?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Bật đèn chiếu xa, tăng tốc độ vượt xe cùng chiều."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giữ nguyên đèn chiếu gần, giảm tốc độ, đi sau xe phía trước."
                ],
                "answer": true
            },
            {
                "option": [
                    "Giữ nguyên đèn chiếu gần, tăng tốc độ vượt xe cùng chiều."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'an toàn'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/596.PNG", "/resources/images/600bca/596.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 596",
        "no": 596,
        "content": "Xe của bạn đang di chuyển gần đến khu vực giao cắt với đường sắt, khi rào chắn đang dịch chuyển, bạn điều khiển xe như thế nào là đúng quy tắc giao thông?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Quan sát nếu thấy không có tàu thì tăng tốc cho xe vượt qua đường sắt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Dừng lại trước rào chắn một khoảng cách an toàn."
                ],
                "answer": true
            },
            {
                "option": [
                    "Ra tín hiệu, yêu cầu người gác chắn tàu kéo chậm barie để xe bạn qua."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "sai vì cán vạch"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/597.PNG", "/resources/images/600bca/597.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 597",
        "no": 597,
        "content": "Trong tình huống dưới đây, xe con màu đỏ nhập làn đường cao tốc theo hướng mũi tên là đúng hay sai?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đúng."
                ],
                "answer": false
            },
            {
                "option": [
                    "Sai."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "không vì xe xanh đang vượt, ko được vượt chung"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/598.PNG", "/resources/images/600bca/598.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 598",
        "no": 598,
        "content": "Trong tình huống dưới đây, xe con màu đỏ có được phép vượt khi xe con màu xanh đang vượt xe tải hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Được vượt."
                ],
                "answer": false
            },
            {
                "option": [
                    "Không được vượt."
                ],
                "answer": true
            }
        ]
    },
    {
        "notes": [
            "đúng, vạch đứt dành cho chiều bên xe vàng"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/599.PNG", "/resources/images/600bca/599.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 599",
        "no": 599,
        "content": "Trong tình huống dưới đây, xe con màu vàng vượt xe con màu đỏ là đúng quy tắc giao thông hay không?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Đúng."
                ],
                "answer": true
            },
            {
                "option": [
                    "Không đúng."
                ],
                "answer": false
            }
        ]
    },
    {
        "notes": [
            "'Giảm tốc độ'"
        ],
        "type": "multiple-choices",
        "images": ["https://raw.githubusercontent.com/lhvan0106-public/600bca/refs/heads/main/600.PNG", "/resources/images/600bca/600.PNG"],
        "shuffle": true,
        "chapter": 6,
        "tittle": "Câu 600",
        "no": 600,
        "content": "Trong tình huống dưới đây, xe đầu kéo kéo rơ moóc (xe container) đang rẽ phải, xe con màu xanh và xe máy phía sau xe container đi như thế nào để bảo đảm an toàn?",
        "isImportant": false,
        "options": [
            {
                "option": [
                    "Vượt về phía bên phải để đi tiếp."
                ],
                "answer": false
            },
            {
                "option": [
                    "Giảm tốc độ chờ xe container rẽ xong rồi tiếp tục đi."
                ],
                "answer": true
            },
            {
                "option": [
                    "Vượt về phía bên trái để đi tiếp."
                ],
                "answer": false
            }
        ]
    }
]